// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.add-box-shadow {
  box-shadow: 2px 2px 5px #000;
}

.btn-close-modal {
  background-color: #ffffff;
  -webkit-background-clip: border-box;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
  box-shadow: 0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1), 0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06);
  overflow: visible;
  padding: 1rem;
}
.btn-close-modal > div {
  margin-top: 0;
}

.data-view-container {
  display: block;
}
.data-view-container .MuiBox-root .css-17mkaxz {
  max-width: -webkit-fit-content;
  max-width: fit-content;
}
.data-view-container > div {
  width: 100%;
}
.data-view-container .data-accordion {
  border-radius: 0.75rem;
  margin-bottom: 5px;
}
.data-view-container .data-accordion:before {
  display: none;
}
.data-view-container .data-accordion:last-of-type {
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.data-view-container .data-view {
  height: 100%;
  width: 100%;
}
.data-view-container .data-view form .lb-xs > label {
  margin-right: 0;
}
.data-view-container .data-view .currency-input {
  background-color: #f5f5f5;
  color: #666;
}
.data-view-container .data-view .currency-input--dark {
  background-color: #424242;
  color: #fff;
}
.data-view-container .activity-logs-container {
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: none;
}
.data-view-container .activity-logs-container--dark {
  background-color: #1a2035;
}
.data-view-container .clear-filters-container {
  display: flex;
  justify-content: flex-end;
}
.data-view-container .clear-filters-container button {
  min-width: 120px;
}
@media (min-width: 1024px) {
  .data-view-container {
    display: flex;
  }
  .data-view-container .data-view {
    width: 88% !important;
    margin: 0 auto;
  }
}

.modal-container {
  overflow-y: auto;
}
.modal-container .data-view {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 32px;
  max-height: 100%;
  box-shadow: none;
}
.modal-container .data-view .css-1v2oh8h {
  padding: 0;
  margin: 0;
  max-width: 100%;
}
.modal-container .data-view .css-halbs2-MuiButtonBase-root-MuiButton-root {
  margin-top: 0px !important;
  justify-content: flex-end !important;
}
.modal-container .data-view .css-5kxzi1-MuiGrid-root {
  justify-content: flex-start !important;
}
@media (min-width: 768px) {
  .modal-container .data-view {
    width: 90%;
  }
}
@media (min-width: 1024px) {
  .modal-container .data-view {
    width: 80%;
  }
}

.MuiDialogActions-root button + button {
  color: #fff;
}

.pg-viewer-wrapper {
  height: 500px;
}

#react-doc-viewer #header-bar {
  display: none;
}
#react-doc-viewer #proxy-renderer {
  overflow: none;
}
#react-doc-viewer #proxy-renderer #msdoc-renderer iframe {
  height: 500px;
}

.title-modal {
  color: #fff !important;
  text-shadow: 2px 2px 5px #000;
}

.visually-hidden-input {
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
}

.docx-wrapper {
  background: white;
  padding: 30px;
}
.docx-wrapper section.docx {
  min-height: 500px;
  background: white;
}

@media (min-width: 1024px) {
  ::-webkit-scrollbar {
    width: 20px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}
.px-xs {
  padding-left: 8px;
  padding-right: 8px;
}

.px-sm {
  padding-left: 12px;
  padding-right: 12px;
}

.px-md {
  padding-left: 16px;
  padding-right: 16px;
}

.px-lg {
  padding-left: 24px;
  padding-right: 24px;
}

.px-xl {
  padding-left: 32px;
  padding-right: 32px;
}

.py-xs {
  padding-top: 8px;
  padding-bottom: 8px;
}

.py-sm {
  padding-top: 12px;
  padding-bottom: 12px;
}

.py-md {
  padding-top: 16px;
  padding-bottom: 16px;
}

.py-lg {
  padding-top: 24px;
  padding-bottom: 24px;
}

.py-xl {
  padding-top: 32px;
  padding-bottom: 32px;
}

.p-xs {
  padding: 8px;
}

.p-sm {
  padding: 12px;
}

.p-md {
  padding: 16px;
}

.p-lg {
  padding: 24px;
}

.p-xl {
  padding: 32px;
}

.text-xs {
  font-size: 0.75rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-base {
  font-size: 1rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.text-3xl {
  font-size: 1.875rem;
}

.text-4xl {
  font-size: 2.25rem;
}

.font-normal {
  font-weight: 400;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.title-primary {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
}

.title-secondary {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.3;
}

.subtitle {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.4;
}

.body-text {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
}

.body3 {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
}

.caption {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
}

.card-base {
  padding: 24px;
  border-radius: 12px;
}
@media (max-width: 768px) {
  .card-base {
    padding: 16px;
  }
}

.card-general-content {
  padding: 16px;
}
@media (max-width: 768px) {
  .card-general-content {
    padding: 12px 16px;
  }
}

.card-header-base {
  padding: 16px 24px;
}
@media (max-width: 768px) {
  .card-header-base {
    padding: 12px 16px;
  }
}

.card-content-base {
  padding: 16px 24px;
}
@media (max-width: 768px) {
  .card-content-base {
    padding: 12px 16px;
  }
}

.MuiDialog-paper .MuiDialogTitle-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogTitle-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .MuiDialogContent-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogContent-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .MuiDialogActions-root {
  padding: 16px !important;
}
@media (max-width: 768px) {
  .MuiDialog-paper .MuiDialogActions-root {
    padding: 12px 16px !important;
  }
}
.MuiDialog-paper .css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {
  display: inline-block;
  margin-top: -15px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #344767;
  line-height: 1;
  transform: translateY(0.625rem);
  margin-left: 0.25rem;
}
.MuiDialog-paper .css-cbmr7p-MuiSvgIcon-root {
  -webkit-user-select: none;
  user-select: none;
  width: 1em;
  height: 1em;
  margin-top: 0px;
  display: inline-block;
  fill: currentColor;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.25rem;
  color: #344767;
  font-size: 1.25rem !important;
}
.MuiDialog-paper .css-tnsvld-MuiSwitch-root {
  display: inline-flex;
  width: 58px;
  height: 38px;
  margin-top: 0px;
  overflow: hidden;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  z-index: 0;
  vertical-align: middle;
}
.MuiDialog-paper .css-knlq9b-MuiFormControlLabel-root {
  display: inline-flex;
  /* -webkit-align-items: center; */
  /* -webkit-box-align: center; */
  -ms-flex-align: center;
  /* align-items: center; */
  /* cursor: pointer; */
  /* vertical-align: bottom; */
  /* -webkit-tap-highlight-color: transparent; */
  /* margin-left: -11px; */
  margin-right: 16px;
  /* display: block; */
  /* min-height: 1.5rem; */
  /* margin-bottom: 0.125rem; */
}
.MuiDialog-paper .css-1bg6o37-MuiGrid-root {
  box-sizing: border-box;
  margin: 0;
  flex-direction: row;
  flex-basis: 100%;
  flex-grow: 0;
  /* max-width: 100%; */
}

.css-1ioqvny-MuiPaper-root-MuiDrawer-paper {
  overflow-x: hidden;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.data-view-container form {
  margin: 24px;
}
@media (max-width: 1024px) {
  .data-view-container form {
    margin: 16px;
  }
}
@media (max-width: 768px) {
  .data-view-container form {
    margin: 12px;
  }
}

.form-container-action-buttons {
  box-sizing: border-box;
  display: flex;
  -webkit-box-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  margin-top: 20px;
  width: calc(100% + 16px);
  align-items: center;
  padding: 12px;
  justify-content: space-between;
}
@media (max-width: 1440px) {
  .form-container-action-buttons {
    justify-content: space-between;
  }
}
@media (max-width: 1024px) {
  .form-container-action-buttons {
    justify-content: flex-end;
  }
}
@media (max-width: 768px) {
  .form-container-action-buttons {
    justify-content: flex-end;
  }
}

.css-18kdg2e-MuiGrid-root {
  box-sizing: border-box;
  margin: 0;
  flex-direction: row;
  flex-basis: 100%;
  flex-grow: 0;
  max-width: 100%;
  display: flex;
  justify-content: flex-end;
}

form .form-container .css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input {
  padding: 4px 0 5px;
}
form .form-container button {
  margin-right: 16px;
}

.modal-container .data-view .css-halbs2-MuiButtonBase-root-MuiButton-root {
  margin-top: 0px !important;
}

.modal-container .data-view .css-5kxzi1-MuiGrid-root {
  justify-content: flex-end !important;
}

.form-data-grid-item {
  box-sizing: border-box;
  margin: 0;
  flex-direction: row;
  flex-basis: 100%;
  flex-grow: 0;
  max-width: 48%;
  margin-top: 24px;
}

.css-1rnrdd8-MuiGrid-root > .MuiGrid-item {
  display: flex;
}
@media (max-width: 1440px) {
  .css-1rnrdd8-MuiGrid-root > .MuiGrid-item {
    justify-content: flex-start;
  }
}
@media (max-width: 1024px) {
  .css-1rnrdd8-MuiGrid-root > .MuiGrid-item {
    justify-content: flex-start;
    margin-left: -5px;
  }
}
@media (max-width: 768px) {
  .css-1rnrdd8-MuiGrid-root > .MuiGrid-item {
    justify-content: flex-end;
  }
}

.css-m166en-MuiGrid-root > .MuiGrid-item {
  display: flex !important;
  justify-content: flex-end !important;
}
@media (min-width: 1024px) {
  .css-m166en-MuiGrid-root > .MuiGrid-item:first-child {
    justify-content: flex-start !important;
  }
  .css-m166en-MuiGrid-root > .MuiGrid-item:last-child {
    justify-content: flex-end !important;
  }
}

.css-1q2d3rl-MuiGrid-root > .MuiGrid-item {
  padding-top: 0px;
}

.full-form-wrapper .full-form-sub-wrapper {
  margin-bottom: 2rem;
}

.formik-input input[type=checkbox] {
  margin-bottom: 0.5rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.data-event-calendar {
  color: #ffffff;
  padding: 2px 5px;
  width: 100%;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  border-radius: 0.35rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.fc-event-error, .fc-event.fc-event-error {
  background: #e57373 !important;
  border-color: #b71c1c !important;
  box-shadow: none;
  opacity: 0.85;
}
.fc-event-success, .fc-event.fc-event-success {
  background: linear-gradient(135deg, #66bb6a 0%, #2e7d32 50%, #1b5e20 100%) !important;
  border-color: #1b5e20 !important;
  box-shadow: 0 2px 4px rgba(46, 125, 50, 0.3);
}
.fc-event-info, .fc-event.fc-event-info {
  background: linear-gradient(135deg, #42a5f5 0%, #1976d2 50%, #0d47a1 100%) !important;
  border-color: #0d47a1 !important;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);
}

.data-event-calendar strong {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.data-event-calendar > div,
.data-event-calendar .patient-name,
.data-event-calendar .doctor-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
  transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
}
.data-event-calendar.event-tiny .patient-name,
.data-event-calendar.event-tiny .doctor-name {
  display: none;
}
.data-event-calendar.event-small .doctor-name {
  display: none;
}

.fc-timegrid-event-harness:hover {
  z-index: 1000 !important;
}
.fc-timegrid-event-harness .fc-timegrid-event {
  transition: bottom 0.3s ease-in-out 0s, min-height 0.3s ease-in-out;
  overflow: hidden;
  border-radius: 0.35rem;
}
.fc-timegrid-event-harness .fc-timegrid-event .fc-event-main {
  padding: 0;
  height: 100%;
}
.fc-timegrid-event-harness .fc-timegrid-event:hover {
  bottom: -60%;
  min-height: 80px;
  overflow: visible;
}
.fc-timegrid-event-harness .fc-timegrid-event:hover .data-event-calendar .patient-name,
.fc-timegrid-event-harness .fc-timegrid-event:hover .data-event-calendar .doctor-name {
  display: block !important;
}
.fc-timegrid-event-harness .fc-v-event {
  border: none;
}

.fc-daygrid-dot-event {
  padding: 0;
}

.appointment-card--completed {
  background-color: #e8f5e8;
}
.appointment-card--completed.dark-mode {
  background-color: #2F6B05;
}
.appointment-card--cancelled {
  background-color: #740011;
}
.appointment-card--cancelled.dark-mode {
  background-color: #751414;
}
.appointment-card--past-due {
  background-color: #fff8e1;
}
.appointment-card--past-due.dark-mode {
  background-color: #BA9C06;
}
.appointment-card--scheduled {
  background-color: #e3f2fd;
}
.appointment-card--scheduled.dark-mode {
  background-color: #05496B;
}

.appointment-modal__wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 900px;
  background-color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
}
.appointment-modal__wrapper.dark-mode {
  background-color: #1a2035;
}
.appointment-modal__wrapper--mobile {
  width: 98vw;
  height: 90vh;
  padding: 12px 16px;
  border-radius: 4px;
}
.appointment-modal__header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  color: #1e1532;
}
.appointment-modal__header.dark-mode {
  color: #ffffff;
}
.appointment-modal__header--mobile {
  margin-bottom: 8px;
}
.appointment-modal__content {
  flex: 1 1;
  overflow: auto;
  margin-bottom: 16px;
}
.appointment-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.appointment-modal__footer.dark-mode {
  border-top-color: #555;
}

.dashboard-appointments__container {
  min-height: 70vh;
  padding: 24px;
}
.dashboard-appointments__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}
.dashboard-appointments__title-wrapper {
  flex: 1 1;
}
.dashboard-appointments__legend {
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dashboard-appointments__legend-inner {
  margin-top: 4px;
  justify-content: center;
}
.dashboard-appointments__legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.dashboard-appointments__legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dashboard-appointments__legend-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}
.dashboard-appointments__legend-box--completed {
  background-color: #91DB96;
}
.dashboard-appointments__legend-box--completed.dark-mode {
  background-color: #2F6B05;
}
.dashboard-appointments__legend-box--scheduled {
  background-color: #00D5FF;
}
.dashboard-appointments__legend-box--scheduled.dark-mode {
  background-color: #05496B;
}
.dashboard-appointments__legend-box--past-due {
  background-color: #FFE162;
}
.dashboard-appointments__legend-box--past-due.dark-mode {
  background-color: #BA9C06;
}
.dashboard-appointments__legend-box--cancelled {
  background-color: #ef0c0c;
}
.dashboard-appointments__legend-box--cancelled.dark-mode {
  background-color: #851a1a;
}
.dashboard-appointments__actions {
  display: flex;
  gap: 8px;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.dashboard-appointments__actions--mobile {
  flex-direction: column;
  width: 100%;
}
.dashboard-appointments__sort-info {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
@media (min-width: 768px) {
  .dashboard-appointments__sort-info {
    margin-bottom: 0;
  }
}
.dashboard-appointments__grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.dashboard-appointments__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}
.dashboard-appointments__notification {
  height: 800px;
}

.daterange-modal__loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  gap: 16px;
}
.daterange-modal__results {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  max-height: 40vh;
}
.daterange-modal__results-inner {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.daterange-modal__scroll-area {
  flex: 1 1;
  overflow-y: auto;
}
.daterange-modal__appointment-item {
  transform: scale(0.85);
  transform-origin: top left;
  width: 117.65%;
  margin-bottom: -12px;
}
.daterange-modal__card-content-appointment-item {
  padding: 5px !important;
}

.arr-modal__wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85vw;
  max-width: 1600px;
  height: auto;
  background-color: #ffffff !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.arr-modal__wrapper.dark-mode {
  background-color: #1a2035;
}
.arr-modal__wrapper--mobile {
  width: 90vw;
  height: auto;
  padding: 12px;
  border-radius: 4px;
}
.arr-modal__header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  color: #1e1532;
}
.arr-modal__header h2 {
  font-size: 1.5rem;
}
.arr-modal__header.dark-mode {
  color: #ffffff;
}
.arr-modal__header--mobile {
  margin-bottom: 8px;
}
.arr-modal__header--mobile h2 {
  font-size: 1.2rem;
}
.arr-modal__content {
  flex: 1 1;
  overflow: auto;
  margin-bottom: 16px;
}
.arr-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-direction: row;
}
.arr-modal__footer--mobile {
  flex-direction: column;
}

.text--caption-small {
  font-size: 0.75rem;
}

.icon--empty-state {
  font-size: 64px;
  color: rgba(0, 0, 0, 0.26);
  margin-bottom: 16px;
}
.icon--empty-state.dark-mode {
  color: rgba(255, 255, 255, 0.3);
}

.appointment-form__button-group {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  padding: 16px;
}
.appointment-form__button {
  margin: 5px;
}

.autocomplete-textfield .MuiInputBase-input {
  color: #000;
}
.autocomplete-textfield .MuiInputLabel-root {
  color: #666;
}
.autocomplete-textfield .MuiInput-underline:before {
  border-bottom-color: #ccc;
}
.autocomplete-textfield .MuiInput-underline:hover:before {
  border-bottom-color: #999;
}
.autocomplete-textfield.dark-mode .MuiInputBase-input {
  color: #fff;
}
.autocomplete-textfield.dark-mode .MuiInputLabel-root {
  color: #bbb;
}
.autocomplete-textfield.dark-mode .MuiInput-underline:before {
  border-bottom-color: #555;
}
.autocomplete-textfield.dark-mode .MuiInput-underline:hover:before {
  border-bottom-color: #777;
}

.appointment-modal__wrapper--large {
  min-width: 480px;
  max-width: 1050px;
}
@media (max-width: 1024px) {
  .appointment-modal__wrapper--large {
    min-width: 95vw;
    max-width: 98vw;
  }
}

.iconButton-addUser {
  height: 12px !important;
  margin: 0px !important;
}

.iconButton-addUser-icon {
  color: inherit;
}

.currencyInput-overrideCopay {
  width: auto;
}
@media (min-width: 768px) {
  .currencyInput-overrideCopay {
    width: 130px;
  }
}

.min-dimensions {
  background-color: lawngreen;
}

.appoinment-form-insurance-options--override-copay div label {
  display: flex;
}
@media (max-width: 768px) {
  .appoinment-form-insurance-options--override-copay {
    flex-direction: column !important;
  }
  .appoinment-form-insurance-options--non-billable div label {
    display: flex;
  }
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.main-container .tab-container {
  overflow: scroll;
}
.main-container .tab-container .react-kanban-board {
  width: 400px;
}
.main-container .tab-container .react-kanban-board > div {
  width: 100%;
  display: flex;
}
.main-container .tab-container .react-kanban-board > div .react-kanban-column {
  flex: 1 0 auto;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.notification-widget {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
}
.notification-widget--light {
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.notification-widget-header {
  padding: 24px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.notification-widget-header--light {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.notification-widget-header--dark {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
  color: #ffffff;
}

.notification-widget-header-title {
  font-size: 1rem !important;
  font-weight: 700 !important;
}
.notification-widget-header-title--light {
  color: #ffffff;
}

.notification-widget-header-badge--light .MuiBadge-badge {
  background-color: #ff4757;
  color: white;
  font-weight: 600;
}

.notification-widget-header-icon--light {
  color: #ffffff !important;
}

.notification-widget-header-button {
  font-size: 0.75rem !important;
}
.notification-widget-header-button--light {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
}
.notification-widget-header-button--light:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}
.notification-widget-header-button--dark {
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
.notification-widget-header-button--dark:hover {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.notification-widget-header-caption {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}
.notification-widget-header-caption--light {
  color: #ffffff;
  opacity: 1;
}
.notification-widget-header-caption--dark {
  color: #ffffff;
  opacity: 0.9;
}

.notification-widget-stats-box {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.notification-widget-toggle-read:focus, .notification-widget-toggle-read:focus-visible, .notification-widget-toggle-read:active {
  background-color: rgba(128, 128, 128, 0.1) !important;
  outline: none !important;
}
.notification-widget-toggle-read {
  font-size: 0.875rem !important;
}

.notification-widget-stats-chip {
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notification-widget-stats-chip:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.notification-widget-stats-chip--active {
  border: 2.5px solid #575757 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 1;
}
.notification-widget-stats-chip--total-light {
  background-color: rgba(201, 201, 201, 0.59) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light.notification-widget-stats-chip--active {
  background-color: rgba(201, 201, 201, 0.9) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--total-dark {
  background-color: #1a2535 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark.notification-widget-stats-chip--active {
  background-color: rgba(255, 255, 255, 0.158) !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--unread-light {
  background-color: #ff3546 !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light.notification-widget-stats-chip--active {
  background-color: #ea3030 !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--unread-dark {
  background-color: #710800 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark.notification-widget-stats-chip--active {
  background-color: #7a4542 !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--read-light {
  background-color: rgba(82, 205, 87, 0.8) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light.notification-widget-stats-chip--active {
  background-color: rgb(116, 248, 121) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--read-dark {
  background-color: rgba(42, 128, 48, 0.6078431373) !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark.notification-widget-stats-chip--active {
  background-color: rgba(105, 188, 111, 0.6078431373) !important;
  border: 2.5px solid #fff !important;
}

.notification-widget-item {
  cursor: pointer;
  border-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px !important;
  transition: all 0.2s ease;
}
.notification-widget-item.MuiListItem-root {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  padding-left: 16px !important;
  padding-right: 32px !important;
  margin-right: 16px !important;
}
.notification-widget-item .MuiListItemText-root {
  padding-right: 16px !important;
}
.notification-widget-item--read {
  opacity: 0.6;
}
.notification-widget-item--unread {
  opacity: 1;
}
.notification-widget-item:hover {
  opacity: 1;
}

.notification-widget-title {
  flex-grow: 1;
  font-size: 0.9375rem !important;
}
.notification-widget-title--read {
  font-weight: normal;
}
.notification-widget-title--unread {
  font-weight: bold !important;
}

.notification-widget-message {
  margin-bottom: 4px;
  font-size: 0.9375rem !important;
}

.notification-widget-date {
  font-size: 0.75rem !important;
  opacity: 0.7;
}

.notification-widget-divider {
  margin-top: 24px;
  margin-bottom: 20px;
  border: 0;
  border-top: 6px solid rgba(0, 0, 0, 0.18);
  position: relative;
  width: 100%;
  z-index: 0;
}
.notification-widget-divider--read {
  margin-bottom: 20px;
}
.notification-widget-divider--unread {
  margin-top: 24px;
  margin-bottom: 20px;
}

.notification-widget--light .notification-widget-divider {
  border-top: 6px solid #1a1a1a !important;
}

.notification-widget--dark .notification-widget-divider {
  border-top: 6px solid rgba(255, 255, 255, 0.22) !important;
}

.notification-widget-divider-chip {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin: 12px 0 20px 0 !important;
  width: 100% !important;
}
.notification-widget-divider-chip .MuiChip-root {
  display: inline-flex !important;
  background: none !important;
}

.notification-widget-item {
  margin-top: 8px;
}

.notification-widget-chip {
  opacity: 1 !important;
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  background-color: transparent !important;
  align-self: center !important;
  align-content: center !important;
}
.notification-widget-chip--read .MuiChip-label {
  color: #4caf50 !important;
}
.notification-widget-chip--unread .MuiChip-label {
  color: #ff4757 !important;
}
.notification-widget-chip.MuiChip-label--light .MuiChip-label {
  color: #909090 !important;
}
.notification-widget-chip.MuiChip-label--dark .MuiChip-label {
  color: #ffffff !important;
}

.notification-widget-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
}

.notification-widget-loading-text {
  margin-left: 16px;
}

.notification-widget-error {
  padding: 16px;
}

.notification-widget-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}

.notification-widget-empty-icon {
  font-size: 48px;
  margin-bottom: 8px;
}

.notification-widget-empty-caption {
  margin-top: 8px;
}

.notification-widget-list {
  padding: 16px;
  max-height: 675px;
  overflow-y: auto;
  overflow-x: hidden;
}
.notification-widget-list .notification-widget-divider-chip {
  text-align: center;
  display: flex;
  justify-content: center;
}
.notification-widget-list::-webkit-scrollbar {
  width: 8px;
}
.notification-widget-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.notification-widget-content {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notification-widget-snackbar .MuiSnackbarContent-root {
  border-radius: 8px;
  font-weight: 500;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
#accounting-movements-totals .balanceText {
  display: inline-block;
  max-width: 250px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
#profile .photoLoadingContainer {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 50%;
}
#profile .progressContainer {
  position: relative;
  display: inline-flex;
}
#profile .progressLabel {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
#profile .addressText {
  display: inline-block;
  max-width: 450px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.header-person-card {
  position: relative !important;
}

.print-button {
  position: absolute !important;
  top: 8px;
  right: 8px;
  background-color: rgba(25, 118, 210, 0.15) !important;
}
.print-button:hover {
  background-color: rgba(25, 118, 210, 0.3) !important;
}

.patient-avatar {
  width: 200px !important;
  height: 200px !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.appointment-card .light-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.appointment-card .dark-card-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.appointment-card .card {
  min-height: 140px;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2);
}
.appointment-card .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4), 0 4px 8px rgba(0, 0, 0, 0.3);
}
.appointment-card .card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
}
.appointment-card .card-content:last-child {
  padding-bottom: 16px;
}
.appointment-card .card-header {
  display: flex;
  flex-direction: row !important;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  gap: 8px;
}
.appointment-card .card-title {
  flex-grow: 1;
  font-size: 1.125rem;
  font-weight: 700;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.appointment-card .card-row-space {
  flex-direction: row !important;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.appointment-card .subtitle2 {
  font-size: 1rem;
  font-weight: 700 !important;
}
.appointment-card .light-color {
  color: rgba(0, 0, 0, 0.6) !important;
}
.appointment-card .dark-color {
  color: white !important;
}
.appointment-card .dark-chip-color {
  color: rgba(0, 0, 0, 0.87) !important;
}
.appointment-card .chip-light {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: bold;
  flex-shrink: 0;
}
.appointment-card .chip-light .MuiChip-label {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: bold;
}
.appointment-card .chip-dark {
  color: white !important;
  font-weight: bold;
  flex-shrink: 0;
}
.appointment-card .chip-dark .MuiChip-label {
  color: white !important;
  font-weight: bold;
}
.appointment-card .cancel-light {
  background-color: #FFCDD2 !important;
}
.appointment-card .checkIn-light {
  background-color: #FFECB3 !important;
}
.appointment-card .checkOut-light {
  background-color: #C8E6C8 !important;
}
.appointment-card .card-color-light {
  background-color: #A0C8E6 !important;
}
.appointment-card .cancel-dark {
  background-color: #FF8787 !important;
}
.appointment-card .checkIn-dark {
  background-color: #FAD784 !important;
}
.appointment-card .checkOut-dark {
  background-color: #91DB96 !important;
}
.appointment-card .card-color-dark {
  background-color: #94BCEB !important;
}
.appointment-card .card-stack-row-center {
  flex-direction: row !important;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.appointment-card .card-text-no-wrap {
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.appointment-card .card-icon-text {
  font-size: 16px;
}
.appointment-card .stack-row-space-between {
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
}

.card-color-cancel-light {
  background-color: #ffebee !important;
}

.card-color-checkIn-light {
  background-color: #fff8e1 !important;
}

.card-color-checkOut-light {
  background-color: #e8f5e8 !important;
}

.card-background-color-light {
  background-color: #e3f2fd !important;
}

.card-color-cancel-dark {
  background-color: #751414 !important;
}

.card-color-checkIn-dark {
  background-color: #BA9C06 !important;
}

.card-color-checkOut-dark {
  background-color: #2F6B05 !important;
}

.card-background-color-dark {
  background-color: #05496B !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.call-timer {
  color: white !important;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 1rem 2rem;
  border-radius: 0.25rem;
  font-weight: bold !important;
  font-family: monospace !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.checkbox-label-center {
  align-items: center;
}

.checkbox-label-size {
  font-size: 1rem !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.select-container {
  line-height: 1.8rem !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.formField-error-label {
  white-space: pre-line !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.FormInputCheckbox-margin-top-small {
  margin-top: 0.75rem;
}

.item-width-field {
  width: 5rem !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.FormControl-content {
  margin: 0 !important;
  width: 100% !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.multipleSelectChip-container {
  margin: 1rem;
}

.multipleSelectChip-chip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.formPhoneInput-dark-mode .react-tel-input .special-label {
  background-color: #1e2e4a !important;
  color: white;
}
.formPhoneInput-dark-mode .react-tel-input .form-control {
  background-color: #1e2e4a !important;
  color: white !important;
  border-color: white;
}
.formPhoneInput-dark-mode .react-tel-input .form-control.invalid-number {
  border-color: red !important;
}

.formPhoneInput-light-mode .react-tel-input .special-label {
  background-color: white !important;
  color: black;
}
.formPhoneInput-light-mode .react-tel-input .form-control {
  background-color: white !important;
}

.formPhoneInput-inputStyle {
  width: 100% !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.FormikSelectInput-select {
  line-height: 1.8rem !important;
}

.FormikSelectInput-errorMessage {
  margin-top: 0.75rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.formTextareaInput-textarea {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 12px 12px 0 12px;
  color: #1C2025;
  background: #fff;
  border: 1px solid #DAE2ED;
  box-shadow: 0px 2px 2px #F3F6F9;
}
.formTextareaInput-textarea:hover {
  border-color: #3399FF;
}
.formTextareaInput-textarea:focus {
  outline: 0;
  border-color: #3399FF;
  box-shadow: 0 0 0 3px #b6daff;
}
.formTextareaInput-textarea:focus-visible {
  outline: 0;
}
.formTextareaInput-textarea[data-theme=dark] {
  color: #C7D0DD;
  background: #434D5B;
  border: 1px solid #434D5B;
  box-shadow: 0px 2px 2px #1C2025;
}
.formTextareaInput-textarea[data-theme=dark]:focus {
  box-shadow: 0 0 0 3px #0072E5;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.custom-wrapper {
  width: 100%;
  height: 40rem !important;
  overflow: hidden;
}

.custom-editor {
  height: 30rem;
  overflow: auto;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.HtmlTooltip-html-tooltip .MuiTooltip-tooltip {
  background-color: #f5f5f9;
  color: rgba(0, 0, 0, 0.87);
  max-width: 220px;
  font-size: 12px;
  border: 1px solid #dadde9;
}
.HtmlTooltip-html-tooltip .MuiTooltip-arrow {
  color: #dadde9;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.idCell-caption {
  margin-left: 8px;
}

.inputHelper.dark-mode input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-text-fill-color: #fff !important;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}
.inputHelper.dark-mode * {
  color: #fff !important;
}

.inputHelper.light-mode input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-text-fill-color: #000 !important;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}
.inputHelper.light-mode * {
  color: #000 !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  flex-direction: column;
}
.loading-overlay .loading-spinner {
  color: #FFFFFF;
}
.loading-overlay .loading-message {
  color: #FFFFFF;
  margin-top: 2rem;
  font-size: 16px;
  font-weight: bold;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.pdf-viewer-container {
  width: 100%;
  height: 900px;
}
.pdf-viewer-container .pdf-viewer {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #ffffff;
}

.medical-asset-viewer .loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 900px;
  gap: 2rem;
  padding: 0 4rem;
}
.medical-asset-viewer .loading-container .progress-wrapper {
  position: relative;
  display: inline-flex;
}
.medical-asset-viewer .loading-container .progress-wrapper .progress-percentage {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
.medical-asset-viewer .loading-container .loading-message {
  margin-top: 2rem;
  color: #6c757d;
}
.medical-asset-viewer .viewer-height {
  height: 900px;
}
.medical-asset-viewer .error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 2rem;
}
.medical-asset-viewer .error-container .error-message {
  color: red;
}
.medical-asset-viewer .error-container .error-button {
  border: 1px solid #ccc;
}
.medical-asset-viewer .error-alert {
  margin-top: 2rem;
}
.medical-asset-viewer .card {
  padding: 1.5rem;
  margin-top: 2rem;
}
.medical-asset-viewer .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.medical-asset-viewer .header .header-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.medical-asset-viewer .header .header-left .icon {
  font-size: 24px;
  color: #007FFF;
}
.medical-asset-viewer .header .header-left .file-info .file-name {
  font-size: 1.25rem;
  font-weight: 600;
}
.medical-asset-viewer .header .header-left .file-info .file-type {
  font-size: 0.875rem;
  color: #6B7A90;
}
.medical-asset-viewer .header .header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.medical-asset-viewer .viewer-container {
  margin-top: 2rem;
}
.medical-asset-viewer .viewer-container .viewer-box {
  height: 900px;
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
  overflow: auto;
  background-color: #f5f5f5;
}
.medical-asset-viewer .no-preview {
  text-align: center;
  padding: 4rem 0;
  background-color: #F3F6F9;
  border-radius: 0.25rem;
}
.medical-asset-viewer .no-preview .no-preview-title {
  font-size: 1.25rem;
  color: #6B7A90;
  margin-bottom: 1rem;
}
.medical-asset-viewer .no-preview .no-preview-message {
  font-size: 0.875rem;
  color: #6B7A90;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.office-document-renderer .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 500px;
  gap: 2rem;
}
.office-document-renderer .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 500px;
  padding: 4rem;
}
.office-document-renderer .error-container .alert {
  max-width: 600px;
  margin-bottom: 3rem;
}
.office-document-renderer .header {
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.office-document-renderer .content {
  flex: 1 1;
  overflow: auto;
  background-color: #f5f5f5;
  padding: 3rem;
}
.office-document-renderer .content .preview {
  max-width: 900px;
  margin: 0 auto;
  background-color: #f5f5f5;
  min-height: 100%;
}
.office-document-renderer .content .preview .docx-container {
  padding: 4rem;
  min-height: 500px;
}
.office-document-renderer .content .preview .docx-container section.docx {
  padding: 0 !important;
  background-color: #f5f5f5;
}
.office-document-renderer .content .preview .html-content {
  padding: 4rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.password-recovery-card {
  width: 400px;
  height: auto !important;
}
.password-recovery-card .card-content .title {
  margin-top: 16px;
}
.password-recovery-card .card-content .description {
  font-size: 13px;
  display: block;
  margin-top: 16px;
  margin-bottom: 2px;
}
.password-recovery-card .card-content .error {
  margin-top: 10px;
  color: #f44336;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: pre-line;
  font-size: 12px !important;
}
.password-recovery-card .card-content .error .error-icon {
  font-size: 15px !important;
}
.password-recovery-card .card-content .footer {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.pdf-vitals-uploader .hidden-input {
  display: none;
}
.pdf-vitals-uploader .upload-button {
  margin-right: 2rem;
  border-color: #1A73E8;
  align-self: center;
}
.pdf-vitals-uploader .upload-description {
  margin-top: 1rem;
  color: #747b8a;
  display: flex;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.percentage-input-props {
  text-align: right;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.pricing-file-upload .flex-container {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2px;
}
.pricing-file-upload .margin-bottom {
  margin-bottom: 2px;
}
.pricing-file-upload .transparent-alert {
  background-color: transparent;
  margin-bottom: 2px;
}
.pricing-file-upload .bold-margin {
  font-weight: bold;
  margin-bottom: 1px;
}
.pricing-file-upload .padded-list {
  padding-left: 2px;
}
.pricing-file-upload .bold-margin-top {
  font-weight: bold;
  margin-bottom: 1px;
  margin-top: 2px;
}
.pricing-file-upload .flex-center {
  display: flex;
  align-items: center;
  margin-top: 2px;
  margin-bottom: 2px;
}
.pricing-file-upload .progress-icon {
  margin-right: 1px;
  color: #6c757d;
}
.pricing-file-upload .status-alert {
  margin-top: 2px;
}
.pricing-file-upload .pre-wrap {
  white-space: pre-wrap;
  font-family: inherit;
  margin: 0;
}
.pricing-file-upload .error-alert {
  margin-top: 2px;
}
.pricing-file-upload .full-width {
  width: 100%;
}
.pricing-file-upload .margin-bottom-start {
  margin-bottom: 2px;
  align-items: flex-start;
}
.pricing-file-upload .thin-font {
  font-weight: thin;
}
.pricing-file-upload .bold-font {
  font-weight: bold;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.sidenav-button {
  width: 24px;
  height: 24px;
  padding: 0;
  margin-right: 8px !important;
  border: 1px solid transparent !important;
  transition: border-color 0.2s ease-in-out !important;
}
.sidenav-button.selected.dark-mode {
  border-color: #EBEFF4 !important;
}
.sidenav-button.selected.light-mode {
  border-color: #344767 !important;
}
.sidenav-button:hover.dark-mode, .sidenav-button:focus.dark-mode, .sidenav-button:active.dark-mode {
  border-color: #EBEFF4 !important;
}
.sidenav-button:hover.light-mode, .sidenav-button:focus.light-mode, .sidenav-button:active.light-mode {
  border-color: #344767 !important;
}
.sidenav-button:not(:last-child) {
  margin-right: 4px;
}
.sidenav-button.one {
  background-color: #EC407A;
  background-image: linear-gradient(#EC407A, #D81B60);
}
.sidenav-button.two {
  background-color: #344767;
  background-image: linear-gradient(#344767, #1d2430);
}
.sidenav-button.three {
  background-color: #49a3f1;
  background-image: linear-gradient(#49a3f1, #1A73E8);
}
.sidenav-button.four {
  background-color: #66BB6A;
  background-image: linear-gradient(#66BB6A, #43A047);
}
.sidenav-button.five {
  background-color: #FFA726;
  background-image: linear-gradient(#FFA726, #FB8C00);
}
.sidenav-button.six {
  background-color: #EF5350;
  background-image: linear-gradient(#EF5350, #E53935);
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.switch-span {
  font-size: 0.75rem;
  font-weight: bold;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.text-messages-chat {
  width: 100%;
  height: 100% !important;
  background-color: #f8f9fa !important;
  border-left: 1px solid #dee2e6 !important;
  display: flex;
  flex-direction: column;
  border-radius: 0 8px 8px 0 !important;
  color: #333333 !important;
}
.text-messages-chat.dark {
  background-color: #1a1a1a !important;
  border-left: 1px solid #333333 !important;
  color: #ffffff !important;
}
.text-messages-chat.dark * {
  color: #ffffff !important;
}
.text-messages-chat .chat-header {
  padding: 16px;
  background-color: #343a40 !important;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #495057 !important;
}
.text-messages-chat .chat-header.dark {
  background-color: #2c2c2c !important;
  border-bottom: 1px solid #444 !important;
}
.text-messages-chat .chat-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.text-messages-chat .chat-icon {
  font-size: 20px;
  color: #ffffff !important;
  fill: #ffffff !important;
  stroke: #ffffff !important;
}
.text-messages-chat .chat-title {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff !important;
}
.text-messages-chat .icon-button {
  color: #ffffff !important;
  padding: 4px;
}
.text-messages-chat .icon-button:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.text-messages-chat .icon-button svg {
  color: #ffffff !important;
  fill: #ffffff !important;
}
.text-messages-chat .content-copy-icon {
  font-size: 18px;
  color: #ffffff !important;
  fill: #ffffff !important;
  stroke: #ffffff !important;
}
.text-messages-chat .copy-success-message {
  color: #ffffff !important;
  font-size: 12px;
}
.text-messages-chat .tooltip {
  z-index: 10000;
}
.text-messages-chat .tooltip .MuiTooltip-tooltip {
  background-color: rgba(0, 0, 0, 0.9);
  color: #ffffff !important;
  font-size: 12px;
  padding: 6px 8px;
  border-radius: 4px;
  max-width: 200px;
}
.text-messages-chat .tooltip .MuiTooltip-arrow {
  color: rgba(0, 0, 0, 0.9);
}
.text-messages-chat .close-button {
  color: #ffffff !important;
  padding: 4px;
}
.text-messages-chat .close-button:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.text-messages-chat .close-button svg {
  color: #ffffff !important;
  fill: #ffffff !important;
}
.text-messages-chat .chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #f8f9fa !important;
  color: #333333 !important;
}
.text-messages-chat .chat-messages.dark {
  background-color: #1a1a1a !important;
  color: #ffffff !important;
}
.text-messages-chat .empty-messages {
  text-align: center;
  color: #333333 !important;
  font-size: 14px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.text-messages-chat .empty-messages.dark {
  color: #ffffff !important;
}
.text-messages-chat .empty-messages-icon {
  font-size: 32px;
  color: #333333 !important;
}
.text-messages-chat .empty-messages-icon.dark {
  color: #ffffff !important;
}
.text-messages-chat .empty-messages-small-text {
  font-size: 12px;
  color: #333333 !important;
}
.text-messages-chat .empty-messages-small-text.dark {
  color: #ffffff !important;
}
.text-messages-chat .message-container {
  display: flex;
  flex-direction: column;
  max-width: 80%;
}
.text-messages-chat .message-container.own {
  align-items: flex-end;
  align-self: flex-end;
}
.text-messages-chat .message-container.other {
  align-items: flex-start;
  align-self: flex-start;
}
.text-messages-chat .message-bubble {
  color: #FFFFFF !important;
  padding: 10px 14px;
  max-width: 100%;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.text-messages-chat .message-bubble.own {
  background-color: #007bff !important;
  border-radius: 18px 18px 4px 18px;
}
.text-messages-chat .message-bubble.other {
  background-color: #d63384 !important;
  border-radius: 18px 18px 18px 4px;
}
.text-messages-chat .message-metadata {
  font-size: 11px;
  color: #6c757d !important;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.text-messages-chat .message-metadata.dark {
  color: #bbbbbb !important;
}
.text-messages-chat .chat-caption {
  color: #6c757d !important;
  font-size: 11px;
  margin-top: 4px;
  display: block;
}
.text-messages-chat .chat-caption.dark {
  color: #aaaaaa !important;
}
.text-messages-chat .chat-input {
  padding: 16px;
  border-top: 1px solid #dee2e6;
  background-color: #ffffff !important;
  padding-bottom: 24px;
}
@media (max-width: 768px) {
  .text-messages-chat .chat-input {
    padding-bottom: 32px;
  }
}
.text-messages-chat .chat-input.dark {
  border-top: 1px solid #444;
  background-color: #1a1a1a !important;
}
.text-messages-chat .input-wrapper {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root {
  border-radius: 20px;
  font-size: 14px;
  background-color: #f8f9fa !important;
  color: #333 !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root.dark {
  background-color: #333333 !important;
  color: #ffffff !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root fieldset {
  border-color: #ced4da !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root fieldset.dark {
  border-color: #555555 !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root:hover fieldset {
  border-color: #adb5bd !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root:hover fieldset.dark {
  border-color: #666666 !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #007bff !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-input {
  padding: 10px 16px;
  color: #333 !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-input.dark {
  color: #ffffff !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-input::placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
}
.text-messages-chat .chat-text-field .MuiOutlinedInput-input::placeholder.dark {
  color: #aaaaaa !important;
}
.text-messages-chat .send-button {
  background-color: #007bff !important;
  color: #FFFFFF !important;
  margin-bottom: 2px;
  padding: 8px;
  border-radius: 50%;
  min-width: 40px;
  height: 40px;
}
.text-messages-chat .send-button:hover {
  background-color: #0056b3 !important;
}
.text-messages-chat .send-button.disabled {
  background-color: #dee2e6 !important;
}
.text-messages-chat .send-button.disabled:hover {
  background-color: #c6c8ca !important;
}
.text-messages-chat .send-button.dark {
  background-color: #555555 !important;
}
.text-messages-chat .send-button.dark:hover {
  background-color: #666666 !important;
}
.text-messages-chat .send-icon {
  font-size: 18px;
  color: #FFFFFF !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.*/
.appointment-widget__appointment-text {
  line-height: 1;
  margin-bottom: 8px;
}
.appointment-widget__progress-note-btn {
  margin-top: 12px;
  margin-left: 12px;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.patient-hub-form__title {
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 16px;
}
.patient-hub-form__no-info {
  font-size: 1rem;
  font-weight: 700;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.general-settings-form__card-equal-height {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  margin-top: 2%;
}
.general-settings-form__card-equal-height .MuiCardContent-root {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 4%;
}
.general-settings-form__section-title {
  margin-bottom: 40px !important;
  font-weight: 500 !important;
  font-size: 12.5px !important;
  color: #6f6f6f !important;
}
.general-settings-form__currency-lock-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2%;
  margin-left: 1%;
}
.general-settings-form__currency-chip {
  height: 20px;
  font-size: 10px;
}
.general-settings-form__helper-text-no-margin {
  margin: 0;
}
.general-settings-form__module-section-container {
  margin-top: 1.5%;
  margin-bottom: 0.8%;
}
.general-settings-form__checkbox-container {
  display: flex;
  align-items: center;
}
.general-settings-form__actions-container {
  margin-top: 1.5%;
}

.general-settings-modal__title {
  margin-left: 1.2% !important;
  margin-top: 1.2% !important;
  margin-bottom: 8px;
}
.general-settings-modal__subtitle {
  text-align: left;
  margin-left: 1.2% !important;
  color: #6f6f6f !important;
  margin-bottom: -2% !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.*/
.document-viewer__title {
  font-size: 1rem !important;
  font-weight: 700 !important;
}
.document-viewer__folder-name {
  font-size: 1rem !important;
  font-weight: 700 !important;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.recycle-bin-modal__paper {
  background-color: #ffffff;
}
.recycle-bin-modal__paper--dark {
  background-color: #2d3748;
}
.recycle-bin-modal__title {
  padding-bottom: 8px;
}
.recycle-bin-modal__content {
  padding: 24px;
}
@media (max-width: 768px) {
  .recycle-bin-modal__content {
    padding: 16px;
  }
}
.recycle-bin-modal__empty-message {
  text-align: center;
  padding-top: 32px;
  padding-bottom: 32px;
}
.recycle-bin-modal__actions {
  padding: 16px;
  padding-top: 0;
}
@media (max-width: 768px) {
  .recycle-bin-modal__actions {
    padding: 12px;
    padding-top: 0;
  }
}
.recycle-bin-modal__action-button {
  margin-right: 8px !important;
}
.recycle-bin-modal__action-button:last-child {
  margin-right: 0;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.progress-note-container {
  padding: 24px;
}

.progress-note-autocomplete .MuiAutocomplete-root .MuiInputBase-root {
  font-size: 1rem !important;
  padding: 8px 16px !important;
}
.progress-note-autocomplete .MuiAutocomplete-root .MuiInputLabel-root {
  font-size: 1rem !important;
  font-weight: 500;
}
.progress-note-autocomplete .MuiAutocomplete-root .MuiAutocomplete-option {
  font-size: 0.875rem !important;
  padding: 12px 16px !important;
}
.progress-note-autocomplete .MuiAutocomplete-root .MuiAutocomplete-option:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.progress-note-autocomplete .MuiAutocomplete-root .MuiAutocomplete-option[aria-selected=true] {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

.progress-note-form-section {
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.progress-note-form-section__title {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  margin-bottom: 16px !important;
}
.progress-note-form-section__content {
  font-size: 1rem !important;
  line-height: 1.5;
}

.progress-note-grid .MuiGrid-item {
  padding: 16px;
}

.progress-note-history__checkbox-container {
  margin-top: 16px;
  margin-bottom: 16px;
}
.progress-note-history__checkbox-label {
  font-size: 0.875rem !important;
  font-weight: 500;
}

.progress-note-select-option {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.progress-note-select-option__date {
  font-size: 0.875rem !important;
  font-weight: 600;
  color: #333;
}
.progress-note-select-option__reason {
  font-size: 0.75rem !important;
  color: #666;
}

.progress-note-patient-select .MuiAutocomplete-root {
  margin-bottom: 16px;
}

.progress-note-appointment-select .MuiAutocomplete-root {
  margin-bottom: 16px;
}

.progress-note-previous-select .MuiAutocomplete-inputRoot {
  padding: 12px 16px !important;
}
.progress-note-previous-select .MuiAutocomplete-option {
  font-size: 0.875rem !important;
  padding: 16px !important;
  border-bottom: 1px solid #e0e0e0;
}
.progress-note-previous-select .MuiAutocomplete-option:last-child {
  border-bottom: none;
}

.progress-note-content-layout {
  display: flex;
  gap: 24px;
}
.progress-note-content-layout__form {
  flex: 1 1;
}
.progress-note-content-layout__history {
  flex: 1 1;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  max-height: 100vh;
  overflow-y: auto;
  margin-right: 24px !important;
}

@media (max-width: 960px) {
  .progress-note-content-layout {
    flex-direction: column;
  }
  .progress-note-content-layout__history {
    position: static;
    max-height: none;
  }
}
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.billing-encounter__stack {
  background-color: #f4f4f4;
  padding: 12px;
  font-size: 0.875rem !important;
  border-radius: 0.5rem;
}
.billing-encounter__text-table {
  font-size: 0.775rem;
}
.billing-encounter__control-label {
  margin-top: 10px;
  font-size: 0.7rem;
  margin: 10 auto;
  display: flex;
  padding-left: 0.3;
}

.css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {
  display: inline-block;
  font-size: 0.775rem;
  font-weight: 700;
  color: #344767;
  line-height: 1;
  transform: translateY(0.0625rem);
  margin-left: 0.25rem;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.payment-form__container {
  display: flex;
  flex-direction: row;
  min-height: 60vh;
  max-height: calc(95vh - 100px);
  overflow: hidden;
  gap: 0;
}
@media (max-width: 1024px) {
  .payment-form__container {
    flex-direction: column;
    max-height: none;
  }
}
.payment-form__left-panel {
  flex: 0 0 45%;
  border-right: 1px solid #f5f5f5;
  overflow-y: auto;
  padding: 24px;
  background-color: #f5f5f5;
}
@media (max-width: 1024px) {
  .payment-form__left-panel {
    flex: 1 1 auto;
    border-right: none;
    border-bottom: 2px solid #e0e0e0;
    max-height: 50vh;
    overflow-y: auto;
  }
}
@media (max-width: 768px) {
  .payment-form__left-panel {
    padding: 16px;
  }
}
.payment-form__right-panel {
  flex: 0 0 55%;
  overflow-y: auto;
  padding: 24px;
}
@media (max-width: 1024px) {
  .payment-form__right-panel {
    flex: 1 1 auto;
    max-height: none;
  }
}
@media (max-width: 768px) {
  .payment-form__right-panel {
    padding: 16px;
  }
}
.payment-form__billing-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1976d2;
}
@media (max-width: 768px) {
  .payment-form__billing-header {
    margin-bottom: 12px;
  }
}
.payment-form__billing-instructions {
  margin-bottom: 16px;
  padding: 12px;
  background-color: #e3f2fd;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .payment-form__billing-instructions {
    margin-bottom: 12px;
    font-size: 0.75rem;
  }
}
.payment-form__select-all-btn {
  margin-bottom: 16px;
}
@media (max-width: 768px) {
  .payment-form__select-all-btn {
    margin-bottom: 12px;
  }
}
.payment-form__table-container {
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  overflow: hidden;
}
@media (max-width: 768px) {
  .payment-form__table-container {
    margin-bottom: 12px;
  }
}
.payment-form__table-row {
  cursor: pointer;
  transition: background-color 0.2s;
}
.payment-form__table-row:hover {
  background-color: #f5f5f5;
}
.payment-form__table-row--selected {
  background-color: #e3f2fd !important;
}
.payment-form__table-row--selected:hover {
  background-color: #bbdefb !important;
}
.payment-form__service-name {
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 4px;
  line-height: 1.4;
}
@media (max-width: 768px) {
  .payment-form__service-name {
    font-size: 0.75rem;
  }
}
.payment-form__service-description {
  font-size: 0.75rem;
  color: #666;
  line-height: 1.3;
}
.payment-form__price-info {
  font-weight: 600;
  font-size: 0.875rem;
}
@media (max-width: 768px) {
  .payment-form__price-info {
    font-size: 0.75rem;
  }
}
.payment-form__discount-info {
  font-size: 0.75rem;
  color: #666;
  font-style: italic;
  line-height: 1.2;
}
.payment-form__summary {
  margin-top: 16px;
  padding: 16px;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1976d2;
}
@media (max-width: 768px) {
  .payment-form__summary {
    margin-top: 12px;
    padding: 12px;
  }
}
.payment-form__summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
@media (max-width: 768px) {
  .payment-form__summary-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.payment-form__summary-label {
  font-weight: 600;
  font-size: 0.875rem;
}
@media (max-width: 768px) {
  .payment-form__summary-label {
    font-size: 0.75rem;
  }
}
.payment-form__summary-total {
  font-weight: 700;
  font-size: 1.25rem;
  color: #1976d2;
}
@media (max-width: 768px) {
  .payment-form__summary-total {
    font-size: 1.125rem;
  }
}
.payment-form__empty-state {
  text-align: center;
  padding: 32px;
  color: #999;
  font-style: italic;
}

.payment-form-dialog :global(.MuiDialog-paper) {
  width: 99vw;
  max-width: 2200px;
  margin: 16px;
  max-height: 95vh;
}
@media (max-width: 1024px) {
  .payment-form-dialog :global(.MuiDialog-paper) {
    width: 100vw;
    max-width: 100vw;
    margin: 8px;
  }
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.confirm-payment-form__dialog .MuiDialog-paper {
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 680px;
  max-width: 775px;
  width: 100%;
}
.confirm-payment-form__title {
  padding: 24px 32px;
  border-bottom: 2px solid #1976d2;
}
.confirm-payment-form__title h5 {
  font-weight: 600;
  margin: 0;
}
@media (max-width: 768px) {
  .confirm-payment-form__title {
    padding: 16px 24px;
  }
}
.confirm-payment-form__header {
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 16px;
}
.confirm-payment-form__header-title {
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 8px;
}
.confirm-payment-form__header-subtitle {
  color: #717171;
  font-weight: 500;
}
.confirm-payment-form__current-payment-input {
  margin-top: -16px !important;
}
.confirm-payment-form__current-payment-input .MuiInputBase-input {
  color: #2e7d32 !important;
  font-weight: 600 !important;
}
.confirm-payment-form__current-payment-input .MuiInputLabel-root {
  color: #2e7d32 !important;
  font-weight: 600 !important;
}
.confirm-payment-form .MuiInputBase-root {
  width: 100% !important;
  max-width: 600px !important;
}
.confirm-payment-form {
  max-width: 340px;
  width: 100%;
}
.confirm-payment-form__content {
  padding: 32px;
}
@media (max-width: 768px) {
  .confirm-payment-form__content {
    padding: 24px;
  }
}
.confirm-payment-form__financial-summary {
  margin-bottom: 16px;
  margin-top: 0;
  border-radius: 0.5rem;
  border: 1px solid #f5f5f5;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.confirm-payment-form__financial-summary .MuiBox-root {
  padding: 16px;
}
@media (max-width: 768px) {
  .confirm-payment-form__financial-summary {
    margin-bottom: 16px;
  }
}
.confirm-payment-form__payment-details {
  margin-top: 24px;
  padding-left: 10%;
  padding-bottom: 5%;
  gap: 16px;
}
@media (max-width: 768px) {
  .confirm-payment-form__payment-details {
    padding-left: 0;
    gap: 12px;
  }
}
.confirm-payment-form__amount-to-charge .MuiInputBase-root, .confirm-payment-form__received-amount .MuiInputBase-root, .confirm-payment-form__change .MuiInputBase-root {
  font-size: 0.875rem;
  font-weight: 400;
  max-width: 260px;
  width: 100%;
  margin-right: 16px;
}
.confirm-payment-form__insufficient-warning {
  padding: 16px;
  background-color: #ffebee;
  border: 1px solid #ef5350;
  border-radius: 0.5rem;
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.confirm-payment-form__insufficient-warning .MuiTypography-root {
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 16px;
  border-bottom: 2px solid #1976d2;
  padding-bottom: 12px;
}
.confirm-payment-form__actions {
  padding: 24px 32px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
@media (max-width: 768px) {
  .confirm-payment-form__actions {
    padding: 16px 24px;
    flex-direction: column-reverse;
  }
  .confirm-payment-form__actions button {
    width: 100%;
  }
}
.confirm-payment-form__confirm-button, .confirm-payment-form__cancel-button {
  transition: all 0.3s ease;
}
.confirm-payment-form__confirm-button:hover:not(:disabled), .confirm-payment-form__cancel-button:hover:not(:disabled) {
  transform: translateY(-2px);
}
.confirm-payment-form__confirm-button:disabled, .confirm-payment-form__cancel-button:disabled {
  background: #bdbdbd;
  box-shadow: none;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.patient-hub-data-content__header-row {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  align-items: stretch !important;
}
.patient-hub-data-content__person-info {
  width: 100%;
  margin-bottom: 1rem;
}
.patient-hub-data-content__person-info #profile > div > div > div:first-child {
  margin: 0 auto;
}
.patient-hub-data-content__emergency-contact {
  width: 100%;
}
.patient-hub-data-content__emergency-contact .card-base {
  min-width: auto;
}
@media (min-width: 768px) {
  .patient-hub-data-content .patient-hub-data-content__header-row {
    flex-direction: row !important;
  }
  .patient-hub-data-content .patient-hub-data-content__emergency-contact {
    width: 20%;
  }
  .patient-hub-data-content .patient-hub-data-content__person-info {
    width: 80%;
    margin-bottom: 0;
    margin-right: 1rem;
  }
  .patient-hub-data-content .patient-hub-data-content__person-info #profile > div > div > div:first-child {
    margin: 0;
    margin: initial;
  }
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR. */
.docFormlogo {
  width: 200px !important;
  height: 200px !important;
}

.docFormErrorMessage {
  color: red !important;
  text-align: center;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.videochat-renderer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.videochat-renderer--maximized {
  border-radius: 0;
}
.videochat-renderer--guest {
  min-height: 100vh;
  height: 100vh;
}
@media (max-width: 768px) {
  .videochat-renderer--guest {
    min-height: 100vh;
    height: 100vh;
  }
}
.videochat-renderer--minimized {
  width: 100%;
  height: 100%;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.videochat-header {
  background-color: #343a40;
  color: #fff;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
}
.videochat-header--maximized {
  border-radius: 0;
}
.videochat-header.videochat-header--dark {
  background-color: #1a1a1a;
  border-bottom-color: #444;
}
.videochat-header__title-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.videochat-header__icon {
  width: 24px;
  height: 24px;
  fill: #fff;
}
.videochat-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.videochat-header__status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}
.videochat-header__status--connected {
  background-color: #4caf50;
}
.videochat-header__status--default {
  background-color: #757575;
}
.videochat-header__controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.videochat-header-button {
  color: #fff !important;
  padding: 12px !important;
}
.videochat-header-button:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.videochat-header-button svg {
  fill: #fff !important;
  stroke: #fff !important;
}

.videochat-guest-link {
  background-color: #f5f5f5;
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
}
.videochat-guest-link.videochat-guest-link--dark {
  background-color: #333;
  color: #fff;
}
.videochat-guest-link__label {
  font-weight: bold;
  display: flex;
  align-items: center;
}
.videochat-guest-link__content {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.videochat-guest-link__url {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  max-width: 300px;
  display: flex;
  align-items: center;
}
.videochat-guest-link__copy-button {
  padding: 4px !important;
  min-width: 28px !important;
  height: 28px !important;
  flex-shrink: 0;
  color: #333 !important;
}
.videochat-guest-link__copy-button:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.videochat-guest-link__copy-button.videochat-guest-link__copy-button--dark {
  color: #fff !important;
}
.videochat-guest-link__copy-button.videochat-guest-link__copy-button--dark:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.videochat-guest-link__copy-button.videochat-guest-link__copy-button--dark svg {
  fill: #fff !important;
}
.videochat-guest-link__copy-button svg {
  width: 16px;
  height: 16px;
  fill: #333;
}

.videochat-layout {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  min-height: 0;
}

.videochat-video-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
}

.videochat-main-video {
  flex: 1 1;
  position: relative;
  background-color: #000 !important;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
  min-height: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.videochat-main-video--no-controls {
  margin-bottom: 0;
}
.videochat-main-video--no-border {
  border-radius: 0;
}
.videochat-main-video--guest {
  min-height: calc(100vh - 200px);
  height: calc(100vh - 200px);
}
@media (max-width: 768px) {
  .videochat-main-video--guest {
    min-height: calc(100vh - 150px);
    height: calc(100vh - 150px);
  }
}
.videochat-main-video button svg {
  color: #fff !important;
}

.videochat-video-container {
  width: 100%;
  height: 100%;
  min-height: 150px;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.videochat-video-container--guest {
  min-height: calc(100vh - 250px);
  height: calc(100vh - 250px);
}
@media (max-width: 768px) {
  .videochat-video-container--guest {
    min-height: calc(100vh - 200px);
    height: calc(100vh - 200px);
  }
}

.videochat-participant-label {
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff !important;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 5;
}
.videochat-participant-label * {
  color: #fff !important;
}
.videochat-participant-label svg {
  font-size: 16px !important;
  color: #fff !important;
}
.videochat-participant-label span {
  color: #fff;
}

.videochat-participant-name {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff !important;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}
.videochat-participant-name * {
  color: #fff !important;
}
.videochat-participant-name span {
  color: #fff;
}

.videochat-swap-button {
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: #fff !important;
}
.videochat-swap-button:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.videochat-timer {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.videochat-status-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 2;
}
.videochat-status-message__icon {
  font-size: 48px !important;
  margin-bottom: 16px;
  color: #fff !important;
}
.videochat-status-message__text {
  font-size: 18px;
  font-weight: 500;
  margin-top: 8px;
  color: #fff;
}

.videochat-local-video {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 200px;
  height: 150px;
  z-index: 10;
}

.videochat-local-video-paper {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #333;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.videochat-local-video-container {
  width: 100%;
  height: 100%;
}

.videochat-local-video-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #9e9e9e;
  text-align: center;
}
.videochat-local-video-placeholder__icon {
  font-size: 32px !important;
  margin-bottom: 4px;
  color: #9e9e9e !important;
}
.videochat-local-video-placeholder__text {
  font-size: 12px;
  margin-top: 4px;
}

.videochat-local-video-label {
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.videochat-local-video-label span {
  color: #fff;
}

.videochat-controls {
  padding: 16px !important;
  background-color: #424242 !important;
  display: flex;
  justify-content: center;
  gap: 16px;
  border-radius: 0 0 8px 8px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .videochat-controls {
    padding: 12px !important;
    gap: 12px;
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 100;
  }
}
.videochat-controls--no-border {
  border-radius: 0;
}
.videochat-controls button svg {
  color: #fff !important;
}

.videochat-control-button {
  color: #fff !important;
}
.videochat-control-button.videochat-control-button--enabled {
  background-color: #9e9e9e !important;
}
.videochat-control-button.videochat-control-button--enabled:hover {
  background-color: #757575 !important;
}
.videochat-control-button.videochat-control-button--enabled-dark {
  background-color: #616161 !important;
}
.videochat-control-button.videochat-control-button--enabled-dark:hover {
  background-color: #424242 !important;
}
.videochat-control-button.videochat-control-button--disabled {
  background-color: #d32f2f !important;
}
.videochat-control-button.videochat-control-button--disabled:hover {
  background-color: #c62828 !important;
}
.videochat-control-button.videochat-control-button--success {
  background-color: #388e3c !important;
}
.videochat-control-button.videochat-control-button--success:hover {
  background-color: #2e7d32 !important;
}

.videochat-chat-toggle {
  position: relative;
  background-color: #9e9e9e !important;
  color: #fff !important;
}
.videochat-chat-toggle:hover {
  background-color: #757575 !important;
}
.videochat-chat-toggle.videochat-chat-toggle--dark {
  background-color: #616161 !important;
}
.videochat-chat-toggle.videochat-chat-toggle--dark:hover {
  background-color: #424242 !important;
}

.videochat-unread-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: #f44336 !important;
  color: #fff !important;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
}

.videochat-chat-panel {
  width: 350px;
  background-color: #fff;
  border-radius: 0 8px 8px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.videochat-chat-panel.videochat-chat-panel--dark {
  background-color: #1a1a1a;
}
.videochat-chat-panel--no-border {
  border-radius: 0;
}

.videochat-minimized-header {
  padding: 8px 12px;
  background-color: #343a40;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  min-height: 40px;
}
.videochat-minimized-header span {
  color: #fff;
}

.videochat-minimized-restore-button {
  color: #fff !important;
  padding: 4px !important;
  min-width: 24px !important;
  height: 24px !important;
}
.videochat-minimized-restore-button:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.videochat-minimized-restore-button span {
  color: #fff;
  font-size: 16px;
}

.videochat-minimized-video {
  flex: 1 1;
  position: relative;
  background-color: #333;
  overflow: hidden;
}

.videochat-minimized-video-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.videochat-minimized-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  font-size: 24px;
}
.videochat-minimized-placeholder__icon {
  margin-bottom: 8px;
  font-size: 48px !important;
  color: #fff !important;
}
.videochat-minimized-placeholder__text {
  font-size: 12px;
  margin-top: 8px;
  color: #fff;
}

.videochat-minimized-label {
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.videochat-minimized-label span {
  color: #fff;
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.guest-videochat-page {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.guest-videochat-page .videochat-renderer {
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.guest-videochat-page .videochat-video-section {
  flex: 1 1;
  min-height: 0;
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.guest-videochat-page .videochat-main-video {
  flex: 1 1;
  min-height: 0;
  max-height: calc(100vh - 150px);
  height: auto;
  overflow: hidden;
}
@media (max-width: 768px) {
  .guest-videochat-page .videochat-main-video {
    max-height: calc(100vh - 80px);
  }
}
.guest-videochat-page .videochat-controls {
  flex-shrink: 0;
  position: relative;
  bottom: auto;
}
@media (max-width: 768px) {
  .guest-videochat-page .videochat-controls {
    position: relative;
    bottom: auto;
  }
}
.guest-videochat-page .videochat-chat-panel {
  width: 350px;
  max-width: 100vw;
  min-height: 220px;
  max-height: calc(100vh - 60px);
  transition: width 0.2s, max-height 0.2s;
  overflow: auto;
}
@media (max-width: 820px) {
  .guest-videochat-page .videochat-chat-panel {
    max-height: calc(100vh - 24px);
  }
}
@media (max-width: 600px) {
  .guest-videochat-page .videochat-chat-panel {
    width: 100vw;
    min-width: 0;
    border-radius: 0 !important;
    max-height: 60vh;
  }
}
@media (max-width: 400px) {
  .guest-videochat-page .videochat-chat-panel {
    width: 100vw;
    min-width: 0;
    border-radius: 0 !important;
    max-height: 50vh;
  }
}

/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.accounting-movements-grid {
  align-items: stretch;
}
.accounting-movements-grid .grid-item-flex {
  display: flex;
  flex-direction: column;
}
.accounting-movements-grid .grid-item-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.accounting-movements-grid .grid-item-wrapper > * {
  height: 100%;
}
.accounting-movements-grid .buttons-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1rem;
}
@media (min-width: 900px) {
  .accounting-movements-grid .buttons-wrapper {
    gap: 2rem;
  }
}

/*Copyright (c) 2026 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2026 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2026 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2026 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.feedback-floating__button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  position: fixed;
  right: 2rem;
  bottom: 6rem;
  z-index: 99;
  cursor: pointer;
}
.feedback-floating__modal {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}
.feedback-floating__modal--light {
  background-color: #ffffff !important;
}
.feedback-floating__modal--dark {
  background-color: #1e2e4a !important;
}
.feedback-floating__header {
  padding: 16px;
}
.feedback-floating__header--light {
  border-bottom: 1px solid #e0e0e0;
}
.feedback-floating__header--dark {
  border-bottom: 1px solid #1e2e4a;
}
.feedback-floating__content {
  padding: 16px;
}
.feedback-floating__form-control {
  margin-bottom: 16px !important;
  margin-top: 8px !important;
}
.feedback-floating__form-title {
  margin-bottom: 16px !important;
}
.feedback-floating__radio-description {
  margin-left: 24px !important;
}
.feedback-floating__paste-hint {
  margin-top: 4px !important;
  display: block;
}
.feedback-floating__paste-icon {
  font-size: 14px;
  vertical-align: middle;
  margin-right: 4px;
}
.feedback-floating__images-section {
  margin-top: 16px;
}
.feedback-floating__images-title {
  margin-bottom: 8px !important;
}
.feedback-floating__images-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.feedback-floating__image-wrapper {
  position: relative;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: visible;
  width: 100px;
  height: 100px;
}
.feedback-floating__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.feedback-floating__image-remove {
  position: absolute !important;
  top: -8px !important;
  right: -8px !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  color: white !important;
  padding: 4px !important;
  min-width: 0 !important;
  min-width: initial !important;
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
}
.feedback-floating__image-remove:hover {
  background-color: rgba(211, 47, 47, 0.9) !important;
}
.feedback-floating__remove-icon {
  font-size: 14px !important;
}
.feedback-floating__actions {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.feedback-floating__actions--light {
  background-color: #ffffff !important;
}
.feedback-floating__actions--dark {
  background-color: #1e2e4a !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/components/_general.scss","webpack://./src/styles/components/_forms.scss","webpack://./src/styles/components/_appointmentCalendarView.scss","webpack://./src/styles/layouts/_kanban.container.scss","webpack://./src/styles/components/_notifications.scss","webpack://./src/styles/components/_AccountingMovementsTotals.scss","webpack://./src/styles/components/_HeaderPersonInformation.scss","webpack://./src/styles/components/generals/_AppointmentCard.scss","webpack://./src/styles/components/generals/_CallTimer.scss","webpack://./src/styles/components/generals/_Checkbox.scss","webpack://./src/styles/components/generals/_CustomSelect.scss","webpack://./src/styles/components/generals/_FormInput.scss","webpack://./src/styles/components/generals/_FormInputCheckbox.scss","webpack://./src/styles/components/generals/_FormInputPassword.scss","webpack://./src/styles/components/generals/_FormMultipleSelectChip.scss","webpack://./src/styles/components/generals/_FormPhoneInput.scss","webpack://./src/styles/components/generals/_FormSelectInput.scss","webpack://./src/styles/components/generals/_FormTextareaInput.scss","webpack://./src/styles/components/generals/_FormTextEditor.scss","webpack://./src/styles/components/generals/_HtmlTooltip.scss","webpack://./src/styles/components/generals/_IdCell.scss","webpack://./src/styles/components/generals/_Input.scss","webpack://./src/styles/components/generals/_LoadingOverlay.scss","webpack://./src/styles/components/generals/_MedicalAssetViewer.scss","webpack://./src/styles/components/generals/_OfficeDocumentRenderer.scss","webpack://./src/styles/components/generals/_PasswordRecoveryCard.scss","webpack://./src/styles/components/generals/_PDFVitalsUploader.scss","webpack://./src/styles/components/generals/_PercentageInput.scss","webpack://./src/styles/components/generals/_PricingExcelUpload.scss","webpack://./src/styles/components/generals/_SideNavarColor.scss","webpack://./src/styles/components/generals/_Switch.scss","webpack://./src/styles/components/generals/_TextMessagesChat.scss","webpack://./src/styles/components/widgets/_AppointmentWidget.scss","webpack://./src/styles/components/forms/_PatientHubForm.scss","webpack://./src/styles/components/forms/_GeneralSettingsForm.scss","webpack://./src/styles/components/views/_DocumentViewer.scss","webpack://./src/styles/components/views/_TemplateRecycleBinModal.scss","webpack://./src/styles/components/_progressNote.scss","webpack://./src/styles/components/forms/_BillingEncounterForm.scss","webpack://./src/styles/components/forms/_PaymentForm.scss","webpack://./src/styles/components/forms/_ConfirmPaymentForm.scss","webpack://./src/styles/components/content/_PatientHubDataContent.scss","webpack://./src/styles/components/forms/_DoctorForm.scss","webpack://./src/styles/components/_videochatRenderer.scss","webpack://./src/styles/components/_guestVideochatPage.scss","webpack://./src/styles/components/content/_AccountingMovementsDataContent.scss","webpack://./src/styles/components/global/_FeedbackFloating.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;8HAAA;AAKA;;;;kBAAA;ACLA;;;8HAAA;AAKA;;;;kBAAA;ADLA;;;8HAAA;AAKA;;;;kBAAA;AELA;;;8HAAA;AAKA;;;;kBAAA;AAQA;EACE,4BAAA;AFyBF;;AEtBA;EACE,yBAAA;EACA,mCAAA;EACA,2BAAA;EACA,oCAAA;EACA,sBAAA;EACA,qHACE;EAEF,iBAAA;EACA,aAAA;AFuBF;AErBE;EACE,aAAA;AFuBJ;;AEnBA;EACE,cAAA;AFsBF;AEpBE;EACE,8BAAA;EAAA,sBAAA;AFsBJ;AEnBE;EACE,WAAA;AFqBJ;AElBE;EACE,sBAAA;EACA,kBAAA;AFoBJ;AElBI;EACE,aAAA;AFoBN;AEjBI;EACE,kCAAA;EACA,mCAAA;AFmBN;AEfE;EACE,YAAA;EACA,WAAA;AFiBJ;AEbQ;EACE,eAAA;AFeV;AEVI;EACE,yBAAA;EACA,WAAA;AFYN;AEVM;EACE,yBAAA;EACA,WAAA;AFYR;AEPE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AFSJ;AERI;EACE,yBAAA;AFUN;AEPE;EACE,aAAA;EACA,yBAAA;AFSJ;AERI;EACE,gBAAA;AFUN;AENE;EAhEF;IAiEI,aAAA;EFSF;EEPE;IACE,qBAAA;IACA,cAAA;EFSJ;AACF;;AELA;EACE,gBAAA;AFQF;AENE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AFQJ;AENI;EACE,UAAA;EACA,SAAA;EACA,eAAA;AFQN;AELI;EACE,0BAAA;EACA,oCAAA;AFON;AEHI;EACE,sCAAA;AFKN;AEFI;EA1BF;IA2BI,UAAA;EFKJ;AACF;AEHI;EA9BF;IA+BI,UAAA;EFMJ;AACF;;AEDE;EACE,WAAA;AFIJ;;AEAA;EACE,aAAA;AFGF;;AECE;EACE,aAAA;AFEJ;AECE;EACE,cAAA;AFCJ;AEEM;EACE,aAAA;AFAR;;AEMA;EACE,sBAAA;EACA,6BAAA;AFHF;;AEMA;EACE,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AFHF;;AEOA;EACE,iBAAA;EACA,aAAA;AFJF;AEME;EACE,iBAAA;EACA,iBAAA;AFJJ;;AEQA;EACE;IACE,WAAA;EFLF;EEQA;IACE,6BAAA;EFNF;EESA;IACE,sBAAA;IACA,mBAAA;IACA,6BAAA;IACA,4BAAA;EFPF;EEUA;IACE,sBAAA;EFRF;AACF;AEgBA;EACE,iBD3MW;EC4MX,kBD5MW;AD8Lb;;AEiBA;EACE,kBD/MW;ECgNX,mBDhNW;ADkMb;;AEiBA;EACE,kBDnNW;ECoNX,mBDpNW;ADsMb;;AEiBA;EACE,kBDvNW;ECwNX,mBDxNW;AD0Mb;;AEiBA;EACE,kBD3NW;EC4NX,mBD5NW;AD8Mb;;AEkBA;EACE,gBDrOW;ECsOX,mBDtOW;ADuNb;;AEkBA;EACE,iBDzOW;EC0OX,oBD1OW;AD2Nb;;AEkBA;EACE,iBD7OW;EC8OX,oBD9OW;AD+Nb;;AEkBA;EACE,iBDjPW;ECkPX,oBDlPW;ADmOb;;AEkBA;EACE,iBDrPW;ECsPX,oBDtPW;ADuOb;;AEmBA;EACE,YD/PW;AD+Ob;;AEmBA;EACE,aDlQW;ADkPb;;AEmBA;EACE,aDrQW;ADqPb;;AEmBA;EACE,aDxQW;ADwPb;;AEmBA;EACE,aD3QW;AD2Pb;;AEwBA;EACE,kBDjRQ;AD4PV;;AEwBA;EACE,mBDpRQ;AD+PV;;AEwBA;EACE,eDtRU;ADiQZ;;AEwBA;EACE,mBDzRQ;ADoQV;;AEwBA;EACE,kBD5RQ;ADuQV;;AEwBA;EACE,iBD/RS;AD0QX;;AEwBA;EACE,mBDlSS;AD6QX;;AEwBA;EACE,kBDrSS;ADgRX;;AEyBA;EACE,gBDvSY;ADiRd;;AEyBA;EACE,gBD1SY;ADoRd;;AEyBA;EACE,gBD7Sc;ADuRhB;;AEyBA;EACE,gBDhTU;AD0RZ;;AE0BA;EACE,iBD7TS;EC8TT,gBDtTU;ECuTV,gBAAA;AFvBF;;AE0BA;EACE,kBDpUQ;ECqUR,gBD5TU;EC6TV,gBAAA;AFvBF;;AE0BA;EACE,mBD3UQ;EC4UR,gBDlUU;ECmUV,gBAAA;AFvBF;;AE0BA;EACE,eDlVU;ECmVV,gBDxUU;ECyUV,gBAAA;AFvBF;;AE0BA;EACE,mBD1VQ;EC2VR,gBDhVY;ECiVZ,cAAA;AFvBF;;AE0BA;EACE,mBDhWQ;ECiWR,gBDvVY;ECwVZ,gBAAA;AFvBF;;AE+BA;EACE,aDhXW;ECiXX,mBAAA;AF5BF;AE8BE;EAJF;IAKI,aDrXS;ED0VX;AACF;;AE8BA;EACE,aD1XW;AD+Vb;AE6BE;EAHF;IAII,kBAAA;EF1BF;AACF;;AE6BA;EACE,kBAAA;AF1BF;AE4BE;EAHF;IAII,kBAAA;EFzBF;AACF;;AE4BA;EACE,kBAAA;AFzBF;AE2BE;EAHF;IAII,kBAAA;EFxBF;AACF;;AEiCE;EACE,wBAAA;AF9BJ;AEgCI;EAHF;IAII,6BAAA;EF7BJ;AACF;AEgCE;EACE,wBAAA;AF9BJ;AEgCI;EAHF;IAII,6BAAA;EF7BJ;AACF;AEgCE;EACE,wBAAA;AF9BJ;AEgCI;EAHF;IAII,6BAAA;EF7BJ;AACF;AEgCE;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EAIA,+BAAA;EACA,oBAAA;AF9BJ;AEiCE;EACE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EAGA,cAAA;EAEA,uDAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AF/BJ;AEkCE;EAIE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EAGA,cAAA;EACA,UAAA;EACA,sBAAA;AFhCJ;AEmCE;EAIE,oBAAA;EACA,iCAAA;EACA,+BAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;AFjCJ;AEoCE;EACE,sBAAA;EACA,SAAA;EAGA,mBAAA;EAGA,gBAAA;EAIA,YAAA;EACA,qBAAA;AFlCJ;;AEsCA;EACE,kBAAA;AFnCF;;AAlgBA;;;8HAAA;AAKA;;;;kBAAA;AGLA;;;8HAAA;AAKA;;;;kBAAA;AASA;EACE,YFcW;AD2fb;AGvgBE;EAHF;IAII,YFUS;EDggBX;AACF;AGxgBE;EAPF;IAQI,YFKS;EDsgBX;AACF;;AGxgBA;EACE,sBAAA;EAIA,aAAA;EACA,2BAAA;EAGA,eAAA;EACA,WAAA;EAGA,mBAAA;EACA,gBAAA;EACA,wBAAA;EAIA,mBAAA;EACA,aAAA;EAGA,8BAAA;AH2gBF;AGxgBE;EA1BF;IA2BI,8BAAA;EH2gBF;AACF;AGxgBE;EA/BF;IAgCI,yBAAA;EH2gBF;AACF;AGvgBE;EArCF;IAsCI,yBAAA;EH0gBF;AACF;;AGtgBA;EACE,sBAAA;EACA,SAAA;EAGA,mBAAA;EAGA,gBAAA;EAIA,YAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AHygBF;;AGpgBE;EACE,kBAAA;AHugBJ;AGpgBE;EACE,kBFlES;ADwkBb;;AGlgBA;EACE,0BAAA;AHqgBF;;AGjgBA;EACE,oCAAA;AHogBF;;AGjgBA;EACE,sBAAA;EACA,SAAA;EAGA,mBAAA;EAGA,gBAAA;EAIA,YAAA;EACA,cAAA;EACA,gBAAA;AHogBF;;AGjgBA;EACE,aAAA;AHogBF;AGjgBE;EAJF;IAKI,2BAAA;EHogBF;AACF;AGjgBE;EATF;IAUI,2BAAA;IACA,iBAAA;EHogBF;AACF;AGjgBE;EAfF;IAgBI,yBAAA;EHogBF;AACF;;AGjgBA;EACE,wBAAA;EACA,oCAAA;AHogBF;AGlgBE;EACE;IACE,sCAAA;EHogBJ;EGjgBE;IACE,oCAAA;EHmgBJ;AACF;;AG/fA;EACE,gBAAA;AHkgBF;;AG9fE;EACE,mBAAA;AHigBJ;;AG5fE;EACE,qBAAA;AH+fJ;;AA1qBA;;;8HAAA;AAKA;;;;kBAAA;AILA;;;8HAAA;AAKA;;;;kBAAA;AASA;EACE,cHEqB;EGDrB,gBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AJirBF;;AI3qBE;EAEE,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;AJ6qBJ;AI1qBE;EAEE,qFAAA;EACA,gCAAA;EACA,4CAAA;AJ2qBJ;AIxqBE;EAEE,qFAAA;EACA,gCAAA;EACA,6CAAA;AJyqBJ;;AInqBE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AJsqBJ;AInqBE;;;EAGE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iEAAA;AJqqBJ;AI/pBI;;EAEE,aAAA;AJiqBN;AI3pBI;EACE,aAAA;AJ6pBN;;AIvpBE;EACE,wBAAA;AJ0pBJ;AIvpBE;EACE,mEAAA;EACA,gBAAA;EACA,sBAAA;AJypBJ;AIvpBI;EACE,UAAA;EACA,YAAA;AJypBN;AItpBI;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AJwpBN;AIppBQ;;EAEE,yBAAA;AJspBV;AIhpBE;EACE,YAAA;AJkpBJ;;AI9oBA;EACE,UAAA;AJipBF;;AI5oBE;EACE,yBAAA;AJ+oBJ;AI7oBI;EACE,yBAAA;AJ+oBN;AI3oBE;EACE,yBAAA;AJ6oBJ;AI3oBI;EACE,yBAAA;AJ6oBN;AIzoBE;EACE,yBAAA;AJ2oBJ;AIzoBI;EACE,yBAAA;AJ2oBN;AIvoBE;EACE,yBAAA;AJyoBJ;AIvoBI;EACE,yBAAA;AJyoBN;;AIloBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,yBH3JmB;EG4JnB,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AJqoBJ;AInoBI;EACE,yBAAA;AJqoBN;AIloBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AJooBN;AIhoBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cHpLkB;ADszBtB;AIhoBI;EACE,cHtLiB;ADwzBvB;AI/nBI;EACE,kBAAA;AJioBN;AI7nBE;EACE,SAAA;EACA,cAAA;EACA,mBAAA;AJ+nBJ;AI5nBE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AJ8nBJ;AI5nBI;EACE,sBAAA;AJ8nBN;;AIvnBE;EACE,gBAAA;EACA,aAAA;AJ0nBJ;AIvnBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AJynBJ;AItnBE;EACE,SAAA;AJwnBJ;AIrnBE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AJunBJ;AIpnBE;EACE,eAAA;EACA,uBAAA;AJsnBJ;AInnBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AJqnBJ;AIlnBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AJonBJ;AIjnBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AJmnBJ;AIjnBI;EACE,yBAAA;AJmnBN;AIjnBM;EACE,yBAAA;AJmnBR;AI/mBI;EACE,yBAAA;AJinBN;AI/mBM;EACE,yBAAA;AJinBR;AI7mBI;EACE,yBAAA;AJ+mBN;AI7mBM;EACE,yBAAA;AJ+mBR;AI3mBI;EACE,yBAAA;AJ6mBN;AI3mBM;EACE,yBAAA;AJ6mBR;AIxmBE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AJ0mBJ;AIxmBI;EACE,sBAAA;EACA,WAAA;AJ0mBN;AItmBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AJwmBJ;AItmBI;EALF;IAMI,gBAAA;EJymBJ;AACF;AIrmBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AJumBJ;AIpmBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AJsmBJ;AInmBE;EACE,aAAA;AJqmBJ;;AI/lBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AJkmBJ;AI/lBE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AJimBJ;AI9lBE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AJgmBJ;AI7lBE;EACE,SAAA;EACA,gBAAA;AJ+lBJ;AI5lBE;EACE,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,oBAAA;AJ8lBJ;AI3lBE;EACE,uBAAA;AJ6lBJ;;AIvlBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,oCAAA;EACA,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AJ0lBJ;AIxlBI;EACE,yBAAA;AJ0lBN;AIvlBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AJylBN;AIrlBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cH7ZkB;ADo/BtB;AIrlBI;EACE,iBAAA;AJulBN;AIplBI;EACE,cHnaiB;ADy/BvB;AInlBI;EACE,kBAAA;AJqlBN;AInlBM;EACE,iBAAA;AJqlBR;AIhlBE;EACE,SAAA;EACA,cAAA;EACA,mBAAA;AJklBJ;AI/kBE;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;AJilBJ;AI/kBI;EACE,sBAAA;AJilBN;;AI1kBE;EACE,kBAAA;AJ6kBJ;;AIvkBE;EACE,eAAA;EACA,0BAAA;EACA,mBAAA;AJ0kBJ;AIxkBI;EACE,+BAAA;AJ0kBN;;AInkBE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;AJskBJ;AInkBE;EACE,WAAA;AJqkBJ;;AI/jBE;EACE,WAAA;AJkkBJ;AI/jBE;EACE,WAAA;AJikBJ;AI9jBE;EACE,yBAAA;AJgkBJ;AI7jBE;EACE,yBAAA;AJ+jBJ;AI3jBI;EACE,WAAA;AJ6jBN;AI1jBI;EACE,WAAA;AJ4jBN;AIzjBI;EACE,yBAAA;AJ2jBN;AIxjBI;EACE,yBAAA;AJ0jBN;;AInjBE;EACE,gBAAA;EACA,iBAAA;AJsjBJ;AIpjBI;EAJF;IAKI,eAAA;IACA,eAAA;EJujBJ;AACF;;AInjBA;EACE,uBAAA;EACA,sBAAA;AJsjBF;;AInjBA;EACE,cAAA;AJsjBF;;AInjBA;EACE,WAAA;AJsjBF;AIpjBE;EAHF;IAII,YAAA;EJujBF;AACF;;AIpjBA;EACE,2BAAA;AJujBF;;AIljBI;EACE,aAAA;AJqjBN;AIjjBE;EACE;IACE,iCAAA;EJmjBJ;EI/iBI;IACE,aAAA;EJijBN;AACF;;AK3nCA;;;8HAAA;AAKA;;;;kBAAA;AAOE;EACE,gBAAA;AL2nCJ;AK1nCI;EACE,YAAA;AL4nCN;AK3nCM;EACE,WAAA;EACA,aAAA;AL6nCR;AK5nCQ;EACE,cAAA;AL8nCV;;AAlpCA;;;8HAAA;AAKA;;;;kBAAA;AMLA;;;8HAAA;AAKA;;;;kBAAA;AAQA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AN0pCF;AMzpCE;EACE,mBAAA;EACA,0CAAA;EACA,6DAAA;AN2pCJ;;AMvpCA;EACE,aLCW;EKAX,4BAAA;EACA,6BAAA;AN0pCF;AMzpCE;EACE,6DAAA;EACA,cAAA;EACA,yCAAA;AN2pCJ;AMzpCE;EACE,6DAAA;EACA,cAAA;AN2pCJ;;AMvpCA;EACE,0BAAA;EACA,2BAAA;AN0pCF;AMzpCE;EACE,cAAA;AN2pCJ;;AMtpCE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;ANypCJ;;AMppCE;EACE,yBAAA;ANupCJ;;AMnpCA;EACE,6BAAA;ANspCF;AMrpCE;EACE,cAAA;EACA,sCAAA;EACA,0CAAA;ANupCJ;AMtpCI;EACE,0CAAA;EACA,sCAAA;ANwpCN;AMrpCE;EACE,YAAA;EACA,sCAAA;EACA,oCAAA;ANupCJ;AMtpCI;EACE,oCAAA;EACA,sCAAA;ANwpCN;;AMnpCA;EACE,8BAAA;EACA,2BAAA;ANspCF;AMrpCE;EACE,cAAA;EACA,UAAA;ANupCJ;AMrpCE;EACE,cAAA;EACA,YAAA;ANupCJ;;AMnpCA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;ANspCF;;AMlpCE;EAGE,qDAAA;EACA,wBAAA;ANmpCJ;AMxpCA;EAOE,8BAAA;ANopCF;;AMjpCA;EACE,2BAAA;EACA,eAAA;EACA,yBAAA;ANopCF;AMnpCE;EACE,sBAAA;EACA,YAAA;ANqpCJ;AMnpCE;EACE,sCAAA;EACA,yCAAA;EACA,UAAA;ANqpCJ;AMnpCE;EACE,sDAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,qDAAA;EACA,sCAAA;ANspCN;AMnpCE;EACE,oCAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,uDAAA;EACA,mCAAA;ANspCN;AMnpCE;EACE,oCAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,oCAAA;EACA,sCAAA;ANspCN;AMnpCE;EACE,oCAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,oCAAA;EACA,mCAAA;ANspCN;AMnpCE;EACE,mDAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,+CAAA;EACA,sCAAA;ANspCN;AMnpCE;EACE,4DAAA;EACA,yBAAA;ANqpCJ;AMppCI;EACE,yBAAA;ANspCN;AMppCI;EACE,8DAAA;EACA,mCAAA;ANspCN;;AMjpCA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBL9KW;EK+KX,6BAAA;EACA,yBAAA;ANopCF;AMlpCE;EACE,4BAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;ANopCJ;AMjpCE;EACE,8BAAA;ANmpCJ;AMjpCE;EACE,YAAA;ANmpCJ;AMjpCE;EACE,UAAA;ANmpCJ;AMjpCE;EACE,UAAA;ANmpCJ;;AM/oCA;EACE,YAAA;EACA,+BAAA;ANkpCF;AMjpCE;EACE,mBAAA;ANmpCJ;AMjpCE;EACE,4BAAA;ANmpCJ;;AM/oCA;EACE,kBAAA;EACA,+BAAA;ANkpCF;;AMhpCA;EACE,6BAAA;EACA,YAAA;ANmpCF;;AMjpCA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ANopCF;AMlpCE;EACE,mBAAA;ANopCJ;AMlpCE;EACE,gBAAA;EACA,mBAAA;ANopCJ;;AMhpCA;EACE,wCAAA;ANmpCF;;AMjpCA;EACE,0DAAA;ANopCF;;AMjpCA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;ANopCF;AMlpCE;EACE,+BAAA;EACA,2BAAA;ANopCJ;;AMhpCA;EACE,eAAA;ANmpCF;;AM/oCA;EACE,qBAAA;EACA,6BAAA;EACA,2BAAA;EACA,wCAAA;EACA,6BAAA;EACA,gCAAA;ANkpCF;AMjpCE;EACE,yBAAA;ANmpCJ;AMhpCE;EACE,yBAAA;ANkpCJ;AM/oCE;EACE,yBAAA;ANipCJ;AM9oCE;EACE,yBAAA;ANgpCJ;;AM5oCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AN+oCF;;AM5oCA;EACE,iBAAA;AN+oCF;;AM5oCA;EACE,aAAA;AN+oCF;;AM5oCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AN+oCF;;AM5oCA;EACE,eAAA;EACA,kBAAA;AN+oCF;;AM5oCA;EACE,eAAA;AN+oCF;;AM5oCA;EACE,aL9TW;EK+TX,iBAAA;EACA,gBAAA;EACA,kBAAA;AN+oCF;AM7oCE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AN+oCJ;AM5oCE;EACE,UAAA;AN8oCJ;AM3oCE;EACE,+BAAA;EACA,kBAAA;AN6oCJ;AM1oCE;EACE,8BAAA;EACA,kBAAA;AN4oCJ;AM3oCI;EACE,8BAAA;AN6oCN;;AMxoCA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AN2oCF;;AMvoCE;EACE,kBAAA;EACA,gBAAA;AN0oCJ;;AO3gDA;;;8HAAA;AAKA;;;;kBAAA;AAOE;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AP2gDJ;;AQ5hDA;;;8HAAA;AAKA;;;;kBAAA;AAOE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AR4hDJ;AQzhDE;EACE,kBAAA;EACA,oBAAA;AR2hDJ;AQxhDE;EACE,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AR0hDJ;AQvhDE;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;ARyhDJ;;AQrhDA;EACE,6BAAA;ARwhDF;;AQrhDA;EACE,6BAAA;EACA,QAAA;EACA,UAAA;EACA,qDAAA;ARwhDF;AQthDE;EACE,oDAAA;ARwhDJ;;AQphDA;EACE,uBAAA;EACA,wBAAA;ARuhDF;;AAvlDA;;;8HAAA;AAKA;;;;kBAAA;ASLA;;;8HAAA;AAKA;;;;mBAAA;AAsCE;EACE,2CAAA;ATikDJ;AS9jDE;EACE,iDAAA;ATgkDJ;AS7jDE;EACE,iBAAA;EACA,gCAAA;EACA,sEAfa;AT8kDjB;AS7jDI;EACE,2BAAA;EACA,uEAlBiB;ATilDvB;AS3jDE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aRvCS;ADomDb;AS3jDI;EACE,oBR1CO;ADumDb;ASzjDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBRlDS;EQmDT,oBRnDS;EQoDT,QRtDS;ADinDb;ASxjDE;EACE,YAAA;EACA,mBRhDM;EQiDN,gBRvCQ;EQwCR,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AT0jDJ;ASvjDE;EACE,8BAAA;EACA,8BAAA;EACA,uBAAA;EACA,QRvES;EQwET,kBRxES;ADioDb;AStjDE;EACE,eRlEQ;EQmER,2BAAA;ATwjDJ;ASrjDE;EACE,oCAAA;ATujDJ;ASpjDE;EACE,uBAAA;ATsjDJ;ASnjDE;EACE,qCAAA;ATqjDJ;ASljDE;EACE,qCAAA;EACA,iBAAA;EACA,cAAA;ATojDJ;ASljDI;EACE,qCAAA;EACA,iBAAA;ATojDN;AShjDE;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;ATkjDJ;AShjDI;EACE,uBAAA;EACA,iBAAA;ATkjDN;AS9iDE;EACE,oCAAA;ATgjDJ;AS7iDE;EACE,oCAAA;AT+iDJ;AS5iDE;EACE,oCAAA;AT8iDJ;AS3iDE;EACE,oCAAA;AT6iDJ;AS1iDE;EACE,oCAAA;AT4iDJ;ASziDE;EACE,oCAAA;AT2iDJ;ASxiDE;EACE,oCAAA;AT0iDJ;ASviDE;EACE,oCAAA;ATyiDJ;AStiDE;EACE,8BAAA;EACA,mBAAA;EACA,QRrJS;EQsJT,kBRtJS;AD8rDb;ASriDE;EACE,mBRlJM;EQmJN,mBAAA;EACA,gBAAA;EACA,uBAAA;ATuiDJ;ASpiDE;EACE,eAAA;ATsiDJ;ASniDE;EACE,8BAAA;EACA,8BAAA;EACA,mBAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;ASliDE;EACE,oCAAA;ATqiDJ;;AUtwDA;;;8HAAA;AAKA;;;;kBAAA;AASA;EACE,uBAAA;EACA,oCAJ4B;EAK5B,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,iCAAA;AVowDF;;AWxxDA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,mBAAA;AXyxDJ;;AWtxDA;EACI,0BAAA;AXyxDJ;;AYzyDA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACC,8BAAA;AZ0yDD;;AatzDA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,gCAAA;AbuzDJ;;Acn0DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,mBAAA;Ado0DJ;;Acl0DA;EACI,sBAAA;Adq0DJ;;Aep1DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,oBAAA;EACA,sBAAA;Afq1DJ;;AgBl2DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,YAAA;AhBm2DJ;;AgBh2DA;EACI,aAAA;EACA,eAAA;EACA,WAAA;AhBm2DJ;;AiBr3DA;;;8HAAA;AAKA;;;;kBAAA;AAkBI;EACE,oCAAA;EACA,YAbsB;AjBu3D5B;AiBv2DI;EACE,oCAAA;EACA,uBAAA;EACA,mBAlB6B;AjB23DnC;AiBt2DI;EACE,4BAAA;AjBw2DN;;AiBj2DI;EACE,kCAAA;EACA,YA5BuB;AjBg4D7B;AiBl2DI;EACG,kCAAA;AjBo2DP;;AiB/1DA;EACE,sBAAA;AjBk2DF;;AkBv5DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,8BAAA;AlBw5DJ;;AkBr5DA;EACG,mBAAA;AlBw5DH;;AmBx6DA;;;8HAAA;AAKA;;;;kBAAA;AA6BA;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAbU;EAcV,yBAAA;EACA,+BAAA;AnBk5DF;AmBh5DE;EACE,qBAAA;AnBk5DJ;AmB/4DE;EACE,UAAA;EACA,qBAAA;EACA,6BAAA;AnBi5DJ;AmB94DE;EACE,UAAA;AnBg5DJ;AmB74DE;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;AnB+4DJ;AmB74DI;EACE,6BAAA;AnB+4DN;;AoBr9DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACE,WAAA;EACA,wBAAA;EACA,gBAAA;ApBs9DF;;AoBn9DA;EACE,aAAA;EACA,cAAA;ApBs9DF;;AqBz+DA;;;8HAAA;AAKA;;;;kBAAA;AAWE;EACE,yBAN2B;EAO3B,0BANqB;EAOrB,gBAAA;EACA,eAAA;EACA,yBAAA;ArBq+DJ;AqBn+DI;EACA,cAXiB;ArBg/DrB;;AsB7/DA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACE,gBAAA;AtB8/DF;;AuBzgEI;EACI,6DAAA;EACA,wCAAA;EACA,yDAAA;EAAA,iDAAA;AvB4gER;AuB1gEI;EAEI,sBAAA;AvB2gER;;AuBvgEI;EACI,6DAAA;EACA,wCAAA;EACA,yDAAA;EAAA,iDAAA;AvB0gER;AuBxgEI;EAEI,sBAAA;AvBygER;;AwB5hEA;;;8HAAA;AAKA;;;;kBAAA;AAUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAVmB;EAWnB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AxByhEF;AwBvhEE;EACE,cAjBY;AxB0iEhB;AwBthEE;EACE,cApBY;EAqBZ,gBAAA;EACA,eAAA;EACA,iBAAA;AxBwhEJ;;AyB5jEA;;;8HAAA;AAKA;;;;kBAAA;AAcA;EACE,WAAA;EACA,aAAA;AzBqjEF;AyBnjEE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AzBqjEJ;;AyBhjEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AzBmjEJ;AyBjjEI;EACE,kBAAA;EACA,oBAAA;AzBmjEN;AyBjjEM;EACE,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzBmjER;AyB/iEI;EACE,gBAAA;EACA,cA/CmB;AzBgmEzB;AyB7iEE;EACE,aAAA;AzB+iEJ;AyB5iEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;AzB8iEJ;AyB5iEI;EACE,UA/DQ;AzB6mEd;AyB3iEI;EACE,sBAAA;AzB6iEN;AyBziEE;EACE,gBAAA;AzB2iEJ;AyBxiEE;EACE,eAAA;EACA,gBAAA;AzB0iEJ;AyBviEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AzByiEJ;AyBviEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AzByiEN;AyBviEM;EACE,eAAA;EACA,cAhGa;AzByoErB;AyBriEQ;EACE,kBAAA;EACA,gBAAA;AzBuiEV;AyBpiEQ;EACE,mBAAA;EACA,cA1GQ;AzBgpElB;AyBjiEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AzBmiEN;AyB/hEE;EACE,gBAAA;AzBiiEJ;AyB/hEI;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAzHwB;AzB0pE9B;AyB7hEE;EACE,kBAAA;EACA,eAAA;EACA,yBA/H0B;EAgI1B,sBAAA;AzB+hEJ;AyB7hEI;EACE,kBAAA;EACA,cA1IY;EA2IZ,mBAAA;AzB+hEN;AyB5hEI;EACE,mBAAA;EACA,cAhJY;AzB8qElB;;A0BzrEA;;;8HAAA;AAKA;;;;kBAAA;AAQE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;A1BwrEJ;A0BrrEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;A1BurEJ;A0BrrEI;EACE,gBAAA;EACA,mBAAA;A1BurEN;A0BnrEE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAlCe;EAmCf,gCAAA;A1BqrEJ;A0BlrEE;EACE,SAAA;EACA,cAAA;EACA,yBAzCe;EA0Cf,aAAA;A1BorEJ;A0BlrEI;EACE,gBAAA;EACA,cAAA;EACA,yBA/Ca;EAgDb,gBAAA;A1BorEN;A0BlrEM;EACE,aAAA;EACA,iBAAA;A1BorER;A0BlrEQ;EACE,qBAAA;EACA,yBAxDS;A1B4uEnB;A0BhrEM;EACE,aAAA;A1BkrER;;A2BzvEA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACE,YAAA;EACA,uBAAA;A3B0vEF;A2BxvEI;EACE,gBAAA;A3B0vEN;A2BxvEI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;A3B0vEN;A2BvvEI;EACE,gBAAA;EACA,cAjBQ;EAkBR,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,0BAAA;A3ByvEN;A2BxvEM;EACE,0BAAA;A3B0vER;A2BtvEI;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;A3BwvEN;;A4BlyEA;;;8HAAA;AAKA;;;;kBAAA;AAUE;EACE,aAAA;A5B+xEJ;A4B5xEE;EACE,kBAAA;EACA,qBAVyB;EAWzB,kBAAA;A5B8xEJ;A4B3xEE;EACE,gBAAA;EACA,cAf+B;EAgB/B,aAAA;A5B6xEJ;;A6BzzEA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACI,iBAAA;A7B0zEJ;;A8Bt0EA;;;8HAAA;AAKA;;;;kBAAA;AASE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;A9Bo0EJ;A8Bj0EE;EACE,kBAAA;A9Bm0EJ;A8Bh0EE;EACE,6BAAA;EACA,kBAAA;A9Bk0EJ;A8B/zEE;EACE,iBAAA;EACA,kBAAA;A9Bi0EJ;A8B9zEE;EACE,iBAAA;A9Bg0EJ;A8B7zEE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;A9B+zEJ;A8B5zEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;A9B8zEJ;A8B3zEE;EACE,iBAAA;EACA,cA5CkB;A9By2EtB;A8B1zEE;EACE,eAAA;A9B4zEJ;A8BzzEE;EACE,qBAAA;EACA,oBAAA;EACA,SAAA;A9B2zEJ;A8BxzEE;EACE,eAAA;A9B0zEJ;A8BvzEE;EACE,WAAA;A9ByzEJ;A8BtzEE;EACE,kBAAA;EACA,uBAAA;A9BwzEJ;A8BrzEE;EACE,iBAAA;A9BuzEJ;A8BpzEE;EACE,iBAAA;A9BszEJ;;A+B34EA;;;8HAAA;AAKA;;;;kBAAA;AAqCA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,wCAAA;EACA,oDAAA;A/B62EF;A+B12EI;EACE,gCAAA;A/B42EN;A+Bz2EI;EACE,gCAAA;A/B22EN;A+Bp2EI;EACE,gCAAA;A/Bs2EN;A+Bn2EI;EACE,gCAAA;A/Bq2EN;A+Bj2EE;EACE,iBAAA;A/Bm2EJ;A+Bh2EE;EACE,yBA3DW;EA4DX,mDAAA;A/Bk2EJ;A+B/1EE;EACE,yBA3CQ;EA4CR,mDAAA;A/Bi2EJ;A+B91EE;EACE,yBA/DQ;EAgER,mDAAA;A/Bg2EJ;A+B71EE;EACE,yBAjEW;EAkEX,mDAAA;A/B+1EJ;A+B51EE;EACE,yBAnEW;EAoEX,mDAAA;A/B81EJ;A+B31EE;EACE,yBArES;EAsET,mDAAA;A/B61EJ;;AgCp8EA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACE,kBAAA;EACA,iBAAA;AhCq8EF;;AAl9EA;;;8HAAA;AAKA;;;;kBAAA;AiCLA;;;8HAAA;AAKA;;;;kBAAA;AAmDA;EACE,WAAA;EACA,uBAAA;EACA,oCAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,yBAAA;AjC+6EF;AiC76EE;EACE,oCAAA;EACA,yCAAA;EACA,yBAAA;AjC+6EJ;AiC76EI;EACE,yBAAA;AjC+6EN;AiC36EE;EACE,ahCjDS;EgCkDT,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;AjC66EJ;AiC36EI;EACE,oCAAA;EACA,wCAAA;AjC66EN;AiCz6EE;EACE,aAAA;EACA,mBAAA;EACA,QhCpES;AD++Eb;AiCx6EE;EACE,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,0BAAA;AjC06EJ;AiCv6EE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AjCy6EJ;AiCt6EE;EACE,yBAAA;EACA,YAAA;AjCw6EJ;AiCt6EI;EACE,qDAAA;AjCw6EN;AiCr6EI;EACE,yBAAA;EACA,wBAAA;AjCu6EN;AiCn6EE;EACE,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,0BAAA;AjCq6EJ;AiCl6EE;EACE,yBAAA;EACA,eAAA;AjCo6EJ;AiCj6EE;EACE,cAAA;AjCm6EJ;AiCj6EI;EACE,oCAxGe;EAyGf,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AjCm6EN;AiCh6EI;EACE,yBAhHgB;AjCkhFtB;AiC95EE;EACE,yBAAA;EACA,YAAA;AjCg6EJ;AiC95EI;EACE,qDAAA;AjCg6EN;AiC75EI;EACE,yBAAA;EACA,wBAAA;AjC+5EN;AiC35EE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;AjC65EJ;AiC35EI;EACE,oCAAA;EACA,yBAAA;AjC65EN;AiCz5EE;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AjC25EJ;AiCz5EI;EACE,yBAAA;AjC25EN;AiCv5EE;EACE,eAAA;EACA,yBAAA;AjCy5EJ;AiCv5EI;EACE,yBAAA;AjCy5EN;AiCr5EE;EACE,eAAA;EACA,yBAAA;AjCu5EJ;AiCr5EI;EACE,yBAAA;AjCu5EN;AiCn5EE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AjCq5EJ;AiCn5EI;EACE,qBAAA;EACA,oBAAA;AjCq5EN;AiCl5EI;EACE,uBAAA;EACA,sBAAA;AjCo5EN;AiCh5EE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;AjCk5EJ;AiCh5EI;EACE,oCAAA;EACA,iCAAA;AjCk5EN;AiC/4EI;EACE,oCAAA;EACA,iCAAA;AjCi5EN;AiC74EE;EACE,eAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AjC+4EJ;AiC74EI;EACE,yBAAA;AjC+4EN;AiC34EE;EACE,yBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AjC64EJ;AiC34EI;EACE,yBAAA;AjC64EN;AiCz4EE;EACE,aAAA;EACA,6BAAA;EACA,oCAAA;EACA,oBAAA;AjC24EJ;AiCz4EI;EANF;IAOI,oBAAA;EjC44EJ;AACF;AiC14EI;EACE,0BAAA;EACA,oCAAA;AjC44EN;AiCx4EE;EACE,aAAA;EACA,QAAA;EACA,qBAAA;AjC04EJ;AiCt4EI;EACE,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,sBAAA;AjCw4EN;AiCt4EM;EACE,oCAAA;EACA,yBAAA;AjCw4ER;AiCr4EM;EACE,gCAAA;AjCu4ER;AiCr4EQ;EACE,gCAAA;AjCu4EV;AiCn4EM;EACE,gCAAA;AjCq4ER;AiCn4EQ;EACE,gCAAA;AjCq4EV;AiCj4EM;EACE,gCAAA;AjCm4ER;AiC/3EI;EACE,kBAAA;EACA,sBAAA;AjCi4EN;AiC/3EM;EACE,yBAAA;AjCi4ER;AiC93EM;EACE,yBAAA;EACA,qBAAA;AjCg4ER;AiC93EQ;EACE,yBAAA;AjCg4EV;AiC13EE;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AjC43EJ;AiC13EI;EACE,oCAAA;AjC43EN;AiCz3EI;EACE,oCAAA;AjC23EN;AiCz3EM;EACE,oCAAA;AjC23ER;AiCv3EI;EACE,oCAAA;AjCy3EN;AiCv3EM;EACE,oCAAA;AjCy3ER;AiCp3EE;EACE,eAAA;EACA,yBAAA;AjCs3EJ;;AArvFA;;;8HAAA;AAKA;;;;kBAAA;AkCLA,gHAAA;AAKE;EACE,cAAA;EACA,kBjCmBS;AD0uFb;AkC1vFE;EACE,gBjCgBS;EiCfT,iBjCeS;AD6uFb;;AAxwFA;;;8HAAA;AAKA;;;;kBAAA;AmCLA;;;8HAAA;AAKA;;;;mBAAA;AASE;EACE,mBlCsBM;EkCrBN,gBlC+BQ;EkC9BR,gBlCWS;ADowFb;AmC5wFE;EACE,elCeQ;EkCdR,gBlCyBQ;ADqvFZ;;AApyFA;;;8HAAA;AAKA;;;;kBAAA;AoCLA;;;8HAAA;AAKA;;;;mBAAA;AASI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;ApC2yFR;AoCzyFQ;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;ApC2yFZ;AoCvyFI;EACI,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;ApCyyFR;AoCtyFI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;ApCwyFR;AoCryFI;EACI,YAAA;EACA,eAAA;ApCuyFR;AoCpyFI;EACI,SAAA;ApCsyFR;AoCnyFI;EACI,gBAAA;EACA,mBAAA;ApCqyFR;AoClyFI;EACI,aAAA;EACA,mBAAA;ApCoyFR;AoCjyFI;EACI,gBAAA;ApCmyFR;;AoC9xFI;EACI,4BAAA;EACA,2BAAA;EACA,kBAAA;ApCiyFR;AoC9xFI;EACI,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;ApCgyFR;;AAh3FA;;;8HAAA;AAKA;;;;kBAAA;AqCLA,gHAAA;AAKE;EACE,0BAAA;EACA,2BAAA;ArCw3FJ;AqCr3FE;EACE,0BAAA;EACA,2BAAA;ArCu3FJ;;AAn4FA;;;8HAAA;AAKA;;;;kBAAA;AsCLA;;;8HAAA;AAKA;;;;kBAAA;AASE;EACE,yBAAA;AtC04FJ;AsCx4FI;EACE,yBAAA;AtC04FN;AsCt4FE;EACE,mBrCGS;ADq4Fb;AsCr4FE;EACE,arCES;ADq4Fb;AsCr4FI;EAHF;IAII,arCFO;ED04FX;AACF;AsCr4FE;EACE,kBAAA;EACA,iBrCNS;EqCOT,oBrCPS;AD84Fb;AsCp4FE;EACE,arCbS;EqCcT,cAAA;AtCs4FJ;AsCp4FI;EAJF;IAKI,arClBO;IqCmBP,cAAA;EtCu4FJ;AACF;AsCp4FE;EACE,4BAAA;AtCs4FJ;AsCp4FI;EACE,eAAA;AtCs4FN;;AA57FA;;;8HAAA;AAKA;;;;kBAAA;AuCLA;;;8HAAA;AAKA;;;;kBAAA;AASA;EACE,atCcW;ADq7Fb;;AuC77FI;EACE,0BAAA;EACA,4BAAA;AvCg8FN;AuC77FI;EACE,0BAAA;EACA,gBtCiBQ;AD86Fd;AuC57FI;EACE,8BAAA;EACA,6BAAA;AvC87FN;AuC57FM;EACE,qCAAA;AvC87FR;AuC37FM;EACE,gDAAA;AvC67FR;;AuCt7FA;EACE,mBtCnBW;EsCoBX,atCrBW;EsCsBX,kBAAA;EACA,yBAAA;AvCy7FF;AuCv7FE;EACE,8BAAA;EACA,2BAAA;EACA,8BAAA;AvCy7FJ;AuCt7FE;EACE,0BAAA;EACA,gBAAA;AvCw7FJ;;AuCl7FE;EACE,atCxCS;AD69Fb;;AuC/6FE;EACE,gBtC/CS;EsCgDT,mBtChDS;ADk+Fb;AuC/6FE;EACE,8BAAA;EACA,gBtCpCU;ADq9Fd;;AuC56FA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AvC+6FF;AuC76FE;EACE,8BAAA;EACA,gBtC/CY;EsCgDZ,WAAA;AvC+6FJ;AuC56FE;EACE,6BAAA;EACA,WAAA;AvC86FJ;;AuCx6FE;EACE,mBtC9ES;ADy/Fb;;AuCr6FE;EACE,mBtCrFS;AD6/Fb;;AuCl6FE;EACE,6BAAA;AvCq6FJ;AuCl6FE;EACE,8BAAA;EACA,wBAAA;EACA,gCAAA;AvCo6FJ;AuCl6FI;EACE,mBAAA;AvCo6FN;;AuC95FA;EACE,aAAA;EACA,StC5GW;AD6gGb;AuC/5FE;EACE,SAAA;AvCi6FJ;AuC95FE;EACE,SAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AvCg6FJ;;AuC15FA;EACE;IACE,sBAAA;EvC65FF;EuC35FE;IACE,gBAAA;IACA,gBAAA;EvC65FJ;AACF;AA/jGA;;;8HAAA;AAKA;;;;kBAAA;AwCLA;;;8HAAA;AAKA;;;;mBAAA;AAQI;EACI,yBAAA;EACA,avCYK;EuCXL,8BAAA;EACA,qBvCkCW;ADoiGnB;AwCnkGI;EACI,mBAAA;AxCqkGR;AwClkGI;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AxCokGR;;AwChkGA;EACI,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EAIA,gCAAA;EACA,oBAAA;AxCmkGJ;;AA9mGA;;;8HAAA;AAKA;;;;kBAAA;AyCLA;;;8HAAA;AAKA;;;;mBAAA;AAQI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,MAAA;AzCsnGR;AyCnnGQ;EATJ;IAUQ,sBAAA;IACA,gBAAA;EzCsnGV;AACF;AyCnnGI;EACI,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,axCHK;EwCIL,yBxCnBW;ADwoGnB;AyCnnGQ;EAPJ;IAQQ,cAAA;IACA,kBAAA;IACA,gCAAA;IACA,gBAAA;IACA,gBAAA;EzCsnGV;AACF;AyCpnGQ;EAfJ;IAgBQ,axChBC;EDuoGX;AACF;AyCpnGI;EACI,aAAA;EACA,gBAAA;EACA,axCtBK;AD4oGb;AyCpnGQ;EALJ;IAMQ,cAAA;IACA,gBAAA;EzCunGV;AACF;AyCrnGQ;EAVJ;IAWQ,axC/BC;EDupGX;AACF;AyCrnGI;EACI,mBxCpCK;EwCqCL,oBxCtCK;EwCuCL,gCAAA;AzCunGR;AyCrnGQ;EALJ;IAMQ,mBxC1CC;EDkqGX;AACF;AyCrnGI;EACI,mBxC9CK;EwC+CL,axChDK;EwCiDL,yBAAA;EACA,qBxC1BW;EwC2BX,mBxC5CE;EwC6CF,gBAAA;AzCunGR;AyCrnGQ;EARJ;IASQ,mBxCvDC;IwCwDD,kBxClDF;ED0qGR;AACF;AyCrnGI;EACI,mBxC5DK;ADmrGb;AyCrnGQ;EAHJ;IAIQ,mBxChEC;EDwrGX;AACF;AyCrnGI;EACI,mBxCpEK;EwCqEL,wCAAA;EACA,qBxC/CW;EwCgDX,gBAAA;AzCunGR;AyCrnGQ;EANJ;IAOQ,mBxC3EC;EDmsGX;AACF;AyCrnGI;EACI,eAAA;EACA,iCAAA;AzCunGR;AyCrnGQ;EACI,yBAAA;AzCunGZ;AyCpnGQ;EACI,oCAAA;AzCsnGZ;AyCpnGY;EACI,oCAAA;AzCsnGhB;AyCjnGI;EACI,gBxC9EQ;EwC+ER,mBxC3FE;EwC4FF,kBAAA;EACA,gBAAA;AzCmnGR;AyCjnGQ;EANJ;IAOQ,kBxCjGF;EDqtGR;AACF;AyCjnGI;EACI,kBxCtGE;EwCuGF,WAAA;EACA,gBAAA;AzCmnGR;AyChnGI;EACI,gBxC/FQ;EwCgGR,mBxC5GE;AD8tGV;AyChnGQ;EAJJ;IAKQ,kBxChHF;EDmuGR;AACF;AyChnGI;EACI,kBxCrHE;EwCsHF,WAAA;EACA,kBAAA;EACA,gBAAA;AzCknGR;AyC/mGI;EACI,gBxCjIK;EwCkIL,axClIK;EwCmIL,sBxClJM;EwCmJN,qBxC7GW;EwC8GX,wCAAA;EACA,8BAAA;AzCinGR;AyC/mGQ;EARJ;IASQ,gBxC1IC;IwC2ID,axC3IC;ED6vGX;AACF;AyC/mGI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SxCnJK;ADowGb;AyC/mGQ;EANJ;IAOQ,sBAAA;IACA,uBAAA;IACA,QxCzJC;ED2wGX;AACF;AyC/mGI;EACI,gBxC1IQ;EwC2IR,mBxCvJE;ADwwGV;AyC/mGQ;EAJJ;IAKQ,kBxC3JF;ED6wGR;AACF;AyC/mGI;EACI,gBxClJI;EwCmJJ,kBxC5JE;EwC6JF,cAAA;AzCinGR;AyC/mGQ;EALJ;IAMQ,mBxCjKF;EDmxGR;AACF;AyC/mGI;EACI,kBAAA;EACA,axC9KK;EwC+KL,WAAA;EACA,kBAAA;AzCinGR;;AyC3mGI;EACI,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AzC8mGR;AyC5mGQ;EANJ;IAOQ,YAAA;IACA,gBAAA;IACA,WAAA;EzC+mGV;AACF;;AA70GA;;;8HAAA;AAKA;;;;kBAAA;A0CLA;;;8HAAA;AAKA;;;;mBAAA;AAUQ;EACI,mBzCoCO;EyCnCP,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;A1Cm1GZ;A0C/0GI;EACI,kBAAA;EACA,gCAAA;A1Ci1GR;A0C/0GQ;EACI,gBAAA;EACA,SAAA;A1Ci1GZ;A0C90GQ;EATJ;IAUQ,kBAAA;E1Ci1GV;AACF;A0C90GI;EACI,eAAA;EACA,gCAAA;EACA,mBzCbK;AD61Gb;A0C90GQ;EACI,gBAAA;EACA,cAAA;EACA,kBzCpBC;ADo2Gb;A0C70GQ;EACI,czCnCM;EyCoCN,gBAAA;A1C+0GZ;A0C30GI;EACI,4BAAA;A1C60GR;A0C30GQ;EACI,yBAAA;EACA,2BAAA;A1C60GZ;A0C10GQ;EACI,yBAAA;EACA,2BAAA;A1C40GZ;A0Cx0GI;EACI,sBAAA;EACA,2BAAA;A1C00GR;A0Cp4GA;EA6DI,gBAAA;EACA,WAAA;A1C00GJ;A0Cx0GI;EACI,azChDK;AD03Gb;A0Cx0GQ;EAHJ;IAIQ,azCpDC;ED+3GX;AACF;A0Cx0GI;EACI,mBzC1DK;EyC2DL,aAAA;EACA,qBzCrCW;EyCsCX,yBAAA;EACA,yCAAA;A1C00GR;A0Cx0GQ;EACI,azCjEC;AD24Gb;A0Cv0GQ;EAXJ;IAYQ,mBzCrEC;ED+4GX;AACF;A0Cv0GI;EACI,gBzCzEK;EyC0EL,iBAAA;EACA,kBAAA;EACA,SzC7EK;ADs5Gb;A0Cv0GQ;EANJ;IAOQ,eAAA;IACA,SzClFC;ED45GX;AACF;A0Cp0GQ;EACI,mBzCnFF;EyCoFE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBzC7FC;ADm6Gb;A0Cl0GI;EACI,azClGK;EyCmGL,yBAAA;EACA,yBAAA;EACA,qBzC9EW;EyC+EX,gBzCtGK;EyCuGL,aAAA;EACA,mBAAA;EACA,SzC1GK;AD86Gb;A0Cl0GQ;EACI,gBAAA;EACA,ezCrGA;EyCsGA,mBzC9GC;EyC+GD,gCAAA;EACA,oBzCjHC;ADq7Gb;A0Ch0GI;EACI,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SzCzHK;AD27Gb;A0Ch0GQ;EAPJ;IAQQ,kBAAA;IACA,8BAAA;E1Cm0GV;E0Cj0GU;IACI,WAAA;E1Cm0Gd;AACF;A0C/zGI;EAEI,yBAAA;A1Cg0GR;A0C9zGQ;EACI,2BAAA;A1Cg0GZ;A0C7zGQ;EACI,mBAAA;EACA,gBAAA;A1C+zGZ;;AA1+GA;;;8HAAA;AAKA;;;;kBAAA;A2CLA;;;8HAAA;AAKA;;;;kBAAA;AASE;EACE,wBAAA;EACA,iCAAA;EACA,yCAAA;EACA,+BAAA;A3Ci/GJ;A2C9+GE;EACE,WAAA;EACA,mBAAA;A3Cg/GJ;A2C/+GI;EACE,cAAA;A3Ci/GN;A2C7+GE;EACE,WAAA;A3C++GJ;A2C9+GI;EACE,eAAA;A3Cg/GN;A2C5+GE;EAEI;IACE,8BAAA;E3C6+GN;E2C1+GI;IACE,UAAA;E3C4+GN;E2Cz+GI;IACE,UAAA;IACA,gBAAA;IACA,kBAAA;E3C2+GN;E2C1+GM;IACE,SAAA;IAAA,eAAA;E3C4+GR;AACF;;A4ChiHA;;;8HAAA;AAKA;;;;mBAAA;AAMA;EAEI,uBAAA;EACA,wBAAA;A5CgiHJ;;A4C9hHA;EAEI,qBAAA;EACA,kBAAA;A5CgiHJ;;AAnjHA;;;8HAAA;AAKA;;;;kBAAA;A6CLA;;;8HAAA;AAKA;;;;kBAAA;AASA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;A7C0jHF;A6CxjHE;EACE,gBAAA;A7C0jHJ;A6CvjHE;EACE,iBAAA;EACA,aAAA;A7CyjHJ;A6CvjHI;EAJF;IAKI,iBAAA;IACA,aAAA;E7C0jHJ;AACF;A6CvjHE;EACE,WAAA;EACA,YAAA;EACA,sB5C3BU;E4C4BV,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;A7CyjHJ;;A6CpjHA;EACE,yBAAA;EACA,W5CrCY;E4CsCZ,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;A7CujHF;A6CrjHE;EACE,gBAAA;A7CujHJ;A6CpjHE;EACE,yBAAA;EACA,yBAAA;A7CsjHJ;A6CnjHE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A7CqjHJ;A6CljHE;EACE,WAAA;EACA,YAAA;EACA,U5C/DU;ADmnHd;A6CjjHE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,W5CtEU;ADynHd;A6ChjHE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,W5C9EU;ADgoHd;A6ChjHI;EACE,yBAAA;A7CkjHN;A6C/iHI;EACE,yBAAA;A7CijHN;A6C7iHE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A7C+iHJ;;A6C3iHA;EACE,sBAAA;EACA,wBAAA;A7C8iHF;A6C5iHE;EACE,qDAAA;A7C8iHJ;A6C3iHE;EACE,qBAAA;EACA,uBAAA;A7C6iHJ;;A6CxiHA;EACE,yBAAA;EACA,iBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;A7C2iHF;A6CziHE;EACE,sBAAA;EACA,W5C3HU;ADsqHd;A6CxiHE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;A7C0iHJ;A6CviHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;A7CyiHJ;A6CtiHE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;A7CwiHJ;A6CriHE;EACE,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;A7CuiHJ;A6CriHI;EACE,+CAAA;A7CuiHN;A6CpiHI;EACE,sBAAA;A7CsiHN;A6CpiHM;EACE,qDAAA;A7CsiHR;A6CniHM;EACE,qBAAA;A7CqiHR;A6CjiHI;EACE,WAAA;EACA,YAAA;EACA,UAAA;A7CmiHN;;A6C7hHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;A7CgiHF;;A6C7hHA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;A7CgiHF;;A6C5hHA;EACE,SAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;A7C+hHF;A6C7hHE;EACE,gBAAA;A7C+hHJ;A6C5hHE;EACE,gBAAA;A7C8hHJ;A6C3hHE;EACE,+BAAA;EACA,2BAAA;A7C6hHJ;A6C3hHI;EAJF;IAKI,+BAAA;IACA,2BAAA;E7C8hHJ;AACF;A6C3hHE;EACE,sBAAA;A7C6hHJ;;A6CzhHA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A7C4hHF;A6C1hHE;EACE,+BAAA;EACA,2BAAA;A7C4hHJ;A6C1hHI;EAJF;IAKI,+BAAA;IACA,2BAAA;E7C6hHJ;AACF;;A6CxhHA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;A7C2hHF;A6CzhHE;EACE,sBAAA;A7C2hHJ;A6CxhHE;EACE,0BAAA;EACA,sBAAA;A7C0hHJ;A6CvhHE;EACE,W5CvRU;ADgzHd;;A6CrhHA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;A7CwhHF;A6CthHE;EACE,sBAAA;A7CwhHJ;A6CrhHE;EACE,W5C3SU;ADk0Hd;;A6CnhHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+CAAA;EACA,sBAAA;A7CshHF;A6CphHE;EACE,+CAAA;A7CshHJ;;A6ClhHA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;A7CqhHF;;A6CjhHA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,W5C1UY;E4C2UZ,UAAA;A7CohHF;A6ClhHE;EACE,0BAAA;EACA,mBAAA;EACA,sBAAA;A7CohHJ;A6CjhHE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,W5CvVU;AD02Hd;;A6C9gHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;A7CihHF;;A6C9gHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;A7CihHF;;A6C9gHA;EACE,WAAA;EACA,YAAA;A7CihHF;;A6C9gHA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;A7CihHF;A6C/gHE;EACE,0BAAA;EACA,kBAAA;EACA,yBAAA;A7CihHJ;A6C9gHE;EACE,eAAA;EACA,eAAA;A7CghHJ;;A6C5gHA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,W5C/YY;E4CgZZ,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A7C+gHF;A6C7gHE;EACE,W5C1ZU;ADy6Hd;;A6C1gHA;EACE,wBAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,0BAAA;EACA,eAAA;A7C6gHF;A6C3gHE;EATF;IAUI,wBAAA;IACA,SAAA;IACA,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,YAAA;E7C8gHF;AACF;A6C5gHE;EACE,gBAAA;A7C8gHJ;A6C3gHE;EACE,sBAAA;A7C6gHJ;;A6CzgHA;EACE,sBAAA;A7C4gHF;A6C1gHE;EACE,oCAAA;A7C4gHJ;A6C1gHI;EACE,oCAAA;A7C4gHN;A6CxgHE;EACE,oCAAA;A7C0gHJ;A6CxgHI;EACE,oCAAA;A7C0gHN;A6CtgHE;EACE,oCAAA;A7CwgHJ;A6CtgHI;EACE,oCAAA;A7CwgHN;A6CpgHE;EACE,oCAAA;A7CsgHJ;A6CpgHI;EACE,oCAAA;A7CsgHN;;A6CjgHA;EACE,kBAAA;EACA,oCAAA;EACA,sBAAA;A7CogHF;A6ClgHE;EACE,oCAAA;A7CogHJ;A6CjgHE;EACE,oCAAA;A7CmgHJ;A6CjgHI;EACE,oCAAA;A7CmgHN;;A6C9/GA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;A7CigHF;;A6C7/GA;EACE,YAAA;EACA,sB5ClgBY;E4CmgBZ,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;A7CggHF;A6C9/GE;EACE,yBAAA;A7CggHJ;A6C7/GE;EACE,gBAAA;A7C+/GJ;;A6C1/GA;EACE,iBAAA;EACA,yBAAA;EACA,W5CrhBY;E4CshBZ,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A7C6/GF;A6C3/GE;EACE,W5C9hBU;AD2hId;;A6Cz/GA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;A7C4/GF;A6C1/GE;EACE,qDAAA;A7C4/GJ;A6Cz/GE;EACE,W5C7iBU;E4C8iBV,eAAA;A7C2/GJ;;A6Cv/GA;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;A7C0/GF;;A6Cv/GA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A7C0/GF;;A6Cv/GA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,W5CvkBY;E4CwkBZ,eAAA;A7C0/GF;A6Cx/GE;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;A7C0/GJ;A6Cv/GE;EACE,eAAA;EACA,eAAA;EACA,W5CnlBU;AD4kId;;A6Cr/GA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,W5C7lBY;E4C8lBZ,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A7Cw/GF;A6Ct/GE;EACE,W5CxmBU;ADgmId;;AA7mIA;;;8HAAA;AAKA;;;;kBAAA;A8CLA;;;8HAAA;AAKA;;;;kBAAA;AAUA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;A9CmnIJ;A8ChnII;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;A9CknIR;A8C9mII;EACI,SAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;A9CgnIR;A8C5mII;EACI,SAAA;EACA,aAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;A9C8mIR;A8C5mIQ;EAPJ;IAQQ,8BAAA;E9C+mIV;AACF;A8C3mII;EACI,cAAA;EACA,kBAAA;EACA,YAAA;A9C6mIR;A8C3mIQ;EALJ;IAMQ,kBAAA;IACA,YAAA;E9C8mIV;AACF;A8C3mII;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,uCAAA;EACA,cAAA;A9C6mIR;A8C3mIQ;EARJ;IASQ,8BAAA;E9C8mIV;AACF;A8C5mIQ;EAZJ;IAaQ,YAAA;IACA,YAAA;IACA,2BAAA;IACA,gBAAA;E9C+mIV;AACF;A8C7mIQ;EAnBJ;IAoBQ,YAAA;IACA,YAAA;IACA,2BAAA;IACA,gBAAA;E9CgnIV;AACF;;A+C1sIA;;;8HAAA;AAKA;;;;kBAAA;AAMA;EACE,oBAAA;A/C2sIF;A+CzsIE;EACE,aAAA;EACA,sBAAA;A/C2sIJ;A+CxsIE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;A/C0sIJ;A+CxsII;EACE,YAAA;A/C0sIN;A+CtsIE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,SAAA;A/CwsIJ;A+CtsII;EAPF;IAQI,SAAA;E/CysIJ;AACF;;AgD/uIA;;;8HAAA;AAKA;;;;kBAAA;AAQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AhD8uIJ;AgD1uIE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AhD4uIJ;AgD1uII;EACE,oCAAA;AhD4uIN;AgDzuII;EACE,oCAAA;AhD2uIN;AgDtuIE;EACE,aAAA;AhDwuIJ;AgDtuII;EACE,gCAAA;AhDwuIN;AgDruII;EACE,gCAAA;AhDuuIN;AgDluIE;EACE,aAAA;AhDouIJ;AgDhuIE;EACE,8BAAA;EACA,0BAAA;AhDkuIJ;AgD9tIE;EACE,8BAAA;AhDguIJ;AgD5tIE;EACE,4BAAA;AhD8tIJ;AgD1tIE;EACE,0BAAA;EACA,cAAA;AhD4tIJ;AgDztIE;EACE,eAAA;EACA,sBAAA;EACA,iBAAA;AhD2tIJ;AgDvtIE;EACE,gBAAA;AhDytIJ;AgDttIE;EACE,6BAAA;AhDwtIJ;AgDrtIE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AhDutIJ;AgDntIE;EACE,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AhDqtIJ;AgDltIE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AhDotIJ;AgDjtIE;EACE,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,+CAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;AhDmtIJ;AgDjtII;EACE,mDAAA;AhDmtIN;AgD/sIE;EACE,0BAAA;AhDitIJ;AgD7sIE;EACE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AhD+sIJ;AgD7sII;EACE,oCAAA;AhD+sIN;AgD5sII;EACE,oCAAA;AhD8sIN","sourcesContent":["/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n//General vars\n@use \"./_variables\";\n\n//General functions (imports)\n\n//General Styles\n\n@use \"components/_general\";\n\n//Custom Components Styles\n\n@use \"components/_forms\";\n\n@use \"components/_appointmentCalendarView\";\n\n@use \"layouts/kanban.container\";\n\n@use \"components/_notifications\";\n\n@use \"components/_AccountingMovementsTotals\";\n\n@use \"components/_HeaderPersonInformation\";\n\n@use \"components/generals/_AppointmentCard\";\n\n@use \"components/generals/_CallTimer\";\n\n@use \"components/generals/_Checkbox\";\n\n@use \"components/generals/_CustomSelect\";\n\n@use \"components/generals/_FormInput\";\n\n@use \"components/generals/_FormInputCheckbox\";\n\n@use \"components/generals/_FormInputPassword\";\n\n@use \"components/generals/_FormMultipleSelectChip\";\n\n@use \"components/generals/_FormPhoneInput\";\n\n@use \"components/generals/_FormSelectInput\";\n\n@use \"components/generals/_FormTextareaInput\";\n\n@use \"components/generals/_FormTextEditor\";\n\n@use \"components/generals/_HtmlTooltip\";\n\n@use \"components/generals/_IdCell\";\n\n@use \"components/generals/_Input\";\n\n@use \"components/generals/_LoadingOverlay\";\n\n@use \"components/generals/_MedicalAssetViewer\";\n\n@use \"components/generals/_OfficeDocumentRenderer\";\n\n@use \"components/generals/_PasswordRecoveryCard\";\n\n@use \"components/generals/_PDFVitalsUploader\";\n\n@use \"components/generals/_PercentageInput\";\n\n@use \"components/generals/_PricingExcelUpload\";\n\n@use \"components/generals/_SideNavarColor\";\n\n@use \"components/generals/_Switch\";\n\n@use \"components/generals/_TextMessagesChat\";\n\n@use \"components/widgets/_AppointmentWidget\";\n\n@use \"components/forms/_PatientHubForm\";\n\n@use \"components/forms/_GeneralSettingsForm\";\n\n@use \"components/views/_DocumentViewer\";\n\n@use \"components/views/_TemplateRecycleBinModal\";\n\n@use \"components/_progressNote\";\n\n@use \"components/forms/_BillingEncounterForm\";\n\n@use \"components/forms/_PaymentForm\";\n\n@use \"components/forms/_ConfirmPaymentForm\";\n\n@use \"components/content/_PatientHubDataContent\";\n\n@use \"components/forms/_DoctorForm\";\n\n@use \"components/_videochatRenderer\";\n@use \"components/_guestVideochatPage\";\n\n@use \"components/content/_AccountingMovementsDataContent\";\n\n@use \"components/global/_FeedbackFloating\";","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n//colors\n$color-black: #000;\n$color-white: #fff;\n$color-gray-light: #f5f5f5;\n$color-gray-dark: #717171;\n$dark-form-backcolor: #1e1532;\n$light-form-backcolor: #ffffff;\n\n//media query\n$xs-media-querys: 320px;\n$sm-media-querys: 768px;\n$md-media-querys: 1024px;\n$lg-media-querys: 1440px;\n\n// Padding variables - Sistema uniforme de espaciado\n$padding-xs: 8px;\n$padding-sm: 12px;\n$padding-md: 16px;\n$padding-lg: 24px;\n$padding-xl: 32px;\n\n// Typography sizes - Tamaños uniformes de texto\n$text-xs: 0.75rem; // 12px - Captions, labels pequeños\n$text-sm: 0.875rem; // 14px - Body text pequeño\n$text-md: 0.9375rem; // 15px - Body text mediano\n$text-base: 1rem; // 16px - Body text normal\n$text-lg: 1.125rem; // 18px - Body text grande\n$text-xl: 1.25rem; // 20px - Subtítulos pequeños\n$text-2xl: 1.5rem; // 24px - Subtítulos\n$text-3xl: 1.875rem; // 30px - Títulos\n$text-4xl: 2.25rem; // 36px - Títulos grandes\n\n// Font weights\n$font-normal: 400;\n$font-medium: 500;\n$font-semibold: 600;\n$font-bold: 700;\n\n// Border radius\n$border-radius-sm: 0.25rem; // 4px\n$border-radius-md: 0.5rem; // 8px\n$border-radius-lg: 1rem; // 16px","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n.add-box-shadow {\n  box-shadow: 2px 2px 5px vars.$color-black;\n}\n\n.btn-close-modal {\n  background-color: #ffffff;\n  -webkit-background-clip: border-box;\n  background-clip: border-box;\n  border: 0 solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.75rem;\n  box-shadow:\n    0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),\n    0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06);\n  overflow: visible;\n  padding: 1rem;\n\n  >div {\n    margin-top: 0;\n  }\n}\n\n.data-view-container {\n  display: block;\n\n  .MuiBox-root .css-17mkaxz{\n    max-width: fit-content;\n  }\n\n  >div {\n    width: 100%;\n  }\n\n  .data-accordion {\n    border-radius: 0.75rem;\n    margin-bottom: 5px;\n\n    &:before {\n      display: none;\n    }\n\n    &:last-of-type {\n      border-bottom-left-radius: 0.75rem;\n      border-bottom-right-radius: 0.75rem;\n    }\n  }\n\n  .data-view {\n    height: 100%;\n    width: 100%;\n\n    form {\n      .lb-xs {\n        >label {\n          margin-right: 0;\n        }\n      }\n    }\n\n    .currency-input {\n      background-color: #f5f5f5;\n      color: #666;\n\n      &--dark {\n        background-color: #424242;\n        color: #fff;\n      }\n    }\n  }\n\n  .activity-logs-container{\n    padding: 16px;\n    margin-bottom: 16px;\n    box-shadow: none;\n    &--dark {\n      background-color: #1a2035\n    }\n  }\n  .clear-filters-container{\n    display: flex;\n    justify-content: flex-end;\n    button {\n      min-width: 120px;\n    }\n  }\n\n  @media (min-width: vars.$md-media-querys) {\n    display: flex;\n\n    .data-view {\n      width: 88% !important;\n      margin: 0 auto;\n    }\n  }\n}\n\n.modal-container {\n  overflow-y: auto;\n\n  .data-view {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    padding: 32px;\n    max-height: 100%;\n    box-shadow: none;\n\n    .css-1v2oh8h {\n      padding: 0;\n      margin: 0;\n      max-width: 100%;\n    }\n\n    .css-halbs2-MuiButtonBase-root-MuiButton-root {\n      margin-top: 0px !important;\n      justify-content: flex-end !important;\n\n    }\n\n    .css-5kxzi1-MuiGrid-root {\n      justify-content: flex-start !important;\n    }\n\n    @media (min-width: vars.$sm-media-querys) {\n      width: 90%;\n    }\n\n    @media (min-width: vars.$md-media-querys) {\n      width: 80%;\n    }\n  }\n}\n\n.MuiDialogActions-root {\n  button+button {\n    color: #fff;\n  }\n}\n\n.pg-viewer-wrapper {\n  height: 500px;\n}\n\n#react-doc-viewer {\n  #header-bar {\n    display: none;\n  }\n\n  #proxy-renderer {\n    overflow: none;\n\n    #msdoc-renderer {\n      iframe {\n        height: 500px;\n      }\n    }\n  }\n}\n\n.title-modal {\n  color: #fff !important;\n  text-shadow: 2px 2px 5px vars.$color-black;\n}\n\n.visually-hidden-input {\n  clip: rect(0 0 0 0);\n  -webkit-clip-path: inset(50%);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  white-space: nowrap;\n  width: 1px;\n}\n\n// Styles for docx-preview\n.docx-wrapper {\n  background: white;\n  padding: 30px;\n\n  section.docx {\n    min-height: 500px;\n    background: white;\n  }\n}\n\n@media (min-width: vars.$md-media-querys) {\n  ::-webkit-scrollbar {\n    width: 20px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 20px;\n    border: 6px solid transparent;\n    background-clip: content-box;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n  }\n}\n\n// ========================================\n// Utility Classes - Padding System\n// ========================================\n\n// Padding horizontal (left and right)\n.px-xs {\n  padding-left: vars.$padding-xs;\n  padding-right: vars.$padding-xs;\n}\n\n.px-sm {\n  padding-left: vars.$padding-sm;\n  padding-right: vars.$padding-sm;\n}\n\n.px-md {\n  padding-left: vars.$padding-md;\n  padding-right: vars.$padding-md;\n}\n\n.px-lg {\n  padding-left: vars.$padding-lg;\n  padding-right: vars.$padding-lg;\n}\n\n.px-xl {\n  padding-left: vars.$padding-xl;\n  padding-right: vars.$padding-xl;\n}\n\n// Padding vertical (top and bottom)\n.py-xs {\n  padding-top: vars.$padding-xs;\n  padding-bottom: vars.$padding-xs;\n}\n\n.py-sm {\n  padding-top: vars.$padding-sm;\n  padding-bottom: vars.$padding-sm;\n}\n\n.py-md {\n  padding-top: vars.$padding-md;\n  padding-bottom: vars.$padding-md;\n}\n\n.py-lg {\n  padding-top: vars.$padding-lg;\n  padding-bottom: vars.$padding-lg;\n}\n\n.py-xl {\n  padding-top: vars.$padding-xl;\n  padding-bottom: vars.$padding-xl;\n}\n\n// Padding all sides\n.p-xs {\n  padding: vars.$padding-xs;\n}\n\n.p-sm {\n  padding: vars.$padding-sm;\n}\n\n.p-md {\n  padding: vars.$padding-md;\n}\n\n.p-lg {\n  padding: vars.$padding-lg;\n}\n\n.p-xl {\n  padding: vars.$padding-xl;\n}\n\n// ========================================\n// Typography System\n// ========================================\n\n// Text sizes\n.text-xs {\n  font-size: vars.$text-xs;\n}\n\n.text-sm {\n  font-size: vars.$text-sm;\n}\n\n.text-base {\n  font-size: vars.$text-base;\n}\n\n.text-lg {\n  font-size: vars.$text-lg;\n}\n\n.text-xl {\n  font-size: vars.$text-xl;\n}\n\n.text-2xl {\n  font-size: vars.$text-2xl;\n}\n\n.text-3xl {\n  font-size: vars.$text-3xl;\n}\n\n.text-4xl {\n  font-size: vars.$text-4xl;\n}\n\n// Font weights\n.font-normal {\n  font-weight: vars.$font-normal;\n}\n\n.font-medium {\n  font-weight: vars.$font-medium;\n}\n\n.font-semibold {\n  font-weight: vars.$font-semibold;\n}\n\n.font-bold {\n  font-weight: vars.$font-bold;\n}\n\n// Common text combinations\n.title-primary {\n  font-size: vars.$text-2xl;\n  font-weight: vars.$font-bold;\n  line-height: 1.2;\n}\n\n.title-secondary {\n  font-size: vars.$text-xl;\n  font-weight: vars.$font-bold;\n  line-height: 1.3;\n}\n\n.subtitle {\n  font-size: vars.$text-lg;\n  font-weight: vars.$font-bold;\n  line-height: 1.4;\n}\n\n.body-text {\n  font-size: vars.$text-base;\n  font-weight: vars.$font-bold;\n  line-height: 1.5;\n}\n\n.body3 {\n  font-size: vars.$text-sm;\n  font-weight: vars.$font-medium;\n  line-height: 1;\n}\n\n.caption {\n  font-size: vars.$text-sm;\n  font-weight: vars.$font-normal;\n  line-height: 1.4;\n}\n\n// ========================================\n// Component Base Classes\n// ========================================\n\n// Base card styling with consistent padding\n.card-base {\n  padding: vars.$padding-lg;\n  border-radius: 12px;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-md;\n  }\n}\n\n.card-general-content {\n  padding: vars.$padding-md;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n.card-header-base {\n  padding: vars.$padding-md vars.$padding-lg;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n.card-content-base {\n  padding: vars.$padding-md vars.$padding-lg;\n\n  @media (max-width: vars.$sm-media-querys) {\n    padding: vars.$padding-sm vars.$padding-md;\n  }\n}\n\n// ========================================\n// Modal and Dialog Styles\n// ========================================\n\n// Apply consistent padding to all MUI Dialog components\n.MuiDialog-paper {\n  .MuiDialogTitle-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .MuiDialogContent-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .MuiDialogActions-root {\n    padding: vars.$padding-md !important;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm vars.$padding-md !important;\n    }\n  }\n\n  .css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {\n    display: inline-block;\n    margin-top: -15px;\n    font-size: 0.750rem;\n    font-weight: 700;\n    color: #344767;\n    line-height: 1;\n    -webkit-transform: translateY(0.0625rem);\n    -moz-transform: translateY(0.625rem);\n    -ms-transform: translateY(0.625rem);\n    transform: translateY(0.625rem);\n    margin-left: 0.25rem;\n  }\n\n  .css-cbmr7p-MuiSvgIcon-root {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    width: 1em;\n    height: 1em;\n    margin-top: 0px;\n    display: inline-block;\n    fill: currentColor;\n    -webkit-flex-shrink: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    font-size: 1.25rem;\n    color: #344767;\n    font-size: 1.25rem !important;\n  }\n\n  .css-tnsvld-MuiSwitch-root {\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 58px;\n    height: 38px;\n    margin-top: 0px;\n    overflow: hidden;\n    padding: 12px;\n    box-sizing: border-box;\n    position: relative;\n    -webkit-flex-shrink: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    z-index: 0;\n    vertical-align: middle;\n  }\n\n  .css-knlq9b-MuiFormControlLabel-root {\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    /* -webkit-align-items: center; */\n    /* -webkit-box-align: center; */\n    -ms-flex-align: center;\n    /* align-items: center; */\n    /* cursor: pointer; */\n    /* vertical-align: bottom; */\n    /* -webkit-tap-highlight-color: transparent; */\n    /* margin-left: -11px; */\n    margin-right: 16px;\n    /* display: block; */\n    /* min-height: 1.5rem; */\n    /* margin-bottom: 0.125rem; */\n  }\n\n  .css-1bg6o37-MuiGrid-root {\n    box-sizing: border-box;\n    margin: 0;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex-basis: 100%;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    -webkit-box-flex: 0;\n    -webkit-flex-grow: 0;\n    -ms-flex-positive: 0;\n    flex-grow: 0;\n    /* max-width: 100%; */\n  }\n}\n\n.css-1ioqvny-MuiPaper-root-MuiDrawer-paper{\n  overflow-x: hidden;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\r\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\r\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \r\n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\r\n\r\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\r\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \r\nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \r\nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \r\ninto with MALMUR.*/\r\n\r\n@use \"../_variables\" as vars;\r\n\r\n// Apply responsive margin to all form elements\r\n.data-view-container form {\r\n  margin: vars.$padding-lg; // 24px on desktop\r\n\r\n  @media (max-width: vars.$md-media-querys) {\r\n    margin: vars.$padding-md; // 16px on tablet\r\n  }\r\n\r\n  @media (max-width: vars.$sm-media-querys) {\r\n    margin: vars.$padding-sm; // 12px on mobile\r\n  }\r\n}\r\n\r\n.form-container-action-buttons {\r\n  box-sizing: border-box;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex-wrap: wrap;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  margin-top: 20px;\r\n  width: calc(100% + 16px);\r\n  -webkit-align-items: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  padding: 12px;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  justify-content: space-between;\r\n\r\n  // Desktop\r\n  @media (max-width: vars.$lg-media-querys) {\r\n    justify-content: space-between;\r\n  }\r\n\r\n  // Tablet\r\n  @media (max-width: vars.$md-media-querys) {\r\n    justify-content: flex-end;\r\n\r\n  }\r\n\r\n  // Mobile\r\n  @media (max-width: vars.$sm-media-querys) {\r\n    justify-content: flex-end;\r\n  }\r\n\r\n}\r\n\r\n.css-18kdg2e-MuiGrid-root {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-basis: 100%;\r\n  -ms-flex-preferred-size: 100%;\r\n  flex-basis: 100%;\r\n  -webkit-box-flex: 0;\r\n  -webkit-flex-grow: 0;\r\n  -ms-flex-positive: 0;\r\n  flex-grow: 0;\r\n  max-width: 100%;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n\r\nform .form-container {\r\n  .css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-drl5f-MuiSelect-select-MuiInputBase-input-MuiInput-input {\r\n    padding: 4px 0 5px;\r\n  }\r\n\r\n  button {\r\n    margin-right: vars.$padding-md;\r\n  }\r\n}\r\n\r\n.modal-container .data-view .css-halbs2-MuiButtonBase-root-MuiButton-root {\r\n  margin-top: 0px !important;\r\n}\r\n\r\n\r\n.modal-container .data-view .css-5kxzi1-MuiGrid-root {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.form-data-grid-item {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-basis: 100%;\r\n  -ms-flex-preferred-size: 100%;\r\n  flex-basis: 100%;\r\n  -webkit-box-flex: 0;\r\n  -webkit-flex-grow: 0;\r\n  -ms-flex-positive: 0;\r\n  flex-grow: 0;\r\n  max-width: 48%;\r\n  margin-top: 24px;\r\n}\r\n\r\n.css-1rnrdd8-MuiGrid-root>.MuiGrid-item {\r\n  display: flex;\r\n\r\n  // Desktop\r\n  @media (max-width: vars.$lg-media-querys) {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  // Tablet\r\n  @media (max-width: vars.$md-media-querys) {\r\n    justify-content: flex-start;\r\n    margin-left: -5px;\r\n  }\r\n\r\n  // Mobile\r\n  @media (max-width: vars.$sm-media-querys) {\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\n.css-m166en-MuiGrid-root>.MuiGrid-item {\r\n  display: flex !important;\r\n  justify-content: flex-end !important;\r\n\r\n  @media (min-width: vars.$md-media-querys) {\r\n    &:first-child {\r\n      justify-content: flex-start !important;\r\n    }\r\n\r\n    &:last-child {\r\n      justify-content: flex-end !important;\r\n    }\r\n  }\r\n}\r\n\r\n.css-1q2d3rl-MuiGrid-root>.MuiGrid-item {\r\n  padding-top: 0px;\r\n}\r\n\r\n.full-form-wrapper {\r\n  .full-form-sub-wrapper {\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n\r\n.formik-input {\r\n  input[type=\"checkbox\"] {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n// Calendar Event Styles\n.data-event-calendar {\n  color: vars.$light-form-backcolor;\n  padding: 2px 5px;\n  width: 100%;\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 0.35rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n// FullCalendar event color classes based on status with gradients\n.fc-event {\n\n  &-error,\n  &.fc-event-error {\n    background: #e57373 !important;\n    border-color: #b71c1c !important;\n    box-shadow: none;\n    opacity: 0.85;\n  }\n\n  &-success,\n  &.fc-event-success {\n    background: linear-gradient(135deg, #66bb6a 0%, #2e7d32 50%, #1b5e20 100%) !important;\n    border-color: #1b5e20 !important;\n    box-shadow: 0 2px 4px rgba(46, 125, 50, 0.3);\n  }\n\n  &-info,\n  &.fc-event-info {\n    background: linear-gradient(135deg, #42a5f5 0%, #1976d2 50%, #0d47a1 100%) !important;\n    border-color: #0d47a1 !important;\n    box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);\n  }\n}\n\n.data-event-calendar {\n\n  strong {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  >div,\n  .patient-name,\n  .doctor-name {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 0.75rem;\n    transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;\n  }\n\n  // Very small cards (≤15 min) - hide patient and doctor\n  &.event-tiny {\n\n    .patient-name,\n    .doctor-name {\n      display: none;\n    }\n  }\n\n  // Small cards (≤30 min) - hide only doctor\n  &.event-small {\n    .doctor-name {\n      display: none;\n    }\n  }\n}\n\n.fc-timegrid-event-harness {\n  &:hover {\n    z-index: 1000 !important;\n  }\n\n  .fc-timegrid-event {\n    transition: bottom 0.3s ease-in-out 0s, min-height 0.3s ease-in-out;\n    overflow: hidden;\n    border-radius: 0.35rem;\n\n    .fc-event-main {\n      padding: 0;\n      height: 100%;\n    }\n\n    &:hover {\n      bottom: -60%;\n      min-height: 80px;\n      overflow: visible;\n\n      .data-event-calendar {\n\n        .patient-name,\n        .doctor-name {\n          display: block !important;\n        }\n      }\n    }\n  }\n\n  .fc-v-event {\n    border: none;\n  }\n}\n\n.fc-daygrid-dot-event {\n  padding: 0;\n}\n\n// Appointment Card Styles\n.appointment-card {\n  &--completed {\n    background-color: #e8f5e8;\n\n    &.dark-mode {\n      background-color: #2F6B05;\n    }\n  }\n\n  &--cancelled {\n    background-color: #740011;\n\n    &.dark-mode {\n      background-color: #751414;\n    }\n  }\n\n  &--past-due {\n    background-color: #fff8e1;\n\n    &.dark-mode {\n      background-color: #BA9C06;\n    }\n  }\n\n  &--scheduled {\n    background-color: #e3f2fd;\n\n    &.dark-mode {\n      background-color: #05496B;\n    }\n  }\n}\n\n// Modal Styles\n.appointment-modal {\n  &__wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90vw;\n    max-width: 900px;\n    background-color: vars.$light-form-backcolor;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 24px 32px;\n    display: flex;\n    flex-direction: column;\n\n    &.dark-mode {\n      background-color: #1a2035;\n    }\n\n    &--mobile {\n      width: 98vw;\n      height: 90vh;\n      padding: 12px 16px;\n      border-radius: 4px;\n    }\n  }\n\n  &__header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 16px;\n    color: vars.$dark-form-backcolor;\n\n    &.dark-mode {\n      color: vars.$light-form-backcolor;\n    }\n\n    &--mobile {\n      margin-bottom: 8px;\n    }\n  }\n\n  &__content {\n    flex: 1;\n    overflow: auto;\n    margin-bottom: 16px;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    padding-top: 16px;\n    border-top: 1px solid #e0e0e0;\n\n    &.dark-mode {\n      border-top-color: #555;\n    }\n  }\n}\n\n// Dashboard Appointment Styles\n.dashboard-appointments {\n  &__container {\n    min-height: 70vh;\n    padding: 24px;\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n  }\n\n  &__title-wrapper {\n    flex: 1;\n  }\n\n  &__legend {\n    margin-top: 16px;\n    margin-left: 24px;\n    margin-right: 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__legend-inner {\n    margin-top: 4px;\n    justify-content: center;\n  }\n\n  &__legend-items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  &__legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__legend-box {\n    width: 16px;\n    height: 16px;\n    border-radius: 4px;\n\n    &--completed {\n      background-color: #91DB96;\n\n      &.dark-mode {\n        background-color: #2F6B05;\n      }\n    }\n\n    &--scheduled {\n      background-color: #00D5FF;\n\n      &.dark-mode {\n        background-color: #05496B;\n      }\n    }\n\n    &--past-due {\n      background-color: #FFE162;\n\n      &.dark-mode {\n        background-color: #BA9C06;\n      }\n    }\n\n    &--cancelled {\n      background-color: #ef0c0c;\n\n      &.dark-mode {\n        background-color: #851a1a;\n      }\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 8px;\n    flex-direction: row;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n\n    &--mobile {\n      flex-direction: column;\n      width: 100%;\n    }\n  }\n\n  &__sort-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n\n    @media (min-width: vars.$sm-media-querys) {\n      margin-bottom: 0;\n    }\n\n  }\n\n  &__grid {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n  }\n\n  &__notification {\n    height: 800px;\n  }\n}\n\n// Date Range Modal Specific Styles\n.daterange-modal {\n  &__loading {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 48px 0;\n    gap: 16px;\n  }\n\n  &__results {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    margin-top: 50px;\n    max-height: 40vh;\n  }\n\n  &__results-inner {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__scroll-area {\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  &__appointment-item {\n    transform: scale(0.85);\n    transform-origin: top left;\n    width: 117.65%;\n    margin-bottom: -12px;\n  }\n\n  &__card-content-appointment-item {\n    padding: 5px !important;\n  }\n}\n\n// Calendar View ARR Modal Styles\n.arr-modal {\n  &__wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 85vw;\n    max-width: 1600px;\n    height: auto;\n    background-color: vars.$light-form-backcolor !important;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n\n    &.dark-mode {\n      background-color: #1a2035;\n    }\n\n    &--mobile {\n      width: 90vw;\n      height: auto;\n      padding: 12px;\n      border-radius: 4px;\n    }\n  }\n\n  &__header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 16px;\n    color: vars.$dark-form-backcolor;\n\n    h2 {\n      font-size: 1.5rem;\n    }\n\n    &.dark-mode {\n      color: vars.$light-form-backcolor;\n    }\n\n    &--mobile {\n      margin-bottom: 8px;\n\n      h2 {\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  &__content {\n    flex: 1;\n    overflow: auto;\n    margin-bottom: 16px;\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    flex-direction: row;\n\n    &--mobile {\n      flex-direction: column;\n    }\n  }\n}\n\n// Text Styles\n.text {\n  &--caption-small {\n    font-size: 0.75rem;\n  }\n}\n\n// Icon Styles\n.icon {\n  &--empty-state {\n    font-size: 64px;\n    color: rgba(0, 0, 0, 0.26);\n    margin-bottom: 16px;\n\n    &.dark-mode {\n      color: rgba(255, 255, 255, 0.3);\n    }\n  }\n}\n\n// Button Styles for AppointmentForm\n.appointment-form {\n  &__button-group {\n    display: flex;\n    gap: 5px;\n    flex-wrap: wrap;\n    padding: 16px;\n  }\n\n  &__button {\n    margin: 5px;\n  }\n}\n\n// Autocomplete TextField Overrides\n.autocomplete-textfield {\n  .MuiInputBase-input {\n    color: #000;\n  }\n\n  .MuiInputLabel-root {\n    color: #666;\n  }\n\n  .MuiInput-underline:before {\n    border-bottom-color: #ccc;\n  }\n\n  .MuiInput-underline:hover:before {\n    border-bottom-color: #999;\n  }\n\n  &.dark-mode {\n    .MuiInputBase-input {\n      color: #fff;\n    }\n\n    .MuiInputLabel-root {\n      color: #bbb;\n    }\n\n    .MuiInput-underline:before {\n      border-bottom-color: #555;\n    }\n\n    .MuiInput-underline:hover:before {\n      border-bottom-color: #777;\n    }\n  }\n}\n\n// Modal Size Variants\n.appointment-modal {\n  &__wrapper--large {\n    min-width: 480px;\n    max-width: 1050px;\n\n    @media (max-width: vars.$md-media-querys) {\n      min-width: 95vw;\n      max-width: 98vw;\n    }\n  }\n}\n\n.iconButton-addUser {\n  height: 12px !important;\n  margin: 0px !important;\n}\n\n.iconButton-addUser-icon {\n  color: inherit;\n}\n\n.currencyInput-overrideCopay {\n  width: auto;\n\n  @media (min-width: vars.$sm-media-querys) {\n    width: 130px;\n  }\n}\n\n.min-dimensions {\n  background-color: lawngreen;\n}\n\n.appoinment-form-insurance-options {\n  &--override-copay {\n    div label {\n      display: flex;\n    }\n  }\n\n  @media (max-width: vars.$sm-media-querys) {\n    &--override-copay {\n      flex-direction: column !important;\n    }\n\n    &--non-billable {\n      div label {\n        display: flex;\n      }\n    }\n  }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.main-container {\r\n  .tab-container {\r\n    overflow: scroll;\r\n    .react-kanban-board {\r\n      width: 400px;\r\n      > div {\r\n        width: 100%;\r\n        display: flex;\r\n        .react-kanban-column {\r\n          flex: 1 0 auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n.notification-widget {\n  max-width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  padding-right: 0;\n  &--light {\n    border-radius: 24px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  }\n}\n\n.notification-widget-header {\n  padding: vars.$padding-lg;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  &--light {\n    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n    color: #ffffff;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  }\n  &--dark {\n    background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);\n    color: #ffffff;\n  }\n}\n\n.notification-widget-header-title {\n  font-size: vars.$text-base !important;\n  font-weight: vars.$font-bold !important;\n  &--light {\n    color: #ffffff;\n  }\n}\n\n.notification-widget-header-badge {\n  &--light .MuiBadge-badge {\n    background-color: #ff4757;\n    color: white;\n    font-weight: 600;\n  }\n}\n\n.notification-widget-header-icon {\n  &--light {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-header-button {\n  font-size: vars.$text-xs !important;\n  &--light {\n    color: #ffffff;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(255, 255, 255, 0.1);\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n  &--dark {\n    color: white;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(0, 0, 0, 0.1);\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n}\n\n.notification-widget-header-caption {\n  font-size: vars.$text-sm !important;\n  font-weight: vars.$font-medium !important;\n  &--light {\n    color: #ffffff;\n    opacity: 1;\n  }\n  &--dark {\n    color: #ffffff;\n    opacity: 0.9;\n  }\n}\n\n.notification-widget-stats-box {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.notification-widget-toggle-read {\n  &:focus,\n  &:focus-visible,\n  &:active {\n    background-color: rgba(128, 128, 128, 0.1) !important;\n    outline: none !important;\n  }\n  font-size: vars.$text-sm !important;\n}\n\n.notification-widget-stats-chip {\n  font-weight: 600 !important;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  &:hover {\n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n  &--active {\n    border: 2.5px solid #575757 !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    z-index: 1;\n  }\n  &--total-light {\n    background-color: rgba(201, 201, 201, 0.59) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(201, 201, 201, 0.9) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--total-dark {\n    background-color: #1a2535 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(255, 255, 255, 0.158) !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--unread-light {\n    background-color: #ff3546 !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #ea3030 !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--unread-dark {\n    background-color: #710800 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #7a4542 !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--read-light {\n    background-color: rgba(82, 205, 87, 0.8) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgb(116, 248, 121) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--read-dark {\n    background-color: #2a80309b !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #69bc6f9b !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n}\n\n.notification-widget-item {\n  cursor: pointer;\n  border-radius: 8px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  margin-left: vars.$padding-md;\n  margin-right: vars.$padding-md !important;\n  transition: all 0.2s ease;\n  \n  &.MuiListItem-root {\n    padding-top: vars.$padding-md !important;\n    padding-bottom: vars.$padding-md !important;\n    padding-left: vars.$padding-md !important;\n    padding-right: vars.$padding-xl !important;\n    margin-right: vars.$padding-md !important;\n  }\n\n  .MuiListItemText-root {\n    padding-right: vars.$padding-md !important;\n  }\n  &--read {\n    opacity: 0.6;\n  }\n  &--unread {\n    opacity: 1;\n  }\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.notification-widget-title {\n  flex-grow: 1;\n  font-size: vars.$text-md !important;\n  &--read {\n    font-weight: normal;\n  }\n  &--unread {\n    font-weight: bold !important;\n  }\n}\n\n.notification-widget-message {\n  margin-bottom: 4px;\n  font-size: vars.$text-md !important;\n}\n.notification-widget-date {\n  font-size: vars.$text-xs !important;\n  opacity: 0.7;\n}\n.notification-widget-divider {\n  margin-top: 24px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 6px solid rgba(0,0,0,0.18);\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  &--read {\n    margin-bottom: 20px;\n  }\n  &--unread {\n    margin-top: 24px;\n    margin-bottom: 20px;\n  }\n}\n\n.notification-widget--light .notification-widget-divider {\n  border-top: 6px solid #1a1a1a !important;\n}\n.notification-widget--dark .notification-widget-divider {\n  border-top: 6px solid rgba(255,255,255,0.22) !important;\n}\n\n.notification-widget-divider-chip {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  margin: 12px 0 20px 0 !important;\n  width: 100% !important;\n\n  .MuiChip-root {\n    display: inline-flex !important;\n    background: none !important;\n  }\n}\n\n.notification-widget-item {\n  margin-top: 8px;\n}\n\n\n.notification-widget-chip {\n  opacity: 1 !important;\n  font-size: 0.85rem !important;\n  font-weight: 700 !important;\n  background-color: transparent !important;\n  align-self: center !important;\n  align-content: center !important;\n  &--read .MuiChip-label {\n    color: #4caf50 !important;\n  }\n  \n  &--unread .MuiChip-label {\n    color: #ff4757 !important;\n  }\n  \n  &.MuiChip-label--light .MuiChip-label {\n    color: #909090 !important;\n  }\n  \n  &.MuiChip-label--dark .MuiChip-label {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-loading-text {\n  margin-left: 16px;\n}\n\n.notification-widget-error {\n  padding: 16px;\n}\n\n.notification-widget-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-empty-icon {\n  font-size: 48px;\n  margin-bottom: 8px;\n}\n\n.notification-widget-empty-caption {\n  margin-top: 8px;\n}\n\n.notification-widget-list {\n  padding: vars.$padding-md;\n  max-height: 675px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  \n  .notification-widget-divider-chip {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n\n.notification-widget-content {\n  flex: 1 1 auto;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notification-widget-snackbar {\n  .MuiSnackbarContent-root {\n    border-radius: 8px;\n    font-weight: 500;\n  }\n}\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n#accounting-movements-totals {\n  .balanceText {\n    display: inline-block;\n    max-width: 250px;\n    white-space: normal;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n#profile {\n  .photoLoadingContainer {\n    width: 200px;\n    height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f5f5f5;\n    border-radius: 50%;\n  }\n\n  .progressContainer {\n    position: relative;\n    display: inline-flex;\n  }\n\n  .progressLabel {\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .addressText {\n    display: inline-block;\n    max-width: 450px;\n    white-space: normal;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n}\n\n.header-person-card {\n  position: relative !important;\n}\n\n.print-button {\n  position: absolute !important;\n  top: 8px; \n  right: 8px;\n  background-color: rgba(25, 118, 210, 0.15) !important;\n\n  &:hover {\n    background-color: rgba(25, 118, 210, 0.3) !important;\n  }\n}\n\n.patient-avatar {\n  width: 200px !important;\n  height: 200px !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n\n@use \"../../_variables\" as vars;\n\n$background-color-cancel-light: #ffebee;\n$background-color-cancel-dark: #751414;\n$background-color-checkIn-light: #fff8e1;\n$background-color-checkIn-dark: #BA9C06;\n$background-color-checkOut-light: #e8f5e8;\n$background-color-checkOut-dark: #2F6B05;\n$background-color-light: #e3f2fd;\n$background-color-dark: #05496B;\n\n$background-chip-color-cancel-light: #FFCDD2;\n$background-chip-color-cancel-dark: #FF8787;\n$background-chip-color-checkIn-light: #FFECB3;\n$background-chip-color-checkIn-dark: #FAD784;\n$background-chip-color-checkOut-light: #C8E6C8;\n$background-chip-color-checkOut-dark: #91DB96;\n$background-chip-color-light: #A0C8E6;\n$background-chip-color-dark: #94BCEB;\n\n$color-light-mode: rgba(0, 0, 0, 0.6);\n$color-dark-mode: white;\n\n$color-chip-dark-mode: rgba(0, 0, 0, 0.87);\n\n$color-light-card-header: rgba(0,0,0,0.1);\n$color-dark-card-header: rgba(255,255,255,0.2);\n\n$boxshadow-card: 0 4px 8px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2);\n$boxshadow-card-hover: 0 8px 16px rgba(0, 0, 0, 0.4), 0 4px 8px rgba(0, 0, 0, 0.3);\n\n.appointment-card {\n  .light-card-header {\n    border-bottom: 1px solid $color-light-card-header;\n  }\n\n  .dark-card-header {\n    border-bottom: 1px solid $color-dark-card-header;\n  }\n\n  .card {\n    min-height: 140px;\n    transition: all 0.2s ease-in-out;\n    box-shadow: $boxshadow-card;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: $boxshadow-card-hover;\n    }\n  }\n\n  .card-content {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: vars.$padding-md;\n\n    &:last-child {\n      padding-bottom: vars.$padding-md;\n    }\n  }\n\n  .card-header {\n    display: flex;\n    flex-direction: row !important;\n    align-items: center;\n    margin-bottom: vars.$padding-md;\n    padding-bottom: vars.$padding-md;\n    gap: vars.$padding-xs;\n  }\n\n  .card-title {\n    flex-grow: 1;\n    font-size: vars.$text-lg;\n    font-weight: vars.$font-bold;\n    max-width: 70%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .card-row-space {\n    flex-direction: row !important;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: vars.$padding-xs;\n    margin-bottom: vars.$padding-xs;\n  }\n\n  .subtitle2 {\n    font-size: vars.$text-base;\n    font-weight: vars.$font-bold !important;\n  }\n\n  .light-color {\n    color: $color-light-mode !important;\n  }\n\n  .dark-color {\n    color: $color-dark-mode !important;\n  }\n\n  .dark-chip-color {\n    color: $color-chip-dark-mode !important;\n  }\n\n  .chip-light {\n    color: $color-chip-dark-mode !important;\n    font-weight: bold;\n    flex-shrink: 0;\n\n    .MuiChip-label {\n      color: $color-chip-dark-mode !important;\n      font-weight: bold;\n    }\n  }\n\n  .chip-dark {\n    color: $color-dark-mode !important;\n    font-weight: bold;\n    flex-shrink: 0;\n\n    .MuiChip-label {\n      color: $color-dark-mode !important;\n      font-weight: bold;\n    }\n  }\n\n  .cancel-light {\n    background-color: $background-chip-color-cancel-light !important;\n  }\n\n  .checkIn-light {\n    background-color: $background-chip-color-checkIn-light !important;\n  }\n\n  .checkOut-light {\n    background-color: $background-chip-color-checkOut-light !important;\n  }\n\n  .card-color-light {\n    background-color: $background-chip-color-light !important;\n  }\n\n  .cancel-dark {\n    background-color: $background-chip-color-cancel-dark !important;\n  }\n\n  .checkIn-dark {\n    background-color: $background-chip-color-checkIn-dark !important;\n  }\n\n  .checkOut-dark {\n    background-color: $background-chip-color-checkOut-dark !important;\n  }\n\n  .card-color-dark {\n    background-color: $background-chip-color-dark !important;\n  }\n\n  .card-stack-row-center {\n    flex-direction: row !important;\n    align-items: center;\n    gap: vars.$padding-xs;\n    margin-bottom: vars.$padding-xs;\n  }\n\n  .card-text-no-wrap {\n    font-size: vars.$text-sm;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .card-icon-text {\n    font-size: 16px;\n  }\n\n  .stack-row-space-between {\n    flex-direction: row !important;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n  .card-color-cancel-light {\n    background-color: $background-color-cancel-light !important;\n  }\n\n  .card-color-checkIn-light {\n    background-color: $background-color-checkIn-light !important;\n  }\n\n  .card-color-checkOut-light {\n    background-color: $background-color-checkOut-light !important;\n  }\n\n  .card-background-color-light {\n    background-color: $background-color-light !important;\n  }\n\n  .card-color-cancel-dark {\n    background-color: $background-color-cancel-dark !important;\n  }\n\n  .card-color-checkIn-dark {\n    background-color: $background-color-checkIn-dark !important;\n  }\n\n  .card-color-checkOut-dark {\n    background-color: $background-color-checkOut-dark !important;\n  }\n\n  .card-background-color-dark {\n    background-color: $background-color-dark !important;\n  }\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$call-timer-color:white;\n$call-timer-background-color: rgba(0, 0, 0, 0.7);\n\n.call-timer {\n  color: $call-timer-color !important;\n  background-color: $call-timer-background-color;\n  padding: 1rem 2rem;\n  border-radius: 0.25rem; \n  font-weight: bold !important;\n  font-family: monospace !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.checkbox-label-center{\n    align-items: center;\n}\n\n.checkbox-label-size{\n    font-size: 1rem !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.select-container {\n line-height: 1.8rem !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.formField-error-label{\n    white-space: pre-line !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.FormInputCheckbox-margin-top-small {\n    margin-top: 0.75rem;\n}\n.item-width-field {\n    width: 5rem !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.FormControl-content{\n    margin: 0 !important;\n    width: 100% !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.multipleSelectChip-container {\n    margin: 1rem;\n}\n\n.multipleSelectChip-chip {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$formPhoneInput-dark-bg-color: #1e2e4a;\n$formPhoneInput-dark-color: white;\n$formPhoneInput-dark-border-color: white;\n\n$formPhoneInput-light-bg-color: white;\n$formPhoneInput-light-color: black;\n$formPhoneInput-light-border-color: #1e2e4a;\n\n$formPhoneInput-invalidNumber-color: red;\n\n.formPhoneInput-dark-mode {\n  .react-tel-input {\n    .special-label {\n      background-color:$formPhoneInput-dark-bg-color !important;\n      color: $formPhoneInput-dark-color;\n    }\n\n    .form-control {\n      background-color: $formPhoneInput-dark-bg-color !important;\n      color: $formPhoneInput-dark-color !important;\n      border-color: $formPhoneInput-dark-border-color ;\n    }\n\n    & .form-control.invalid-number {\n      border-color: $formPhoneInput-invalidNumber-color !important;\n    }\n  }\n}\n\n.formPhoneInput-light-mode {\n  .react-tel-input {\n    .special-label {\n      background-color: $formPhoneInput-light-bg-color !important;\n      color: $formPhoneInput-light-color;\n    }\n    .form-control {\n       background-color: $formPhoneInput-light-bg-color !important;\n    }\n  }\n}\n\n.formPhoneInput-inputStyle{\n  width: 100% !important;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.FormikSelectInput-select{\n    line-height: 1.8rem !important;\n}\n\n.FormikSelectInput-errorMessage{\n   margin-top: 0.75rem;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$blue: (\n  100: #DAECFF,\n  200: #b6daff,\n  400: #3399FF,\n  500: #007FFF,\n  600: #0072E5,\n  900: #003A75,\n);\n\n$grey: (\n  50: #F3F6F9,\n  100: #E5EAF2,\n  200: #DAE2ED,\n  300: #C7D0DD,\n  400: #B0B8C4,\n  500: #9DA8B7,\n  600: #6B7A90,\n  700: #434D5B,\n  800: #303740,\n  900: #1C2025,\n);\n$background:#fff;\n\n.formTextareaInput-textarea {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  font-family: 'IBM Plex Sans', sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  padding: 12px;\n  border-radius: 12px 12px 0 12px;\n  color: map-get($grey, 900);\n  background: $background;\n  border: 1px solid map-get($grey, 200);\n  box-shadow: 0px 2px 2px map-get($grey, 50);\n\n  &:hover {\n    border-color: map-get($blue, 400);\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: map-get($blue, 400);\n    box-shadow: 0 0 0 3px map-get($blue, 200);\n  }\n\n  &:focus-visible {\n    outline: 0;\n  }\n\n  &[data-theme = dark] {\n    color: map-get($grey, 300);\n    background: map-get($grey, 700);\n    border: 1px solid map-get($grey, 700);\n    box-shadow: 0px 2px 2px map-get($grey, 900);\n\n    &:focus {\n      box-shadow: 0 0 0 3px map-get($blue, 600);\n    }\n  }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.custom-wrapper {\n  width: 100%;\n  height: 40rem !important;\n  overflow: hidden;\n}\n\n.custom-editor {\n  height: 30rem;\n  overflow: auto;\n}\n\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$HtmlTooltip-background-color: #f5f5f9;\n$HtmlTooltip-text-color: rgba(0, 0, 0, 0.87);\n$HtmlTooltip-border: #dadde9;\n\n.HtmlTooltip-html-tooltip {\n  & .MuiTooltip-tooltip {\n    background-color: $HtmlTooltip-background-color;\n    color:$HtmlTooltip-text-color;\n    max-width: 220px;\n    font-size: 12px; \n    border: 1px solid $HtmlTooltip-border;\n  }\n    & .MuiTooltip-arrow {\n    color: $HtmlTooltip-border; \n  }\n}\n\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.idCell-caption {\n  margin-left: 8px;\n}",".inputHelper.dark-mode {\n    input:-webkit-autofill {\n        -webkit-box-shadow: 0 0 0 1000px transparent inset !important;\n        -webkit-text-fill-color: #fff !important;\n        transition: background-color 9999s ease-in-out 0s;\n    }\n    & *\n    {\n        color: #fff !important;\n    }\n}\n.inputHelper.light-mode {\n    input:-webkit-autofill {\n        -webkit-box-shadow: 0 0 0 1000px transparent inset !important;\n        -webkit-text-fill-color: #000 !important;\n        transition: background-color 9999s ease-in-out 0s;\n    }\n    & *\n    {\n        color: #000 !important;\n    }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$overlay-background: rgba(0, 0, 0, 0.5);\n$spinner-color: #FFFFFF;\n$message-color: #FFFFFF;\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: $overlay-background;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  flex-direction: column;\n\n  .loading-spinner {\n    color: $spinner-color;\n  }\n\n  .loading-message {\n    color: $message-color;\n    margin-top: 2rem;\n    font-size: 16px;\n    font-weight: bold;\n  }\n}\n\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n$primary-main-color: #007FFF;\n$secondary-color: #6B7A90;\n$loading-message-color:  #6c757d;\n$error-color: red;\n$button-border-color: #ccc;\n$viewer-box-border-color: #e0e0e0;\n$viewer-box-background-color: #f5f5f5;\n$no-preview-background-color: #F3F6F9;\n\n.pdf-viewer-container {\n  width: 100%;\n  height: 900px;\n  \n  .pdf-viewer {\n    width: 100%;\n    height: 100%;\n    border: none;\n    background-color: #ffffff;\n  }\n}\n\n.medical-asset-viewer {\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 900px;\n    gap: 2rem;\n    padding: 0 4rem;\n\n    .progress-wrapper {\n      position: relative;\n      display: inline-flex;\n\n      .progress-percentage {\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        position: absolute;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .loading-message {\n      margin-top: 2rem;\n      color: $loading-message-color;\n    }\n  }\n\n  .viewer-height {\n    height: 900px;\n  }\n\n  .error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    flex-direction: column;\n    gap: 2rem;\n\n    .error-message {\n      color: $error-color;\n    }\n\n    .error-button {\n      border: 1px solid $button-border-color;\n    }\n  }\n\n  .error-alert {\n    margin-top: 2rem;\n  }\n\n  .card {\n    padding: 1.5rem;\n    margin-top: 2rem;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 2rem;\n\n      .icon {\n        font-size: 24px;\n        color: $primary-main-color;\n      }\n\n      .file-info {\n        .file-name {\n          font-size: 1.25rem;\n          font-weight: 600;\n        }\n\n        .file-type {\n          font-size: 0.875rem;\n          color: $secondary-color;\n        }\n      }\n    }\n\n    .header-right {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n\n  .viewer-container {\n    margin-top: 2rem;\n\n    .viewer-box {\n      height: 900px;\n      border: 1px solid $viewer-box-border-color;\n      border-radius: 0.25rem;\n      overflow: auto;\n      background-color: $viewer-box-background-color;\n    }\n  }\n\n  .no-preview {\n    text-align: center;\n    padding: 4rem 0;\n    background-color: $no-preview-background-color;\n    border-radius: 0.25rem;\n\n    .no-preview-title {\n      font-size: 1.25rem;\n      color: $secondary-color;\n      margin-bottom: 1rem;\n    }\n\n    .no-preview-message {\n      font-size: 0.875rem;\n      color: $secondary-color;\n    }\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n$background-color: #f5f5f5;\n$button-border-color: #e0e0e0;\n.office-document-renderer {\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    min-height: 500px;\n    gap: 2rem;\n  }\n\n  .error-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    min-height: 500px;\n    padding: 4rem;\n\n    .alert {\n      max-width: 600px;\n      margin-bottom: 3rem;\n    }\n  }\n\n  .header {\n    padding: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 0;\n    background-color: $background-color;\n    border-bottom: 1px solid $button-border-color;\n  }\n\n  .content {\n    flex: 1;\n    overflow: auto;\n    background-color: $background-color;\n    padding: 3rem;\n\n    .preview {\n      max-width: 900px;\n      margin: 0 auto;\n      background-color: $background-color;\n      min-height: 100%;\n\n      .docx-container {\n        padding: 4rem;\n        min-height: 500px;\n\n        & section.docx {\n          padding: 0 !important;\n          background-color: $background-color;\n        }\n      }\n\n      .html-content {\n        padding: 4rem;\n      }\n    }\n  }\n}\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n$error-color: #f44336;\n.password-recovery-card {\n  width: 400px;\n  height: auto !important;\n  .card-content {\n    .title {\n      margin-top: 16px;\n    }\n    .description {\n      font-size: 13px;\n      display: block;\n      margin-top: 16px;\n      margin-bottom: 2px;\n    }\n\n    .error {\n      margin-top: 10px;\n      color: $error-color;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      white-space: pre-line;\n      font-size: 12px !important;\n      .error-icon {\n        font-size: 15px !important;\n      }\n    }\n\n    .footer {\n      margin-top: 24px;\n      display: flex;\n      justify-content: flex-end;\n      gap: 0.5rem;\n    }\n  }\n}\n\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$upload-button-border-color: #1A73E8;\n$upload-button-upload-description: #747b8a;\n\n.pdf-vitals-uploader {\n  .hidden-input {\n    display: none;\n  }\n\n  .upload-button {\n    margin-right: 2rem;\n    border-color: $upload-button-border-color;\n    align-self: center;\n  }\n\n  .upload-description {\n    margin-top: 1rem;\n    color: $upload-button-upload-description;\n    display: flex;\n  }\n}\n\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.percentage-input-props{\n    text-align: right;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n$progress-icon-color: #6c757d;\n\n.pricing-file-upload\n{\n  .flex-container {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    margin-bottom: 2px;\n  }\n\n  .margin-bottom {\n    margin-bottom: 2px;\n  }\n\n  .transparent-alert {\n    background-color: transparent;\n    margin-bottom: 2px;\n  }\n\n  .bold-margin {\n    font-weight: bold;\n    margin-bottom: 1px;\n  }\n\n  .padded-list {\n    padding-left: 2px;\n  }\n\n  .bold-margin-top {\n    font-weight: bold;\n    margin-bottom: 1px;\n    margin-top: 2px;\n  }\n\n  .flex-center {\n    display: flex;\n    align-items: center;\n    margin-top: 2px;\n    margin-bottom: 2px;\n  }\n\n  .progress-icon {\n    margin-right: 1px;\n    color: $progress-icon-color;\n  }\n\n  .status-alert {\n    margin-top: 2px;\n  }\n\n  .pre-wrap {\n    white-space: pre-wrap;\n    font-family: inherit;\n    margin: 0;\n  }\n\n  .error-alert {\n    margin-top: 2px;\n  }\n\n  .full-width {\n    width: 100%;\n  }\n\n  .margin-bottom-start {\n    margin-bottom: 2px;\n    align-items: flex-start;\n  }\n\n  .thin-font {\n    font-weight: thin;\n  }\n\n  .bold-font {\n    font-weight: bold;\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n$border-width: 1px;\n$palette: (\n  sidenav-background: #333333,\n  white-main: #ffffff,\n  dark-main: #000000\n);\n\n$primary-main: #EC407A;\n$primary-state: #D81B60;\n\n$secondary-main: #747b8a;\n$secondary-state: #495361;\n\n$info-main: #49a3f1;\n$info-state: #1A73E8;\n\n$success-main: #66BB6A;\n$success-state: #43A047 ;\n\n$warning-main: #FFA726;\n$warning-state: #FB8C00;\n\n$error-main: #EF5350;\n$error-state: #E53935;\n\n$light-main: #EBEFF4;\n$light-state: #CED4DA;\n\n$dark-main: #344767;\n$dark-state: #1d2430;\n    \n.sidenav-button {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  margin-right: 8px !important;\n  border: $border-width solid transparent !important;\n  transition: border-color 0.2s ease-in-out !important;\n\n  &.selected {\n    &.dark-mode {\n      border-color: $light-main !important;\n    }\n\n    &.light-mode {\n      border-color: $dark-main !important;\n    }\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    &.dark-mode {\n      border-color: $light-main !important;\n    }\n\n    &.light-mode {\n      border-color: $dark-main !important;\n    }  \n  }\n\n  &:not(:last-child) {\n    margin-right: 4px;\n  }\n\n  &.one {\n    background-color: $primary-main;\n    background-image: linear-gradient($primary-main, $primary-state);\n  }\n\n  &.two {\n    background-color: $dark-main;\n    background-image: linear-gradient($dark-main, $dark-state);\n  }\n\n  &.three {\n    background-color: $info-main;\n    background-image: linear-gradient($info-main, $info-state);\n  }\n\n  &.four {\n    background-color: $success-main;\n    background-image: linear-gradient($success-main, $success-state);\n  }\n\n  &.five {\n    background-color: $warning-main;\n    background-image: linear-gradient($warning-main, $warning-state);\n  }\n\n  &.six {\n    background-color: $error-main;\n    background-image: linear-gradient($error-main, $error-state);\n  }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.switch-span {\n  font-size: 0.75rem;\n  font-weight: bold;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../../_variables\" as vars;\n\n$primary-color: #007bff;\n$primary-hover-color: #0056b3;\n$disabled-color: #dee2e6;\n$disabled-hover-color: #c6c8ca;\n$dark-primary-color: #555555;\n$dark-primary-hover-color: #666666;\n$white-color: #FFFFFF;\n$secondary-text-color: #6c757d;\n$dark-secondary-text-color: #aaaaaa;\n$metadata-dark-color: #bbbbbb;\n$other-message-color: #d63384;\n\n$text-messages-chat-background-color: #f8f9fa;\n$text-messages-chat-border-color: #dee2e6;\n$text-messages-chat-color: #333333;\n$text-messages-chat-dark-background-color: #1a1a1a;\n$text-messages-chat-dark-border-color: #333333;\n$text-messages-chat-dark-color: #ffffff;\n$chat-header-background-color: #343a40;\n$chat-header-border-color: #495057;\n$chat-header-dark-background-color: #2c2c2c;\n$chat-header-dark-border-color: #444;\n\n$hover-light-background: rgba(255, 255, 255, 0.1);\n$tooltip-background: rgba(0, 0, 0, 0.9);\n$tooltip-arrow-color: rgba(0, 0, 0, 0.9);\n$box-shadow-light: rgba(0, 0, 0, 0.1);\n$chat-input-border: #dee2e6;\n$chat-input-background: #ffffff;\n$chat-input-dark-border: #444;\n$chat-input-dark-background: #1a1a1a;\n$outlined-input-light-background: #f8f9fa;\n$outlined-input-light-color: #333;\n$outlined-input-dark-background: #333333;\n$outlined-input-dark-color: #ffffff;\n$fieldset-light-border: #ced4da;\n$fieldset-dark-border: #555555;\n$fieldset-hover-light-border: #adb5bd;\n$fieldset-hover-dark-border: #666666;\n$fieldset-focused-border: $primary-color;\n$placeholder-light-color: $secondary-text-color;\n$placeholder-dark-color: $dark-secondary-text-color;\n\n.text-messages-chat {\n  width: 100%;\n  height: 100% !important;\n  background-color: $text-messages-chat-background-color !important;\n  border-left: 1px solid $text-messages-chat-border-color !important;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0 8px 8px 0 !important;\n  color: $text-messages-chat-color !important;\n\n  &.dark {\n    background-color: $text-messages-chat-dark-background-color !important;\n    border-left: 1px solid $text-messages-chat-dark-border-color !important;\n    color: $text-messages-chat-dark-color !important;\n\n    & * {\n      color: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .chat-header {\n    padding: vars.$padding-md;\n    background-color: $chat-header-background-color !important;\n    color: $text-messages-chat-dark-color !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid $chat-header-border-color !important;\n\n    &.dark {\n      background-color: $chat-header-dark-background-color !important;\n      border-bottom: 1px solid $chat-header-dark-border-color !important;\n    }\n  }\n\n  .chat-header-content {\n    display: flex;\n    align-items: center;\n    gap: vars.$padding-xs;\n  }\n\n  .chat-icon {\n    font-size: 20px;\n    color: $text-messages-chat-dark-color !important;\n    fill: $text-messages-chat-dark-color !important;\n    stroke: $text-messages-chat-dark-color !important;\n  }\n\n  .chat-title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: bold;\n    color: $text-messages-chat-dark-color !important;\n  }\n\n  .icon-button {\n    color: $text-messages-chat-dark-color !important;\n    padding: 4px;\n\n    &:hover {\n      background-color: $hover-light-background !important;\n    }\n\n    & svg {\n      color: $text-messages-chat-dark-color !important;\n      fill: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .content-copy-icon {\n    font-size: 18px;\n    color: $text-messages-chat-dark-color !important;\n    fill: $text-messages-chat-dark-color !important;\n    stroke: $text-messages-chat-dark-color !important;\n  }\n\n  .copy-success-message {\n    color: $text-messages-chat-dark-color !important;\n    font-size: 12px;\n  }\n\n  .tooltip {\n    z-index: 10000;\n\n    & .MuiTooltip-tooltip {\n      background-color: $tooltip-background;\n      color: $text-messages-chat-dark-color !important;\n      font-size: 12px;\n      padding: 6px 8px;\n      border-radius: 4px;\n      max-width: 200px;\n    }\n\n    & .MuiTooltip-arrow {\n      color: $tooltip-arrow-color;\n    }\n  }\n\n  .close-button {\n    color: $text-messages-chat-dark-color !important;\n    padding: 4px;\n\n    &:hover {\n      background-color: $hover-light-background !important;\n    }\n\n    & svg {\n      color: $text-messages-chat-dark-color !important;\n      fill: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .chat-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    background-color: $text-messages-chat-background-color !important;\n    color: $text-messages-chat-color !important;\n\n    &.dark {\n      background-color: $text-messages-chat-dark-background-color !important;\n      color: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .empty-messages {\n    text-align: center;\n    color: $text-messages-chat-color !important;\n    font-size: 14px;\n    margin-top: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n\n    &.dark {\n      color: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .empty-messages-icon {\n    font-size: 32px;\n    color: $text-messages-chat-color !important;\n\n    &.dark {\n      color: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .empty-messages-small-text {\n    font-size: 12px;\n    color: $text-messages-chat-color !important;\n\n    &.dark {\n      color: $text-messages-chat-dark-color !important;\n    }\n  }\n\n  .message-container {\n    display: flex;\n    flex-direction: column;\n    max-width: 80%;\n\n    &.own {\n      align-items: flex-end;\n      align-self: flex-end;\n    }\n\n    &.other {\n      align-items: flex-start;\n      align-self: flex-start;\n    }\n  }\n\n  .message-bubble {\n    color: $white-color !important;\n    padding: 10px 14px;\n    max-width: 100%;\n    word-wrap: break-word;\n    font-size: 14px;\n    line-height: 1.4;\n    box-shadow: 0 1px 2px $box-shadow-light;\n\n    &.own {\n      background-color: $primary-color !important;\n      border-radius: 18px 18px 4px 18px;\n    }\n\n    &.other {\n      background-color: $other-message-color !important;\n      border-radius: 18px 18px 18px 4px;\n    }\n  }\n\n  .message-metadata {\n    font-size: 11px;\n    color: $secondary-text-color !important;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &.dark {\n      color: $metadata-dark-color !important;\n    }\n  }\n\n  .chat-caption {\n    color: $secondary-text-color !important;\n    font-size: 11px;\n    margin-top: 4px;\n    display: block;\n\n    &.dark {\n      color: $dark-secondary-text-color !important;\n    }\n  }\n\n  .chat-input {\n    padding: 16px;\n    border-top: 1px solid $chat-input-border;\n    background-color: $chat-input-background !important;\n    padding-bottom: 24px;\n\n    @media (max-width: 768px) {\n      padding-bottom: 32px;\n    }\n\n    &.dark {\n      border-top: 1px solid $chat-input-dark-border;\n      background-color: $chat-input-dark-background !important;\n    }\n  }\n\n  .input-wrapper {\n    display: flex;\n    gap: 8px;\n    align-items: flex-end;\n  }\n\n  .chat-text-field {\n    & .MuiOutlinedInput-root {\n      border-radius: 20px;\n      font-size: 14px;\n      background-color: $outlined-input-light-background !important;\n      color: $outlined-input-light-color !important;\n\n      &.dark {\n        background-color: $outlined-input-dark-background !important;\n        color: $outlined-input-dark-color !important;\n      }\n\n      & fieldset {\n        border-color: $fieldset-light-border !important;\n\n        &.dark {\n          border-color: $fieldset-dark-border !important;\n        }\n      }\n\n      &:hover fieldset {\n        border-color: $fieldset-hover-light-border !important;\n\n        &.dark {\n          border-color: $fieldset-hover-dark-border !important;\n        }\n      }\n\n      &.Mui-focused fieldset {\n        border-color: $fieldset-focused-border !important;\n      }\n    }\n\n    & .MuiOutlinedInput-input {\n      padding: 10px 16px;\n      color: $outlined-input-light-color !important;\n\n      &.dark {\n        color: $outlined-input-dark-color !important;\n      }\n\n      &::placeholder {\n        color: $placeholder-light-color !important;\n        opacity: 1 !important;\n\n        &.dark {\n          color: $placeholder-dark-color !important;\n        }\n      }\n    }\n  }\n\n  .send-button {\n    background-color: $primary-color !important;\n    color: $white-color !important;\n    margin-bottom: 2px;\n    padding: 8px;\n    border-radius: 50%;\n    min-width: 40px;\n    height: 40px;\n\n    &:hover {\n      background-color: $primary-hover-color !important;\n    }\n\n    &.disabled {\n      background-color: $disabled-color !important;\n\n      &:hover {\n        background-color: $disabled-hover-color !important;\n      }\n    }\n\n    &.dark {\n      background-color: $dark-primary-color !important;\n\n      &:hover {\n        background-color: $dark-primary-hover-color !important;\n      }\n    }\n  }\n\n  .send-icon {\n    font-size: 18px;\n    color: $white-color !important;\n  }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.*/\n\n@use \"../../variables\" as *;\n\n.appointment-widget {\n  &__appointment-text {\n    line-height: 1;\n    margin-bottom: $padding-xs;\n  }\n\n  &__progress-note-btn {\n    margin-top: $padding-sm;\n    margin-left: $padding-sm;\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n\n@use \"../../variables\" as *;\n\n.patient-hub-form {\n  &__title {\n    font-size: $text-lg;\n    font-weight: $font-bold;\n    margin-top: $padding-md;\n  }\n\n  &__no-info {\n    font-size: $text-base;\n    font-weight: $font-bold;\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n\n@use \"../../variables\" as *;\n\n.general-settings-form {\n    &__card-equal-height {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        min-height: 300px;\n        margin-top: 2%;\n\n        .MuiCardContent-root {\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            margin-top: 4%;\n        }\n    }\n\n    &__section-title {\n        margin-bottom: 40px !important;\n        font-weight: 500 !important;\n        font-size: 12.5px !important;\n        color: #6f6f6f !important;\n    }\n\n    &__currency-lock-container {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-top: 2%;\n        margin-left: 1%;\n    }\n\n    &__currency-chip {\n        height: 20px;\n        font-size: 10px;\n    }\n\n    &__helper-text-no-margin {\n        margin: 0;\n    }\n\n    &__module-section-container {\n        margin-top: 1.5%;\n        margin-bottom: 0.8%;\n    }\n\n    &__checkbox-container {\n        display: flex;\n        align-items: center;\n    }\n\n    &__actions-container {\n        margin-top: 1.5%;\n    }\n}\n\n.general-settings-modal {\n    &__title {\n        margin-left: 1.2% !important;\n        margin-top: 1.2% !important;\n        margin-bottom: 8px;\n    }\n\n    &__subtitle {\n        text-align: left;\n        margin-left: 1.2% !important;\n        color: #6f6f6f !important;\n        margin-bottom: -2% !important;\n    }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.*/\n\n@use \"../../variables\" as *;\n\n.document-viewer {\n  &__title {\n    font-size: $text-base !important;\n    font-weight: $font-bold !important;\n  }\n\n  &__folder-name {\n    font-size: $text-base !important;\n    font-weight: $font-bold !important;\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../../_variables\" as vars;\n\n.recycle-bin-modal {\n  &__paper {\n    background-color: #ffffff;\n    \n    &--dark {\n      background-color: #2d3748;\n    }\n  }\n\n  &__title {\n    padding-bottom: vars.$padding-xs;\n  }\n\n  &__content {\n    padding: vars.$padding-lg;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-md;\n    }\n  }\n\n  &__empty-message {\n    text-align: center;\n    padding-top: vars.$padding-xl;\n    padding-bottom: vars.$padding-xl;\n  }\n\n  &__actions {\n    padding: vars.$padding-md;\n    padding-top: 0;\n\n    @media (max-width: vars.$sm-media-querys) {\n      padding: vars.$padding-sm;\n      padding-top: 0;\n    }\n  }\n\n  &__action-button {\n    margin-right: vars.$padding-xs !important;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../variables\" as vars;\n\n// Progress Note Container\n.progress-note-container {\n  padding: vars.$padding-lg;\n}\n\n// Progress Note Autocomplete Styles\n.progress-note-autocomplete {\n  .MuiAutocomplete-root {\n    .MuiInputBase-root {\n      font-size: vars.$text-base !important;\n      padding: vars.$padding-xs vars.$padding-md !important;\n    }\n    \n    .MuiInputLabel-root {\n      font-size: vars.$text-base !important;\n      font-weight: vars.$font-medium;\n    }\n    \n    .MuiAutocomplete-option {\n      font-size: vars.$text-sm !important;\n      padding: vars.$padding-sm vars.$padding-md !important;\n      \n      &:hover {\n        background-color: rgba(0, 0, 0, 0.04);\n      }\n      \n      &[aria-selected=\"true\"] {\n        background-color: rgba(0, 0, 0, 0.08) !important;\n      }\n    }\n  }\n}\n\n// Progress Note Form Sections\n.progress-note-form-section {\n  margin-bottom: vars.$padding-lg;\n  padding: vars.$padding-md;\n  border-radius: 8px;\n  background-color: #f5f5f5;\n  \n  &__title {\n    font-size: vars.$text-lg !important;\n    font-weight: vars.$font-semibold !important;\n    margin-bottom: vars.$padding-md !important;\n  }\n  \n  &__content {\n    font-size: vars.$text-base !important;\n    line-height: 1.5;\n  }\n}\n\n// Progress Note Selection Grid\n.progress-note-grid {\n  .MuiGrid-item {\n    padding: vars.$padding-md;\n  }\n}\n\n// History Progress Note Styles\n.progress-note-history {\n  &__checkbox-container {\n    margin-top: vars.$padding-md;\n    margin-bottom: vars.$padding-md;\n  }\n  \n  &__checkbox-label {\n    font-size: vars.$text-sm !important;\n    font-weight: vars.$font-medium;\n  }\n}\n\n// Progress Note Select Options\n.progress-note-select-option {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  \n  &__date {\n    font-size: vars.$text-sm !important;\n    font-weight: vars.$font-semibold;\n    color: #333;\n  }\n  \n  &__reason {\n    font-size: vars.$text-xs !important;\n    color: #666;\n  }\n}\n\n// Patient Selection in Progress Note\n.progress-note-patient-select {\n  .MuiAutocomplete-root {\n    margin-bottom: vars.$padding-md;\n  }\n}\n\n// Appointment Selection in Progress Note\n.progress-note-appointment-select {\n  .MuiAutocomplete-root {\n    margin-bottom: vars.$padding-md;\n  }\n}\n\n// Previous Progress Note Selection\n.progress-note-previous-select {\n  .MuiAutocomplete-inputRoot {\n    padding: vars.$padding-sm vars.$padding-md !important;\n  }\n  \n  .MuiAutocomplete-option {\n    font-size: vars.$text-sm !important;\n    padding: vars.$padding-md !important;\n    border-bottom: 1px solid #e0e0e0;\n    \n    &:last-child {\n      border-bottom: none;\n    }\n  }\n}\n\n// Progress Note Content Layout\n.progress-note-content-layout {\n  display: flex;\n  gap: vars.$padding-lg;\n  \n  &__form {\n    flex: 1;\n  }\n  \n  &__history {\n    flex: 1;\n    position: sticky;\n    top: 0;\n    max-height: 100vh;\n    overflow-y: auto;\n    margin-right: vars.$padding-lg !important;\n    \n  }\n}\n\n// Responsive adjustments\n@media (max-width: 960px) {\n  .progress-note-content-layout {\n    flex-direction: column;\n    \n    &__history {\n      position: static;\n      max-height: none;\n    }\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n@use \"../../variables\" as vars;\n\n.billing-encounter {\n    &__stack {\n        background-color: #f4f4f4;\n        padding: vars.$padding-sm;\n        font-size: vars.$text-sm !important;\n        border-radius: vars.$border-radius-md;\n    }\n\n    &__text-table {\n        font-size: 0.775rem;\n    }\n\n    &__control-label {\n        margin-top: 10px;\n        font-size: 0.700rem;\n        margin: 10 auto;\n        display: flex;\n        padding-left: 0.3;\n    }\n}\n\n.css-knlq9b-MuiFormControlLabel-root .MuiFormControlLabel-label {\n    display: inline-block;\n    font-size: 0.775rem;\n    font-weight: 700;\n    color: #344767;\n    line-height: 1;\n    -webkit-transform: translateY(0.0625rem);\n    -moz-transform: translateY(0.0625rem);\n    -ms-transform: translateY(0.0625rem);\n    transform: translateY(0.0625rem);\n    margin-left: 0.25rem;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n@use \"../../variables\" as vars;\n\n.payment-form {\n    &__container {\n        display: flex;\n        flex-direction: row;\n        min-height: 60vh;\n        max-height: calc(95vh - 100px);\n        overflow: hidden;\n        gap: 0;\n\n        // Responsive: En móvil, columnas verticales\n        @media (max-width: vars.$md-media-querys) {\n            flex-direction: column;\n            max-height: none;\n        }\n    }\n\n    &__left-panel {\n        flex: 0 0 45%;\n        border-right: 1px solid vars.$color-gray-light;\n        overflow-y: auto;\n        padding: vars.$padding-lg;\n        background-color: vars.$color-gray-light;\n\n        @media (max-width: vars.$md-media-querys) {\n            flex: 1 1 auto;\n            border-right: none;\n            border-bottom: 2px solid #e0e0e0;\n            max-height: 50vh;\n            overflow-y: auto;\n        }\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding: vars.$padding-md;\n        }\n    }\n\n    &__right-panel {\n        flex: 0 0 55%;\n        overflow-y: auto;\n        padding: vars.$padding-lg;\n\n        @media (max-width: vars.$md-media-querys) {\n            flex: 1 1 auto;\n            max-height: none;\n        }\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding: vars.$padding-md;\n        }\n    }\n\n    &__billing-header {\n        margin-bottom: vars.$padding-md;\n        padding-bottom: vars.$padding-sm;\n        border-bottom: 2px solid #1976d2;\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-bottom: vars.$padding-sm;\n        }\n    }\n\n    &__billing-instructions {\n        margin-bottom: vars.$padding-md;\n        padding: vars.$padding-sm;\n        background-color: #e3f2fd;\n        border-radius: vars.$border-radius-md;\n        font-size: vars.$text-sm;\n        line-height: 1.5;\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-bottom: vars.$padding-sm;\n            font-size: vars.$text-xs;\n        }\n    }\n\n    &__select-all-btn {\n        margin-bottom: vars.$padding-md;\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-bottom: vars.$padding-sm;\n        }\n    }\n\n    &__table-container {\n        margin-bottom: vars.$padding-md;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        border-radius: vars.$border-radius-md;\n        overflow: hidden;\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-bottom: vars.$padding-sm;\n        }\n    }\n\n    &__table-row {\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        &:hover {\n            background-color: #f5f5f5;\n        }\n\n        &--selected {\n            background-color: #e3f2fd !important;\n\n            &:hover {\n                background-color: #bbdefb !important;\n            }\n        }\n    }\n\n    &__service-name {\n        font-weight: vars.$font-semibold;\n        font-size: vars.$text-sm;\n        margin-bottom: 4px;\n        line-height: 1.4;\n\n        @media (max-width: vars.$sm-media-querys) {\n            font-size: vars.$text-xs;\n        }\n    }\n\n    &__service-description {\n        font-size: vars.$text-xs;\n        color: #666;\n        line-height: 1.3;\n    }\n\n    &__price-info {\n        font-weight: vars.$font-semibold;\n        font-size: vars.$text-sm;\n\n        @media (max-width: vars.$sm-media-querys) {\n            font-size: vars.$text-xs;\n        }\n    }\n\n    &__discount-info {\n        font-size: vars.$text-xs;\n        color: #666;\n        font-style: italic;\n        line-height: 1.2;\n    }\n\n    &__summary {\n        margin-top: vars.$padding-md;\n        padding: vars.$padding-md;\n        background-color: vars.$color-white;\n        border-radius: vars.$border-radius-md;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        border-left: 4px solid #1976d2;\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-top: vars.$padding-sm;\n            padding: vars.$padding-sm;\n        }\n    }\n\n    &__summary-row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: vars.$padding-sm;\n\n        @media (max-width: vars.$sm-media-querys) {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: vars.$padding-xs;\n        }\n    }\n\n    &__summary-label {\n        font-weight: vars.$font-semibold;\n        font-size: vars.$text-sm;\n\n        @media (max-width: vars.$sm-media-querys) {\n            font-size: vars.$text-xs;\n        }\n    }\n\n    &__summary-total {\n        font-weight: vars.$font-bold;\n        font-size: vars.$text-xl;\n        color: #1976d2;\n\n        @media (max-width: vars.$sm-media-querys) {\n            font-size: vars.$text-lg;\n        }\n    }\n\n    &__empty-state {\n        text-align: center;\n        padding: vars.$padding-xl;\n        color: #999;\n        font-style: italic;\n    }\n}\n\n// Dialog container styles for PaymentForm modal\n.payment-form-dialog {\n    :global(.MuiDialog-paper) {\n        width: 99vw;\n        max-width: 2200px;\n        margin: 16px;\n        max-height: 95vh;\n\n        @media (max-width: vars.$md-media-querys) {\n            width: 100vw;\n            max-width: 100vw;\n            margin: 8px;\n        }\n    }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n\n@use \"../../variables\" as vars;\n\n.confirm-payment-form {\n    &__dialog {\n        .MuiDialog-paper {\n            border-radius: vars.$border-radius-lg;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n            min-width: 680px;\n            max-width: 775px;\n            width: 100%;\n        }\n    }\n\n    &__title {\n        padding: vars.$padding-lg vars.$padding-xl;\n        border-bottom: 2px solid #1976d2;\n\n        h5 {\n            font-weight: 600;\n            margin: 0;\n        }\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding: vars.$padding-md vars.$padding-lg;\n        }\n    }\n\n    &__header {\n        padding: vars.$padding-md 0;\n        border-bottom: 1px solid vars.$color-gray-light;\n        margin-bottom: vars.$padding-md;\n\n        &-title {\n            font-weight: 700;\n            color: #1976d2;\n            margin-bottom: vars.$padding-xs;\n        }\n\n        &-subtitle {\n            color: vars.$color-gray-dark;\n            font-weight: 500;\n        }\n    }\n\n    &__current-payment-input {\n        margin-top: -16px !important;\n\n        .MuiInputBase-input {\n            color: #2e7d32 !important;\n            font-weight: 600 !important;\n        }\n\n        .MuiInputLabel-root {\n            color: #2e7d32 !important;\n            font-weight: 600 !important;\n        }\n    }\n\n    .MuiInputBase-root {\n        width: 100% !important;\n        max-width: 600px !important;\n    }\n\n    max-width: 340px;\n    width: 100%;\n\n    &__content {\n        padding: vars.$padding-xl;\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding: vars.$padding-lg;\n        }\n    }\n\n    &__financial-summary {\n        margin-bottom: vars.$padding-md;\n        margin-top: 0;\n        border-radius: vars.$border-radius-md;\n        border: 1px solid vars.$color-gray-light;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n\n        .MuiBox-root {\n            padding: vars.$padding-md;\n        }\n\n        @media (max-width: vars.$sm-media-querys) {\n            margin-bottom: vars.$padding-md;\n        }\n    }\n\n    &__payment-details {\n        margin-top: vars.$padding-lg;\n        padding-left: 10%;\n        padding-bottom: 5%;\n        gap: vars.$padding-md;\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding-left: 0;\n            gap: vars.$padding-sm;\n        }\n    }\n\n    &__amount-to-charge,\n    &__received-amount,\n    &__change {\n        .MuiInputBase-root {\n            font-size: vars.$text-sm;\n            font-weight: 400;\n            max-width: 260px;\n            width: 100%;\n            margin-right: vars.$padding-md;\n        }\n    }\n\n    &__insufficient-warning {\n        padding: vars.$padding-md;\n        background-color: #ffebee;\n        border: 1px solid #ef5350;\n        border-radius: vars.$border-radius-md;\n        margin-top: vars.$padding-md;\n        display: flex;\n        align-items: center;\n        gap: vars.$padding-sm;\n\n        .MuiTypography-root {\n            font-weight: 500;\n            font-size: vars.$text-base;\n            margin-bottom: vars.$padding-md;\n            border-bottom: 2px solid #1976d2;\n            padding-bottom: vars.$padding-sm;\n        }\n    }\n\n    &__actions {\n        padding: vars.$padding-lg vars.$padding-xl;\n        border-top: 1px solid #e0e0e0;\n        display: flex;\n        justify-content: flex-end;\n        gap: vars.$padding-md;\n\n        @media (max-width: vars.$sm-media-querys) {\n            padding: vars.$padding-md vars.$padding-lg;\n            flex-direction: column-reverse;\n\n            button {\n                width: 100%;\n            }\n        }\n    }\n\n    &__confirm-button,\n    &__cancel-button {\n        transition: all 0.3s ease;\n\n        &:hover:not(:disabled) {\n            transform: translateY(-2px);\n        }\n\n        &:disabled {\n            background: #bdbdbd;\n            box-shadow: none;\n        }\n    }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../../variables\" as vars;\n\n.patient-hub-data-content {\n  &__header-row {\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: space-between !important;\n    align-items: stretch !important;\n  }\n\n  &__person-info {\n    width: 100%;\n    margin-bottom: 1rem;\n    #profile > div > div > div:first-child{\n      margin: 0 auto;\n    }\n  }\n\n  &__emergency-contact {\n    width: 100%;\n    .card-base{\n      min-width: auto;\n    }\n  }\n\n  @media (min-width: vars.$sm-media-querys) {\n    .patient-hub-data-content {\n      &__header-row {\n        flex-direction: row !important;\n      }\n\n      &__emergency-contact {\n        width: 20%;\n      }\n\n      &__person-info {\n        width: 80%;\n        margin-bottom: 0;\n        margin-right: 1rem;\n        #profile > div > div > div:first-child{\n          margin: initial;\n        }\n      }\n    }\n  }\n}\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR. */\n\n.docFormlogo\n{\n    width: 200px!important;\n    height: 200px!important;\n}\n.docFormErrorMessage\n{\n    color: red !important;\n    text-align: center;\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n// Videochat Renderer Component Styles\n.videochat-renderer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n\n  &--maximized {\n    border-radius: 0;\n  }\n\n  &--guest {\n    min-height: 100vh;\n    height: 100vh;\n\n    @media (max-width: 768px) {\n      min-height: 100vh;\n      height: 100vh;\n    }\n  }\n\n  &--minimized {\n    width: 100%;\n    height: 100%;\n    background-color: vars.$color-black;\n    border-radius: 8px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n// Window Header\n.videochat-header {\n  background-color: #343a40;\n  color: vars.$color-white;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 12px 12px 0 0;\n\n  &--maximized {\n    border-radius: 0;\n  }\n\n  &.videochat-header--dark {\n    background-color: #1a1a1a;\n    border-bottom-color: #444;\n  }\n\n  &__title-section {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  &__icon {\n    width: 24px;\n    height: 24px;\n    fill: vars.$color-white;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: vars.$color-white;\n  }\n\n  &__status {\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: vars.$color-white;\n\n    &--connected {\n      background-color: #4caf50;\n    }\n\n    &--default {\n      background-color: #757575;\n    }\n  }\n\n  &__controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n}\n\n.videochat-header-button {\n  color: vars.$color-white !important;\n  padding: 12px !important;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2) !important;\n  }\n\n  svg {\n    fill: vars.$color-white !important;\n    stroke: vars.$color-white !important;\n  }\n}\n\n// Guest Join URL Section\n.videochat-guest-link {\n  background-color: #f5f5f5;\n  padding: 8px 12px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #333;\n\n  &.videochat-guest-link--dark {\n    background-color: #333;\n    color: vars.$color-white;\n  }\n\n  &__label {\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n  }\n\n  &__content {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  &__url {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    max-width: 300px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__copy-button {\n    padding: 4px !important;\n    min-width: 28px !important;\n    height: 28px !important;\n    flex-shrink: 0;\n    color: #333 !important;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.1) !important;\n    }\n\n    &.videochat-guest-link__copy-button--dark {\n      color: vars.$color-white !important;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1) !important;\n      }\n\n      svg {\n        fill: vars.$color-white !important;\n      }\n    }\n\n    svg {\n      width: 16px;\n      height: 16px;\n      fill: #333;\n    }\n  }\n}\n\n// Main Layout\n.videochat-layout {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n}\n\n.videochat-video-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-width: 0;\n}\n\n// Main Video Container\n.videochat-main-video {\n  flex: 1;\n  position: relative;\n  background-color: #000 !important;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 8px;\n  min-height: 200px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &--no-controls {\n    margin-bottom: 0;\n  }\n\n  &--no-border {\n    border-radius: 0;\n  }\n\n  &--guest {\n    min-height: calc(100vh - 200px);\n    height: calc(100vh - 200px);\n\n    @media (max-width: 768px) {\n      min-height: calc(100vh - 150px);\n      height: calc(100vh - 150px);\n    }\n  }\n\n  button svg {\n    color: vars.$color-white !important;\n  }\n}\n\n.videochat-video-container {\n  width: 100%;\n  height: 100%;\n  min-height: 150px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  &--guest {\n    min-height: calc(100vh - 250px);\n    height: calc(100vh - 250px);\n\n    @media (max-width: 768px) {\n      min-height: calc(100vh - 200px);\n      height: calc(100vh - 200px);\n    }\n  }\n}\n\n// Video Overlays\n.videochat-participant-label {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: vars.$color-white !important;\n  padding: 8px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 5;\n\n  * {\n    color: vars.$color-white !important;\n  }\n\n  svg {\n    font-size: 16px !important;\n    color: vars.$color-white !important;\n  }\n\n  span {\n    color: vars.$color-white;\n  }\n}\n\n.videochat-participant-name {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: vars.$color-white !important;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n\n  * {\n    color: vars.$color-white !important;\n  }\n\n  span {\n    color: vars.$color-white;\n  }\n}\n\n.videochat-swap-button {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  color: vars.$color-white !important;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.7) !important;\n  }\n}\n\n.videochat-timer {\n  position: absolute;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n}\n\n// Waiting/Status Messages\n.videochat-status-message {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: vars.$color-white;\n  z-index: 2;\n\n  &__icon {\n    font-size: 48px !important;\n    margin-bottom: 16px;\n    color: vars.$color-white !important;\n  }\n\n  &__text {\n    font-size: 18px;\n    font-weight: 500;\n    margin-top: 8px;\n    color: vars.$color-white;\n  }\n}\n\n// Local Video (Picture-in-Picture)\n.videochat-local-video {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 200px;\n  height: 150px;\n  z-index: 10;\n}\n\n.videochat-local-video-paper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: #333;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.videochat-local-video-container {\n  width: 100%;\n  height: 100%;\n}\n\n.videochat-local-video-placeholder {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #9e9e9e;\n  text-align: center;\n\n  &__icon {\n    font-size: 32px !important;\n    margin-bottom: 4px;\n    color: #9e9e9e !important;\n  }\n\n  &__text {\n    font-size: 12px;\n    margin-top: 4px;\n  }\n}\n\n.videochat-local-video-label {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  right: 4px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: vars.$color-white;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  span {\n    color: vars.$color-white;\n  }\n}\n\n// Controls\n.videochat-controls {\n  padding: 16px !important;\n  background-color: #424242 !important;\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  border-radius: 0 0 8px 8px;\n  flex-wrap: wrap;\n\n  @media (max-width: 768px) {\n    padding: 12px !important;\n    gap: 12px;\n    position: sticky;\n    bottom: 0;\n    z-index: 100;\n  }\n\n  &--no-border {\n    border-radius: 0;\n  }\n\n  button svg {\n    color: vars.$color-white !important;\n  }\n}\n\n.videochat-control-button {\n  color: vars.$color-white !important;\n\n  &.videochat-control-button--enabled {\n    background-color: #9e9e9e !important;\n\n    &:hover {\n      background-color: #757575 !important;\n    }\n  }\n\n  &.videochat-control-button--enabled-dark {\n    background-color: #616161 !important;\n\n    &:hover {\n      background-color: #424242 !important;\n    }\n  }\n\n  &.videochat-control-button--disabled {\n    background-color: #d32f2f !important;\n\n    &:hover {\n      background-color: #c62828 !important;\n    }\n  }\n\n  &.videochat-control-button--success {\n    background-color: #388e3c !important;\n\n    &:hover {\n      background-color: #2e7d32 !important;\n    }\n  }\n}\n\n.videochat-chat-toggle {\n  position: relative;\n  background-color: #9e9e9e !important;\n  color: vars.$color-white !important;\n\n  &:hover {\n    background-color: #757575 !important;\n  }\n\n  &.videochat-chat-toggle--dark {\n    background-color: #616161 !important;\n\n    &:hover {\n      background-color: #424242 !important;\n    }\n  }\n}\n\n.videochat-unread-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background-color: #f44336 !important;\n  color: vars.$color-white !important;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n// Chat Panel\n.videochat-chat-panel {\n  width: 350px;\n  background-color: vars.$color-white;\n  border-radius: 0 8px 8px 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  &.videochat-chat-panel--dark {\n    background-color: #1a1a1a;\n  }\n\n  &--no-border {\n    border-radius: 0;\n  }\n}\n\n// Minimized View\n.videochat-minimized-header {\n  padding: 8px 12px;\n  background-color: #343a40;\n  color: vars.$color-white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  min-height: 40px;\n\n  span {\n    color: vars.$color-white;\n  }\n}\n\n.videochat-minimized-restore-button {\n  color: vars.$color-white !important;\n  padding: 4px !important;\n  min-width: 24px !important;\n  height: 24px !important;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n  }\n\n  span {\n    color: vars.$color-white;\n    font-size: 16px;\n  }\n}\n\n.videochat-minimized-video {\n  flex: 1;\n  position: relative;\n  background-color: #333;\n  overflow: hidden;\n}\n\n.videochat-minimized-video-container {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.videochat-minimized-placeholder {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: vars.$color-white;\n  font-size: 24px;\n\n  &__icon {\n    margin-bottom: 8px;\n    font-size: 48px !important;\n    color: vars.$color-white !important;\n  }\n\n  &__text {\n    font-size: 12px;\n    margin-top: 8px;\n    color: vars.$color-white;\n  }\n}\n\n.videochat-minimized-label {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  right: 8px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: vars.$color-white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  span {\n    color: vars.$color-white;\n  }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n// Guest Videochat Page Specific Styles\n// Ensures the page fits in viewport and controls are always visible\n.guest-videochat-page {\n    height: 100vh;\n    max-height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n\n    // Override renderer styles for guest context\n    .videochat-renderer {\n        height: 100%;\n        max-height: 100%;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n    }\n\n    // Video section takes available space but leaves room for controls\n    .videochat-video-section {\n        flex: 1;\n        min-height: 0;\n        max-height: calc(100vh - 80px);\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n    }\n\n    // Main video container adapts to available space\n    .videochat-main-video {\n        flex: 1;\n        min-height: 0;\n        max-height: calc(100vh - 150px);\n        height: auto;\n        overflow: hidden;\n\n        @media (max-width: 768px) {\n            max-height: calc(100vh - 80px);\n        }\n    }\n\n    // Controls always visible at bottom, no overflow\n    .videochat-controls {\n        flex-shrink: 0;\n        position: relative;\n        bottom: auto;\n\n        @media (max-width: 768px) {\n            position: relative;\n            bottom: auto;\n        }\n    }\n\n    .videochat-chat-panel {\n        width: 350px;\n        max-width: 100vw;\n        min-height: 220px;\n        max-height: calc(100vh - 60px);\n        transition: width 0.2s, max-height 0.2s;\n        overflow: auto;\n\n        @media (max-width: 820px) {\n            max-height: calc(100vh - 24px);\n        }\n\n        @media (max-width: 600px) {\n            width: 100vw;\n            min-width: 0;\n            border-radius: 0 !important;\n            max-height: 60vh;\n        }\n\n        @media (max-width: 400px) {\n            width: 100vw;\n            min-width: 0;\n            border-radius: 0 !important;\n            max-height: 50vh;\n        }\n    }\n}","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.accounting-movements-grid {\n  align-items: stretch;\n\n  .grid-item-flex {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .grid-item-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    & > * {\n      height: 100%;\n    }\n  }\n\n  .buttons-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 1rem;\n\n    @media (min-width: 900px) {\n      gap: 2rem;\n    }\n  }\n}\n","/*Copyright (c) 2026 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2026 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2026 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2026 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n.feedback-floating {\n  // Floating Button\n  &__button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 3.25rem;\n    height: 3.25rem;\n    border-radius: 50%;\n    position: fixed;\n    right: 2rem;\n    bottom: 6rem;\n    z-index: 99;\n    cursor: pointer;\n  }\n\n  // Modal Container\n  &__modal {\n    border-radius: 8px;\n    overflow: hidden;\n    width: 100%;\n\n    &--light {\n      background-color: #ffffff !important;\n    }\n\n    &--dark {\n      background-color: #1e2e4a !important;\n    }\n  }\n\n  // Modal Header\n  &__header {\n    padding: 16px;\n\n    &--light {\n      border-bottom: 1px solid #e0e0e0;\n    }\n\n    &--dark {\n      border-bottom: 1px solid #1e2e4a;\n    }\n  }\n\n  // Modal Content\n  &__content {\n    padding: 16px;\n  }\n\n  // Form Control\n  &__form-control {\n    margin-bottom: 16px !important;\n    margin-top: 8px !important;\n  }\n\n  // Form Title\n  &__form-title {\n    margin-bottom: 16px !important;\n  }\n\n  // Radio Description\n  &__radio-description {\n    margin-left: 24px !important;\n  }\n\n  // Paste Hint\n  &__paste-hint {\n    margin-top: 4px !important;\n    display: block;\n  }\n\n  &__paste-icon {\n    font-size: 14px;\n    vertical-align: middle;\n    margin-right: 4px;\n  }\n\n  // Images Section\n  &__images-section {\n    margin-top: 16px;\n  }\n\n  &__images-title {\n    margin-bottom: 8px !important;\n  }\n\n  &__images-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  // Image Thumbnail\n  &__image-wrapper {\n    position: relative;\n    border: 1px solid;\n    border-color: rgba(0, 0, 0, 0.12);\n    border-radius: 4px;\n    overflow: visible;\n    width: 100px;\n    height: 100px;\n  }\n\n  &__image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 4px;\n  }\n\n  &__image-remove {\n    position: absolute !important;\n    top: -8px !important;\n    right: -8px !important;\n    background-color: rgba(0, 0, 0, 0.7) !important;\n    color: white !important;\n    padding: 4px !important;\n    min-width: unset !important;\n    width: 24px !important;\n    height: 24px !important;\n    border-radius: 50% !important;\n\n    &:hover {\n      background-color: rgba(211, 47, 47, 0.9) !important;\n    }\n  }\n\n  &__remove-icon {\n    font-size: 14px !important;\n  }\n\n  // Actions Footer\n  &__actions {\n    padding: 16px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n\n    &--light {\n      background-color: #ffffff !important;\n    }\n\n    &--dark {\n      background-color: #1e2e4a !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
